import { useAdminStaticQuery as useAdminStaticQuery$1, usePopupStaticQuery, useWidgetStaticQuery, buildSearchIndex, mergeSearchIndex, getBuiltSearchIndex } from 'gatsby-plugin-jaen';
import { PhotoView, PhotoProvider } from 'react-photo-view';
import * as runtime from 'react/jsx-runtime';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { useState, useEffect, useCallback, createContext, useContext, useMemo, useRef, forwardRef } from 'react';
import { sq, setTokenPair } from '@snek-functions/origin';
import { navigate, Link as Link$2 } from 'gatsby';
import { createSlice, combineReducers, configureStore } from '@reduxjs/toolkit';
import { useSelector, useDispatch, Provider } from 'react-redux';
import { v4 } from 'uuid';
import deepmerge from 'deepmerge';
import { Text, extendTheme, theme as theme$1, withDefaultColorScheme, toCSSVar, useToast, Modal, ModalOverlay, Box, ModalContent, ModalBody, Stack, Input, ModalFooter, Button, useDisclosure, createIcon, useBreakpointValue, IconButton, Badge, HStack, Icon, ModalHeader, ModalCloseButton, FormControl, FormLabel, FormHelperText, FormErrorMessage, useEventListener, Portal, Menu, MenuButton, MenuList, MenuItem, MenuDivider, Tooltip as Tooltip$1, Tag, ButtonGroup, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Flex, Spacer, Link as Link$1, Avatar, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogCloseButton, AlertDialogBody, VStack, Heading, Divider, AlertDialogFooter, Alert, AlertIcon, CloseButton, Checkbox, TagLabel, Textarea, Image as Image$1, Center, StackDivider, useColorModeValue, Circle, InputGroup, InputLeftElement, Wrap, WrapItem, SlideFade, AvatarGroup, Switch, AlertTitle, AlertDescription, CircularProgress, ChakraProvider } from '@chakra-ui/react';
import { ThemeProvider as ThemeProvider$1 } from '@emotion/react';
import { theme as theme$2 } from '@chakra-ui/pro-theme';
import 'react-photo-view/dist/react-photo-view.css';
import { IoHelpBuoySharp, IoOptions } from 'react-icons/io5';
import 'vanilla-cookieconsent';
import { DeleteIcon, EditIcon, AddIcon, ChevronUpIcon, ChevronDownIcon, ChevronRightIcon, HamburgerIcon, ChevronLeftIcon, SearchIcon } from '@chakra-ui/icons';
import { createRoot } from 'react-dom/client';
import { BiRocket, BiSave, BiNotification, BiNotificationOff } from 'react-icons/bi';
import { OSGBackend } from '@snek-at/snek-finder/dist/backends/OSGBackend';
import { useForm, Controller } from 'react-hook-form';
import { FaEye, FaSitemap, FaGithub, FaFileImport, FaSignOutAlt, FaBars, FaRocket, FaArrowUp, FaArrowDown, FaTrash, FaAlignLeft, FaAlignCenter, FaAlignRight, FaAlignJustify, FaBold, FaItalic, FaUnderline } from 'react-icons/fa';
import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';
import { HiDocument, HiLockClosed, HiMinus, HiPlus, HiCloudUpload } from 'react-icons/hi';
import { BsLaptop, BsTag, BsCloudUpload, BsEraser } from 'react-icons/bs';
import { AiOutlineUser } from 'react-icons/ai';
import { useSnekFinder } from '@snek-at/snek-finder';
import { HashRouter, useNavigate, Routes, Route, Outlet, Navigate, useLocation, Link as Link$3 } from 'react-router-dom';
import { GatsbyImage, getImage, getSrc } from 'gatsby-plugin-image';
import { statistics } from 'vfile-statistics';
import { evaluateSync } from '@mdx-js/mdx';
import { useDebounceFn } from 'ahooks';
import { frontmatterToMarkdown } from 'mdast-util-frontmatter';
import { gfmToMarkdown } from 'mdast-util-gfm';
import { VFileMessage } from 'vfile-message';
import { containerPhrasing } from 'mdast-util-to-markdown/lib/util/container-phrasing.js';
import { indentLines } from 'mdast-util-to-markdown/lib/util/indent-lines.js';
import { track } from 'mdast-util-to-markdown/lib/util/track.js';
import rehypeSlug from 'rehype-slug-custom-id';
import { directiveToMarkdown } from 'mdast-util-directive';
import remarkDirective from 'remark-directive';
import remarkFrontmatter from 'remark-frontmatter';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import { VFile } from 'vfile';
import { toMarkdown } from 'mdast-util-to-markdown';
import rehypeMdxCodeProps from 'rehype-mdx-code-props';
import { ErrorBoundary } from 'react-error-boundary';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { FiBox } from 'react-icons/fi';
import { useJaenPagePaths } from 'gatsby-plugin-jaen/hooks/useJaenPagePaths';
import { GiRuleBook } from 'react-icons/gi';
import DOMPurify from 'isomorphic-dompurify';
import { useDebouncedCallback } from 'use-debounce';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var snekResourceId = ___SNEK_RESOURCE_ID___;

function redirectAfterDelay(redirectTo, delay) {
  if (delay === void 0) {
    delay = 500;
  }
  if (redirectTo) {
    setTimeout(function () {
      void navigate(redirectTo, {
        state: {
          from: typeof window !== 'undefined' ? window.location.pathname : '/'
        }
      });
    }, delay);
  }
}

var onErrorResetAndRery = function onErrorResetAndRery(persistKey) {
  var middleware = function middleware() {
    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (e) {
          console.error('Error during action dispatching. Call Fn then retry', e);
          localStorage.removeItem(persistKey);
          next({
            type: 'RESET_STATE'
          });
          return next(action);
        }
      };
    };
  };
  return middleware;
};

var PersistState = (function (persistKey) {
  var loadState = function loadState() {
    try {
      var serialState = localStorage.getItem(persistKey);
      if (serialState === null) {
        return undefined;
      }
      return JSON.parse(serialState);
    } catch (err) {
      return undefined;
    }
  };
  var saveState = function saveState(state) {
    try {
      var removeLoadingAndError = function removeLoadingAndError(obj) {
        var keysToRemove = ['isLoading', 'error'];
        if (obj && typeof obj === 'object') {
          keysToRemove.forEach(function (key) {
            if (key in obj) {
              delete obj[key];
            }
          });
          Object.keys(obj).forEach(function (key) {
            removeLoadingAndError(obj[key]);
          });
        }
      };
      var cleanState = JSON.parse(JSON.stringify(state));
      removeLoadingAndError(cleanState);
      var serialState = JSON.stringify(cleanState);
      localStorage.setItem(persistKey, serialState);
    } catch (err) {
      console.error(err);
    }
  };
  var persistState = function persistState(store) {
    store.subscribe(function () {
      saveState(store.getState());
    });
    var resetState = function resetState(payload) {
      localStorage.removeItem(persistKey);
      store.dispatch({
        type: 'RESET_STATE',
        payload: payload
      });
    };
    return {
      resetState: resetState
    };
  };
  var persistMiddleware = [onErrorResetAndRery(persistKey)];
  return {
    loadState: loadState,
    saveState: saveState,
    persistState: persistState,
    persistMiddleware: persistMiddleware
  };
});

function deepRemoveAllUndefinedFromObject(obj) {
  Object.keys(obj).forEach(function (key) {
    if (obj[key] && typeof obj[key] === 'object') deepRemoveAllUndefinedFromObject(obj[key]);else if (obj[key] === undefined) delete obj[key];
  });
  return obj;
}

var deepmergeArrayIdMerge = function deepmergeArrayIdMerge(target, source, options) {
  if (target == null) {
    return source ? source.slice() : [];
  }
  if (source == null) {
    return target.slice();
  }
  var groups = ['id', 'fieldName'];
  var _loop = function _loop() {
    var group = _groups[_i];
    if (target.every(function (v) {
      return v == null ? void 0 : v[group];
    }) && source.every(function (v) {
      return v == null ? void 0 : v[group];
    })) {
      var mergeArrays = function mergeArrays(arr1, arr2, key) {
        if (arr1 === void 0) {
          arr1 = [];
        }
        if (arr2 === void 0) {
          arr2 = [];
        }
        if (key === void 0) {
          key = 'id';
        }
        var elements = [];
        var arr2Copy = arr2.slice();
        var _loop2 = function _loop2() {
          var element = _step.value;
          var el = arr2Copy.find(function (v) {
            return v && v[key] === element[key];
          });
          if (el) {
            elements.push(deepmerge(element, el, _extends({}, options || {}, {
              arrayMerge: deepmergeArrayIdMerge
            })));
            arr2Copy.splice(arr2Copy.indexOf(el), 1);
          } else {
            elements.push(element);
          }
        };
        for (var _iterator = _createForOfIteratorHelperLoose(arr1), _step; !(_step = _iterator()).done;) {
          _loop2();
        }
        elements.push.apply(elements, arr2Copy);
        return elements;
      };
      var merged = mergeArrays(target || [], source || [], group);
      return {
        v: merged
      };
    }
  };
  for (var _i = 0, _groups = groups; _i < _groups.length; _i++) {
    var _ret = _loop();
    if (typeof _ret === "object") return _ret.v;
  }
  var destination = target.slice();
  source.forEach(function (item, index) {
    if (typeof destination[index] === 'undefined') {
      destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else if (options.isMergeableObject(item)) {
      destination[index] = deepmerge(target[index], item, _extends({}, options || {}, {
        arrayMerge: deepmergeArrayIdMerge
      }));
    } else if (!target.includes(item)) {
      destination.push(item);
    }
  });
  return destination;
};

var updateItem = function updateItem(items, id, newData) {
  var index = items.findIndex(function (item) {
    return item.id === id;
  });
  if (index === -1) {
    items.push(_extends({
      id: id
    }, newData));
  } else {
    items[index] = deepmerge(items[index], newData, {
      arrayMerge: deepmergeArrayIdMerge
    });
  }
  return items;
};
var insertSectionIntoTree = function insertSectionIntoTree(sections, path, options) {
  var between = options == null ? void 0 : options.between;
  var sectionId = options == null ? void 0 : options.sectionId;
  var shouldDelete = options == null ? void 0 : options.shouldDelete;
  var blockData = (options == null ? void 0 : options.blockData) || {};
  var move = options == null ? void 0 : options.move;
  var head = path[0],
    tail = path.slice(1);
  if (sections.find(function (_ref) {
    var fieldName = _ref.fieldName;
    return head && fieldName === head.fieldName;
  }) == null) {
    if (head != null && head.fieldName) {
      sections.push({
        fieldName: head.fieldName,
        items: []
      });
    }
  }
  for (var _iterator = _createForOfIteratorHelperLoose(sections), _step; !(_step = _iterator()).done;) {
    var section = _step.value;
    if (section.fieldName === (head == null ? void 0 : head.fieldName)) {
      if (tail.length === 0) {
        if (sectionId && shouldDelete) {
          updateItem(section.items, sectionId, _extends({}, blockData, {
            deleted: true
          }));
          if (between) {
            var prev = between[0],
              next = between[1];
            if (prev && !next) {
              updateItem(section.items, prev, {
                ptrNext: null
              });
              section.ptrTail = prev;
            } else if (!prev && next) {
              updateItem(section.items, next, {
                ptrPrev: null
              });
              section.ptrHead = next;
            } else if (prev && next) {
              if (shouldDelete) {
                updateItem(section.items, prev, {
                  ptrNext: next
                });
                updateItem(section.items, next, {
                  ptrPrev: prev
                });
              } else {
                updateItem(section.items, prev, {
                  ptrNext: null
                });
                updateItem(section.items, next, {
                  ptrPrev: null
                });
              }
            } else {
              section.ptrHead = null;
              section.ptrTail = null;
            }
          }
        } else if (sectionId && move && between) {
          var _prev = between[0],
            _next = between[1];
          var direction = move.direction,
            ptrNew = move.ptrNew;
          if (direction === 'down') {
            if (ptrNew) {
              updateItem(section.items, ptrNew, {
                ptrPrev: sectionId
              });
            } else {
              section.ptrTail = sectionId;
            }
            if (_prev) {
              updateItem(section.items, _prev, {
                ptrNext: _next
              });
            } else {
              section.ptrHead = _next;
            }
            if (_next) {
              updateItem(section.items, _next, {
                ptrPrev: _prev,
                ptrNext: sectionId
              });
            } else {
              section.ptrTail = sectionId;
            }
            updateItem(section.items, sectionId, {
              ptrPrev: _next,
              ptrNext: ptrNew
            });
          } else if (direction === 'up') {
            if (ptrNew) {
              updateItem(section.items, ptrNew, {
                ptrNext: sectionId
              });
            } else {
              section.ptrHead = sectionId;
            }
            if (_prev) {
              updateItem(section.items, _prev, {
                ptrNext: _next,
                ptrPrev: sectionId
              });
            } else {
              section.ptrHead = sectionId;
            }
            if (_next) {
              updateItem(section.items, _next, {
                ptrPrev: _prev
              });
            } else {
              section.ptrTail = _prev;
            }
            updateItem(section.items, sectionId, {
              ptrPrev: ptrNew,
              ptrNext: _prev
            });
          }
        } else {
          var genSectionId = sectionId || "JaenSection " + v4();
          if (between && blockData.type) {
            var _prev2 = between[0],
              _next2 = between[1];
            if (!_prev2 && !_next2) {
              section.items.push(_extends({
                id: genSectionId,
                jaenFields: null,
                jaenFiles: [],
                ptrNext: null,
                ptrPrev: null,
                sections: [],
                type: blockData.type
              }, blockData));
              section.ptrHead = genSectionId;
              section.ptrTail = genSectionId;
            } else if (_prev2 && !_next2) {
              section.items.push(_extends({
                id: genSectionId,
                jaenFields: null,
                jaenFiles: [],
                ptrNext: null,
                ptrPrev: _prev2,
                sections: [],
                type: blockData.type
              }, blockData));
              updateItem(section.items, _prev2, {
                ptrNext: genSectionId
              });
              section.ptrTail = genSectionId;
            } else if (!_prev2 && _next2) {
              section.items.push(_extends({
                id: genSectionId,
                jaenFields: null,
                jaenFiles: [],
                ptrNext: _next2,
                ptrPrev: null,
                sections: [],
                type: blockData.type
              }, blockData));
              updateItem(section.items, _next2, {
                ptrPrev: genSectionId
              });
              section.ptrHead = genSectionId;
            } else if (_prev2 && _next2) {
              section.items.push(_extends({
                id: genSectionId,
                jaenFields: null,
                jaenFiles: [],
                ptrNext: _next2,
                ptrPrev: _prev2,
                sections: [],
                type: blockData.type
              }, blockData));
              updateItem(section.items, _prev2, {
                ptrNext: genSectionId
              });
              updateItem(section.items, _next2, {
                ptrPrev: genSectionId
              });
            }
          } else {
            updateItem(section.items, genSectionId, _extends({}, blockData, {
              id: genSectionId
            }));
          }
        }
        return section;
      }
      var item = section.items.find(function (_ref2) {
        var _tail$;
        var id = _ref2.id;
        return id === ((_tail$ = tail[0]) == null ? void 0 : _tail$.sectionId);
      });
      if (item == null) {
        var _tail$2;
        item = {
          id: (_tail$2 = tail[0]) == null ? void 0 : _tail$2.sectionId
        };
        section.items.push(item);
      }
      item.sections = item.sections || [];
      return insertSectionIntoTree(item.sections, tail, options);
    }
  }
  return null;
};
var findSection = function findSection(sections, path, i) {
  var head = path[0],
    tail = path.slice(1);
  for (var _iterator2 = _createForOfIteratorHelperLoose(sections), _step2; !(_step2 = _iterator2()).done;) {
    var section = _step2.value;
    if (section.fieldName === (head == null ? void 0 : head.fieldName)) {
      if (tail.length === 0) {
        return section;
      }
      for (var _iterator3 = _createForOfIteratorHelperLoose(section.items), _step3; !(_step3 = _iterator3()).done;) {
        var _tail$3;
        var item = _step3.value;
        if (item.id === (tail == null ? void 0 : (_tail$3 = tail[0]) == null ? void 0 : _tail$3.sectionId)) {
          if (item.sections) {
            return findSection(item.sections, tail);
          }
        }
      }
    }
  }
  return null;
};

var generatePageOriginPath = function generatePageOriginPath(allNodes, node, path) {
  var _node$parent;
  if (path === void 0) {
    path = node.id === 'JaenPage /' ? '/' : "/" + node.slug;
  }
  var parentId = (_node$parent = node.parent) == null ? void 0 : _node$parent.id;
  var parent = allNodes.find(function (n) {
    return n.id === parentId;
  });
  if (parent) {
    return generatePageOriginPath(allNodes, parent, parent.slug ? "/" + parent.slug + path : path);
  }
  var normalizedPath = path.endsWith('/') ? path : path + "/";
  return normalizedPath;
};
var generatePagePaths = function generatePagePaths(allNodes, pageId) {
  var originNode = allNodes.find(function (node) {
    return node.id === pageId;
  });
  if (originNode) {
    var paths = {};
    var originPath = generatePageOriginPath(allNodes, originNode);
    var lookupPath = function lookupPath(node, pathPrefix) {
      if (pathPrefix === void 0) {
        pathPrefix = '/';
      }
      paths[pathPrefix] = node.id;
      if (node.children.length > 0) {
        var _loop = function _loop() {
          var id = _step.value.id;
          var child = allNodes.find(function (n) {
            return n.id === id;
          });
          if (child) {
            lookupPath(child, pathPrefix !== '/' ? pathPrefix + "/" + child.slug : "/" + child.slug);
          }
        };
        for (var _iterator = _createForOfIteratorHelperLoose(node.children), _step; !(_step = _iterator()).done;) {
          _loop();
        }
      }
    };
    lookupPath(originNode, originPath);
    return paths;
  } else {
    throw new Error('Could not generate paths for page with id: ' + pageId);
  }
};
var generateAllPaths = function generateAllPaths(allNodes) {
  var paths = {};
  for (var _iterator2 = _createForOfIteratorHelperLoose(allNodes), _step2; !(_step2 = _iterator2()).done;) {
    var node = _step2.value;
    var path = generatePageOriginPath(allNodes, node);
    if (path) {
      paths[path] = node.id;
    }
  }
  return paths;
};
var matchPath = function matchPath(path1, path2) {
  var p1 = path1.replace(/\/$/, '');
  var p2 = path2.replace(/\/$/, '');
  return p1 === p2;
};

var pageInitialState = {
  pages: {
    lastAddedNodeId: undefined,
    registeredPageFields: {},
    nodes: {}
  },
  routing: {
    dynamicPaths: {}
  }
};
var pagesSlice = createSlice({
  name: 'pages',
  initialState: pageInitialState.pages,
  reducers: {
    page_updateOrCreate: function page_updateOrCreate(state, action) {
      var _action$payload = action.payload,
        id = _action$payload.id,
        slug = _action$payload.slug,
        jaenFields = _action$payload.jaenFields,
        jaenPageMetadata = _action$payload.jaenPageMetadata,
        parent = _action$payload.parent,
        children = _action$payload.children,
        template = _action$payload.template,
        excludedFromIndex = _action$payload.excludedFromIndex,
        fromId = _action$payload.fromId;
      var parentId = (parent == null ? void 0 : parent.id) || null;
      if (id) {
        var _state$nodes$id;
        var toBeAddedData = _extends({
          id: id
        }, slug && {
          slug: slug
        }, jaenFields !== undefined && {
          jaenFields: jaenFields
        }, {
          jaenPageMetadata: jaenPageMetadata
        }, parent !== undefined && {
          parent: parent
        }, children && {
          children: children
        }, excludedFromIndex !== undefined && {
          excludedFromIndex: excludedFromIndex
        });
        toBeAddedData = deepRemoveAllUndefinedFromObject(toBeAddedData);
        state.nodes[id] = _extends({}, state.nodes[id], toBeAddedData, {
          jaenPageMetadata: _extends({}, (_state$nodes$id = state.nodes[id]) == null ? void 0 : _state$nodes$id.jaenPageMetadata, jaenPageMetadata)
        });
        if (fromId && (parentId || parentId === null)) {
          var _state$nodes$fromId;
          var newChildren = [].concat((((_state$nodes$fromId = state.nodes[fromId]) == null ? void 0 : _state$nodes$fromId.children) || []).filter(function (e) {
            return e.id !== id;
          }), [{
            id: id,
            deleted: true
          }]);
          state.nodes[fromId] = _extends({}, state.nodes[fromId], {
            children: newChildren
          });
        }
      } else {
        if (fromId) {
          throw new Error("Cannot move a page that is being created.");
        }
        id = "JaenPage " + v4();
        state.nodes[id] = {
          slug: slug,
          jaenFields: jaenFields || null,
          jaenPageMetadata: jaenPageMetadata || {
            title: 'New Page'
          },
          parent: parent || null,
          children: children || [],
          template: template,
          excludedFromIndex: excludedFromIndex
        };
        state.lastAddedNodeId = id;
      }
      if (parentId) {
        var _state$nodes$parentId, _state$nodes$parentId2;
        state.nodes[parentId] = _extends({}, state.nodes[parentId], {
          children: (_state$nodes$parentId = state.nodes[parentId]) != null && _state$nodes$parentId.children ? [].concat(((_state$nodes$parentId2 = state.nodes[parentId]) == null ? void 0 : _state$nodes$parentId2.children) || [], [{
            id: id
          }]) : [{
            id: id
          }]
        });
      }
      return state;
    },
    page_markForDeletion: function page_markForDeletion(state, action) {
      var _state$nodes$id2;
      var id = action.payload;
      state.nodes[id] = _extends({}, state.nodes[id], {
        deleted: true,
        children: ((_state$nodes$id2 = state.nodes[id]) == null ? void 0 : _state$nodes$id2.children) || []
      });
      return state;
    },
    section_add: function section_add(state, action) {
      var _state$nodes$pageId;
      var _action$payload2 = action.payload,
        pageId = _action$payload2.pageId,
        path = _action$payload2.path,
        sectionItemType = _action$payload2.sectionItemType,
        between = _action$payload2.between;
      state.nodes[pageId] = _extends({}, state.nodes[pageId], {
        children: ((_state$nodes$pageId = state.nodes[pageId]) == null ? void 0 : _state$nodes$pageId.children) || []
      });
      var page = state.nodes[pageId];
      var sections = page.sections || [];
      insertSectionIntoTree(sections, path, {
        between: between,
        blockData: {
          type: sectionItemType
        }
      });
      page.sections = sections;
      return state;
    },
    section_remove: function section_remove(state, action) {
      var _state$nodes$pageId2;
      var _action$payload3 = action.payload,
        pageId = _action$payload3.pageId,
        path = _action$payload3.path,
        sectionId = _action$payload3.sectionId,
        between = _action$payload3.between;
      state.nodes[pageId] = _extends({}, state.nodes[pageId], {
        children: ((_state$nodes$pageId2 = state.nodes[pageId]) == null ? void 0 : _state$nodes$pageId2.children) || []
      });
      var page = state.nodes[pageId];
      var sections = page.sections || [];
      insertSectionIntoTree(sections, path, {
        between: between,
        sectionId: sectionId,
        shouldDelete: true
      });
      page.sections = sections;
      return state;
    },
    section_move: function section_move(state, action) {
      var _state$nodes$pageId3;
      var _action$payload4 = action.payload,
        pageId = _action$payload4.pageId,
        path = _action$payload4.path,
        sectionId = _action$payload4.sectionId,
        between = _action$payload4.between,
        move = _action$payload4.move;
      state.nodes[pageId] = _extends({}, state.nodes[pageId], {
        children: ((_state$nodes$pageId3 = state.nodes[pageId]) == null ? void 0 : _state$nodes$pageId3.children) || []
      });
      var page = state.nodes[pageId];
      var sections = page.sections || [];
      insertSectionIntoTree(sections, path, {
        between: between,
        sectionId: sectionId,
        move: move
      });
      page.sections = sections;
      return state;
    },
    section_register: function section_register(state, action) {
      var _state$nodes$pageId4;
      var _action$payload5 = action.payload,
        pageId = _action$payload5.pageId,
        path = _action$payload5.path,
        props = _action$payload5.props;
      state.nodes[pageId] = _extends({}, state.nodes[pageId], {
        children: ((_state$nodes$pageId4 = state.nodes[pageId]) == null ? void 0 : _state$nodes$pageId4.children) || []
      });
      var page = state.nodes[pageId];
      var sections = page.sections || [];
      var section = findSection(sections, path);
      if (section) {
        section.props = props;
      }
      page.sections = sections;
      return state;
    },
    page_unregisterFields: function page_unregisterFields(state, action) {
      var _extends2;
      var pageId = action.payload.pageId;
      state.registeredPageFields = _extends({}, state.registeredPageFields, (_extends2 = {}, _extends2[pageId] = 0, _extends2));
    },
    field_register: function field_register(state, action) {
      var _state$nodes$pageId5, _state$nodes$pageId6;
      var _action$payload6 = action.payload,
        pageId = _action$payload6.pageId,
        section = _action$payload6.section,
        fieldType = _action$payload6.fieldType,
        fieldName = _action$payload6.fieldName,
        props = _action$payload6.props;
      state.nodes[pageId] = _extends({}, state.nodes[pageId], {
        children: ((_state$nodes$pageId5 = state.nodes[pageId]) == null ? void 0 : _state$nodes$pageId5.children) || [],
        sections: ((_state$nodes$pageId6 = state.nodes[pageId]) == null ? void 0 : _state$nodes$pageId6.sections) || []
      });
      var page = state.nodes[pageId];
      if (section) {
        var _fieldType, _jaenFields;
        var sections = page.sections || [];
        insertSectionIntoTree(sections, section.path, {
          sectionId: section.id,
          blockData: {
            jaenFields: (_jaenFields = {}, _jaenFields[fieldType] = (_fieldType = {}, _fieldType[fieldName] = {
              position: undefined,
              props: props
            }, _fieldType), _jaenFields)
          }
        });
      } else {
        var _page$jaenFields$fiel, _extends3;
        page.jaenFields = page.jaenFields || {};
        page.jaenFields[fieldType] = _extends({}, page.jaenFields[fieldType], (_extends3 = {}, _extends3[fieldName] = _extends({}, (_page$jaenFields$fiel = page.jaenFields[fieldType]) == null ? void 0 : _page$jaenFields$fiel[fieldName], {
          position: undefined,
          props: props
        }), _extends3));
      }
    },
    field_write: function field_write(state, action) {
      var _state$nodes$pageId7;
      var _action$payload7 = action.payload,
        pageId = _action$payload7.pageId,
        section = _action$payload7.section,
        fieldType = _action$payload7.fieldType,
        fieldName = _action$payload7.fieldName,
        value = _action$payload7.value,
        props = _action$payload7.props;
      state.nodes[pageId] = _extends({}, state.nodes[pageId], {
        children: ((_state$nodes$pageId7 = state.nodes[pageId]) == null ? void 0 : _state$nodes$pageId7.children) || []
      });
      var page = state.nodes[pageId];
      if (section) {
        var _fieldType2, _jaenFields2;
        page.sections = page.sections || [];
        insertSectionIntoTree(page.sections, section.path, {
          sectionId: section.id,
          blockData: {
            jaenFields: (_jaenFields2 = {}, _jaenFields2[fieldType] = (_fieldType2 = {}, _fieldType2[fieldName] = {
              value: value,
              props: props
            }, _fieldType2), _jaenFields2)
          }
        });
      } else {
        var _page$jaenFields$fiel2, _extends4;
        page.jaenFields = page.jaenFields || {};
        page.jaenFields[fieldType] = _extends({}, page.jaenFields[fieldType], (_extends4 = {}, _extends4[fieldName] = _extends({}, (_page$jaenFields$fiel2 = page.jaenFields[fieldType]) == null ? void 0 : _page$jaenFields$fiel2[fieldName], {
          value: value,
          props: props
        }), _extends4));
      }
      return state;
    },
    discardAllChanges: function discardAllChanges(state) {
      state.registeredPageFields = {};
      state.nodes = {};
      state.lastAddedNodeId = undefined;
      return state;
    },
    discardChanges: function discardChanges(state, action) {
      var pageId = action.payload.pageId;
      delete state.nodes[pageId];
      if (state.lastAddedNodeId === pageId) {
        state.lastAddedNodeId = undefined;
      }
      return state;
    }
  }
});
var routingSlice = createSlice({
  name: 'routing',
  initialState: pageInitialState.routing,
  reducers: {
    updateDynamicPaths: function updateDynamicPaths(state, action) {
      var _action$payload8 = action.payload,
        jaenPageTree = _action$payload8.jaenPageTree,
        pageId = _action$payload8.pageId,
        create = _action$payload8.create;
      var dynamicIds = Object.fromEntries(Object.entries(state.dynamicPaths).map(function (_ref) {
        var k = _ref[0],
          v = _ref[1];
        return [v.pageId, k];
      }));
      var node = jaenPageTree.find(function (node) {
        return node.id === pageId;
      });
      var paths = generatePagePaths(jaenPageTree, pageId);
      for (var path in paths) {
        var _pageId = paths[path];
        if (_pageId) {
          if (_pageId in dynamicIds) {
            var oldPath = dynamicIds[_pageId];
            if (oldPath) {
              delete state.dynamicPaths[oldPath];
            }
          }
          if (create && node != null && node.template) {
            state.dynamicPaths[path] = {
              pageId: _pageId,
              templateName: node.template
            };
          }
        }
      }
    },
    discardDynamicPaths: function discardDynamicPaths(state) {
      state.dynamicPaths = {};
    }
  }
});
var actions = _extends({}, pagesSlice.actions, routingSlice.actions);
var reducers = {
  pages: pagesSlice.reducer,
  routing: routingSlice.reducer
};
var page = combineReducers(reducers);

var popupInitialState = {
  nodes: {},
  advanced: {}
};
var statusSlice$1 = createSlice({
  name: 'popup',
  initialState: popupInitialState,
  reducers: {
    setActive: function setActive(state, action) {
      state.nodes[action.payload] = _extends({}, state.nodes[action.payload], {
        active: true
      });
    },
    setInactive: function setInactive(state, action) {
      state.nodes[action.payload] = _extends({}, state.nodes[action.payload], {
        active: false
      });
    },
    field_write: function field_write(state, action) {
      var _state$nodes$popupId$, _state$nodes$popupId, _state$nodes$popupId$2, _state$nodes$popupId2, _state$nodes$popupId3, _extends2, _extends3;
      var _action$payload = action.payload,
        popupId = _action$payload.popupId,
        fieldType = _action$payload.fieldType,
        fieldName = _action$payload.fieldName,
        value = _action$payload.value;
      state.nodes[popupId] = _extends({}, state.nodes[popupId], {
        id: popupId,
        jaenFields: _extends({}, (_state$nodes$popupId$ = (_state$nodes$popupId = state.nodes[popupId]) == null ? void 0 : _state$nodes$popupId.jaenFields) != null ? _state$nodes$popupId$ : {}, (_extends3 = {}, _extends3[fieldType] = _extends({}, (_state$nodes$popupId$2 = (_state$nodes$popupId2 = state.nodes[popupId]) == null ? void 0 : (_state$nodes$popupId3 = _state$nodes$popupId2.jaenFields) == null ? void 0 : _state$nodes$popupId3[fieldType]) != null ? _state$nodes$popupId$2 : {}, (_extends2 = {}, _extends2[fieldName] = {
          value: value
        }, _extends2)), _extends3))
      });
    },
    increaseAdvancedPageViews: function increaseAdvancedPageViews(state, action) {
      var popupId = action.payload;
      if (!state.advanced[popupId]) {
        state.advanced[popupId] = {
          pageViews: 0
        };
      }
      state.advanced[popupId].pageViews++;
    }
  }
});
var _statusSlice$actions$1 = statusSlice$1.actions,
  setActive = _statusSlice$actions$1.setActive,
  setInactive = _statusSlice$actions$1.setInactive,
  field_write = _statusSlice$actions$1.field_write,
  increaseAdvancedPageViews = _statusSlice$actions$1.increaseAdvancedPageViews;
var popup = statusSlice$1.reducer;

var siteInitialState = {
  siteMetadata: {}
};
var siteSlice = createSlice({
  name: 'site',
  initialState: siteInitialState,
  reducers: {
    updateSiteMetadata: function updateSiteMetadata(state, action) {
      state.siteMetadata = _extends({}, state.siteMetadata, action.payload);
    }
  }
});
var updateSiteMetadata = siteSlice.actions.updateSiteMetadata;
var site = siteSlice.reducer;

var statusInitialState = {
  isEditing: false,
  isPublishing: false
};
var statusSlice = createSlice({
  name: 'status',
  initialState: statusInitialState,
  reducers: {
    setIsEditing: function setIsEditing(state, action) {
      state.isEditing = action.payload;
    },
    setIsPublishing: function setIsPublishing(state, action) {
      state.isPublishing = action.payload;
    }
  }
});
var _statusSlice$actions = statusSlice.actions,
  setIsEditing = _statusSlice$actions.setIsEditing;
var status = statusSlice.reducer;

var widgetInitialState = {
  nodes: []
};
var widgetsSlice = createSlice({
  name: 'widget',
  initialState: widgetInitialState,
  reducers: {
    writeData: function writeData(state, action) {
      var _action$payload = action.payload,
        widgetName = _action$payload.widgetName,
        data = _action$payload.data;
      var widget = state.nodes.find(function (w) {
        return w.name === widgetName;
      });
      if (widget) {
        widget.data = data;
      } else {
        state.nodes.push({
          name: widgetName,
          data: data
        });
      }
    }
  }
});
var writeData = widgetsSlice.actions.writeData;
var widget = widgetsSlice.reducer;

function useDeepEqualSelector(selector) {
  return useSelector(selector, function (l, r) {
    return JSON.stringify(l) === JSON.stringify(r);
  });
}

var persistKey = 'jaenjs-state';
var _PersistState = PersistState(persistKey),
  loadState = _PersistState.loadState,
  persistState = _PersistState.persistState,
  persistMiddleware = _PersistState.persistMiddleware;
var combinedReducer = combineReducers({
  site: site,
  page: page,
  status: status,
  popup: popup,
  widget: widget,
  finderUrl: function finderUrl(state) {
    if (state === void 0) {
      state = '';
    }
    return state;
  }
});
var rootReducer = function rootReducer(state, action) {
  if (action.type === 'RESET_STATE') {
    var payload = action.payload || {};
    console.log('payload', payload);
    return {
      finderUrl: payload.finderUrl,
      site: deepmerge(siteInitialState, payload.site || {}),
      page: deepmerge(pageInitialState, payload.page || {}),
      status: statusInitialState,
      popup: deepmerge(popupInitialState, payload.popup || {}),
      widget: deepmerge(widgetInitialState, payload.widget || {})
    };
  }
  return combinedReducer(state, action);
};
var persistedState = loadState();
var store = configureStore({
  reducer: rootReducer,
  middleware: function middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      thunk: {
        extraArgument: {}
      }
    }).concat([].concat(persistMiddleware));
  },
  devTools: true ,
  preloadedState: persistedState
});
var _persistState = persistState(store),
  resetState = _persistState.resetState;
var useAppDispatch = function useAppDispatch() {
  return useDispatch();
};
var useAppSelector = useSelector;
var useAppDeepEqualSelector = useDeepEqualSelector;
var withRedux = function withRedux(Component) {
  return function (props) {
    return jsx(Provider, {
      store: store,
      children: jsx(Component, _extends({}, props))
    });
  };
};

var useStatus = function useStatus() {
  var _useState = useState(false),
    isEditing = _useState[0],
    setIsEditing$1 = _useState[1];
  useEffect(function () {
    var state = store.getState();
    setIsEditing$1(state.status.isEditing);
    var unsubscribe = store.subscribe(function () {
      var state = store.getState();
      setIsEditing$1(state.status.isEditing);
    });
    return function () {
      unsubscribe();
    };
  }, []);
  var toggleIsEditing = useCallback(function () {
    var state = store.getState();
    var isCurrentlyEditing = state.status.isEditing;
    setIsEditing$1(!isCurrentlyEditing);
  }, []);
  var setEditing = useCallback(function (isEditing) {
    store.dispatch(setIsEditing(isEditing));
  }, []);
  return {
    isPublishing: true,
    isEditing: isEditing,
    toggleIsEditing: toggleIsEditing,
    setEditing: setEditing
  };
};

var AuthenticationContext = createContext({
  isAuthenticated: false,
  isDemo: false,
  isLoading: true,
  user: null,
  login: function () {
    return Promise.resolve();
  },
  logout: function () {
    return Promise.resolve();
  },
  demoLogin: function () {
    return Promise.resolve();
  },
  redirectToSSO: function () {
    return Promise.resolve();
  }
});
var useDemoLogin = function useDemoLogin() {
  var _useState = useState(false),
    isDemo = _useState[0],
    setIsDemo = _useState[1];
  useEffect(function () {
    var storedIsDemo = localStorage.getItem('isDemo');
    setIsDemo(storedIsDemo === 'true');
  }, []);
  useEffect(function () {
    localStorage.setItem('isDemo', isDemo ? 'true' : 'false');
  }, [isDemo]);
  return [isDemo, setIsDemo];
};
var useAuthenticated = function useAuthenticated() {
  var getIsAuthenticated = useCallback(function () {
    return localStorage.getItem('isAuthenticated') === 'true';
  }, []);
  var _useState2 = useState(false),
    isAuthenticated = _useState2[0],
    setIsAuthenticated = _useState2[1];
  useEffect(function () {
    setIsAuthenticated(getIsAuthenticated());
  }, []);
  useEffect(function () {
    localStorage.setItem('isAuthenticated', isAuthenticated ? 'true' : 'false');
  }, [isAuthenticated]);
  return [isAuthenticated, setIsAuthenticated];
};
var AuthenticationProvider = function AuthenticationProvider(props) {
  var _useAuthenticated = useAuthenticated(),
    isAuthenticated = _useAuthenticated[0],
    setIsAuthenticated = _useAuthenticated[1];
  var _useState3 = useState(null),
    user = _useState3[0],
    setUser = _useState3[1];
  var _useState4 = useState(isAuthenticated),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useDemoLogin = useDemoLogin(),
    isDemo = _useDemoLogin[0],
    setIsDemo = _useDemoLogin[1];
  var status = useStatus();
  var login = useCallback(function (login, password, logMeOutAfterwards) {
    try {
      return Promise.resolve(sq.mutate(function (m) {
        var signIn = m.userSignIn({
          login: login,
          password: password,
          resourceId: snekResourceId
        });
        var u = signIn.user;
        return {
          user: {
            username: u.username,
            primaryEmail: u.primaryEmailAddress,
            id: u.id
          },
          tokenPair: {
            accessToken: signIn.tokenPair.accessToken,
            refreshToken: signIn.tokenPair.refreshToken
          }
        };
      })).then(function (_ref) {
        var data = _ref[0],
          errors = _ref[1];
        var isSuccess = !!data && !errors;
        if (!isSuccess) {
          throw new Error('Login failed');
        }
        setTokenPair(data.tokenPair, logMeOutAfterwards);
        setUser(data.user);
        setIsAuthenticated(true);
        redirectAfterDelay('/admin');
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  var logout = useCallback(function () {
    try {
      if (isDemo) {
        setIsDemo(false);
      } else {
        setTokenPair(null);
      }
      setIsAuthenticated(false);
      status.setEditing(false);
      redirectAfterDelay('/admin/login?loggedOut=true');
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }, [isDemo]);
  var demoLogin = useCallback(function () {
    try {
      setIsDemo(true);
      setIsAuthenticated(true);
      redirectAfterDelay('/admin');
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  var bootstrap = useCallback(function () {
    try {
      return Promise.resolve(sq.query(function (q) {
        var user = q.userMe;
        return {
          id: user.id,
          primaryEmail: user.primaryEmailAddress,
          username: user.username
        };
      })).then(function (_ref2) {
        var me = _ref2[0],
          errors = _ref2[1];
        var isSuccess = !!me && !errors;
        setIsLoading(false);
        if (isSuccess) {
          setIsAuthenticated(true);
          setUser(me);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  useEffect(function () {
    if (isDemo) {
      setUser({
        id: 'demo',
        primaryEmail: 'snekman@snek.at',
        username: 'snekman'
      });
    } else {
      if (isAuthenticated) {
        void bootstrap();
      }
    }
  }, [isDemo, isAuthenticated]);
  var redirectToSSO = useCallback(function () {
    try {
      window.location.href = "https://access.snek.at?resourceId=" + snekResourceId;
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  useEffect(function () {
    var accessFromLocation = new URLSearchParams(window.location.search).get('access');
    if (accessFromLocation) {
      try {
        var access = JSON.parse(accessFromLocation);
        if (access.accessToken && access.refreshToken) {
          var tokenPair = {
            accessToken: access.accessToken,
            refreshToken: access.refreshToken
          };
          var isSession = access.isSession;
          setTokenPair(tokenPair, isSession);
          void bootstrap().then(function () {
            redirectAfterDelay('/admin', 0);
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, []);
  var children = useMemo(function () {
    return props.children;
  }, []);
  var value = useMemo(function () {
    return {
      isAuthenticated: isAuthenticated,
      isDemo: isDemo,
      isLoading: isLoading,
      user: user,
      login: login,
      logout: logout,
      demoLogin: demoLogin,
      redirectToSSO: redirectToSSO
    };
  }, [isAuthenticated, isDemo, isLoading, user, login, logout, demoLogin, redirectToSSO]);
  return jsx(AuthenticationContext.Provider, {
    value: value,
    children: children
  });
};
var useAuthentication = function useAuthentication() {
  return useContext(AuthenticationContext);
};

var PageContext = React__default.createContext(undefined);
var UnregisterFieldsHelper = withRedux(function () {
  var _usePageContext = usePageContext(),
    jaenPage = _usePageContext.jaenPage;
  var dispatch = useAppDispatch();
  React__default.useEffect(function () {
    dispatch(actions.page_unregisterFields({
      pageId: jaenPage.id
    }));
  }, [jaenPage.id]);
  return null;
});
var PageProvider = function PageProvider(_ref) {
  var children = _ref.children,
    jaenPage = _ref.jaenPage,
    jaenPages = _ref.jaenPages,
    _ref$unregisterFields = _ref.unregisterFields,
    unregisterFields = _ref$unregisterFields === void 0 ? true : _ref$unregisterFields;
  var _useAuthentication = useAuthentication(),
    isAuthenticated = _useAuthentication.isAuthenticated;
  return jsxs(PageContext.Provider, {
    value: {
      jaenPage: jaenPage,
      jaenPages: jaenPages
    },
    children: [unregisterFields && isAuthenticated && jsx(UnregisterFieldsHelper, {}), children]
  });
};
var usePageContext = function usePageContext() {
  var context = React__default.useContext(PageContext);
  if (context === undefined) {
    throw new Error('useJaenPageContext must be within PageContext');
  }
  return context;
};
var useJaenPageIndex = function useJaenPageIndex(props) {
  var _usePageContext2 = usePageContext(),
    jaenPage = _usePageContext2.jaenPage,
    jaenPages = _usePageContext2.jaenPages;
  var id = jaenPage.id;
  if (props != null && props.jaenPageId) {
    id = props == null ? void 0 : props.jaenPageId;
  } else if (props != null && props.path) {
    if (jaenPages == null) {
      throw new Error('Unable to resolve page by path. No pages provided.');
    }
    var resolveJaenPageIdByPath = function resolveJaenPageIdByPath(path, staticPages) {
      var _state$page$routing$d, _staticPages$find;
      var state = store.getState();
      var dynamicPageId = (_state$page$routing$d = state.page.routing.dynamicPaths[path]) == null ? void 0 : _state$page$routing$d.pageId;
      if (dynamicPageId) {
        return dynamicPageId;
      }
      return (_staticPages$find = staticPages.find(function (page) {
        return page.buildPath === path;
      })) == null ? void 0 : _staticPages$find.id;
    };
    var path = props == null ? void 0 : props.path;
    var newId = resolveJaenPageIdByPath(path, jaenPages);
    if (!newId) {
      throw new Error("Could not resolve page by path: " + path);
    }
    id = newId;
  }
  var staticChildren = useMemo(function () {
    var _jaenPages$find;
    var jaenPagesChildren = (jaenPages == null ? void 0 : (_jaenPages$find = jaenPages.find(function (page) {
      return page.id === id;
    })) == null ? void 0 : _jaenPages$find.children) || [];
    var children = [];
    if (jaenPage.id === id) {
      children = jaenPage.children || [];
    }
    var mergedChildren = [].concat(children, jaenPagesChildren);
    var uniqueChildren = mergedChildren.filter(function (child, index, self) {
      return index === self.findIndex(function (c) {
        return c.id === child.id;
      });
    });
    return uniqueChildren;
  }, [jaenPage, jaenPage.children, jaenPages, id]);
  var _React$useState = React__default.useState(function () {
      var _state$page$pages$nod;
      var state = store.getState();
      return (_state$page$pages$nod = state.page.pages.nodes[id]) == null ? void 0 : _state$page$pages$nod.children;
    }),
    dynamicChildrenIds = _React$useState[0],
    setDynamicChildrenIds = _React$useState[1];
  React__default.useEffect(function () {
    var unsubscribe = store.subscribe(function () {
      var state = store.getState();
      var page = state.page.pages.nodes[id];
      if (page) {
        var _page$children;
        var onlyNotDeleted = (_page$children = page.children) == null ? void 0 : _page$children.filter(function (c) {
          return !c.deleted;
        });
        setDynamicChildrenIds(onlyNotDeleted);
      }
    });
    return function () {
      unsubscribe();
    };
  }, [id]);
  var _React$useState2 = React__default.useState([]),
    dynamicChildren = _React$useState2[0],
    setDynamicChildren = _React$useState2[1];
  useEffect(function () {
    if (dynamicChildrenIds) {
      var state = store.getState();
      var dynamicJaenPages = state.page.pages.nodes;
      var ds = dynamicChildrenIds.map(function (_ref2) {
        var id = _ref2.id;
        return _extends({
          id: id
        }, dynamicJaenPages[id]);
      });
      setDynamicChildren(ds);
    }
  }, [dynamicChildrenIds]);
  var children = useMemo(function () {
    var mergedChildren = [].concat(staticChildren, dynamicChildren).filter(function (c) {
      return !c.excludedFromIndex && !c.deleted;
    });
    if (props) {
      var filter = props.filter,
        sort = props.sort;
      if (filter) {
        mergedChildren = mergedChildren.filter(filter);
      }
      if (sort) {
        mergedChildren = mergedChildren.sort(sort);
      }
    }
    return mergedChildren;
  }, [staticChildren, dynamicChildren, props]);
  return {
    children: children,
    withJaenPage: function withJaenPage(childId, children) {
      var jaenPage = staticChildren == null ? void 0 : staticChildren.find(function (c) {
        return c.id === childId;
      });
      return jsx(PageProvider, {
        jaenPage: _extends({}, jaenPage, {
          id: childId
        }),
        children: children
      }, childId);
    }
  };
};

var BlockContext = React.createContext(undefined);
var SectionBlockContext = React.createContext(undefined);
var JaenSectionBlockProvider = React.memo(function (_ref) {
  var path = _ref.path,
    id = _ref.id,
    position = _ref.position,
    Component = _ref.Component;
  var _usePageContext = usePageContext(),
    jaenPage = _usePageContext.jaenPage;
  var dispatch = useAppDispatch();
  var register = React.useCallback(function (props) {
    dispatch(actions.section_register({
      pageId: jaenPage.id,
      path: path,
      props: props
    }));
  }, [dispatch, jaenPage.id]);
  return jsx(SectionBlockContext.Provider, {
    value: {
      path: path,
      id: id,
      position: position,
      Component: Component,
      register: register
    },
    children: Component ? jsx(Component, {}) : jsx(Text, {
      children: jsxs(Fragment, {
        children: ["No block component found for section ", id, " at path ", path, ". Please contact the site administrator."]
      })
    })
  });
});
var useSectionBlockContext = function useSectionBlockContext() {
  var context = React.useContext(SectionBlockContext);
  return context;
};

var connectBlock = function connectBlock(Component, options) {
  var MyComp = function MyComp(props) {
    useSectionBlockContext();
    useAuthentication();
    useEffect(function () {
    }, []);
    return jsx(BlockContext.Provider, {
      value: options,
      children: jsx(Component, _extends({}, props))
    });
  };
  MyComp.options = options;
  return MyComp;
};

function useField(name, type, block) {
  var _usePageContext = usePageContext(),
    jaenPage = _usePageContext.jaenPage;
  if (!jaenPage.id) {
    throw new Error('JaenPage id is undefined! connectField must be used within a JaenPage');
  }
  var SectionBlockContext = useSectionBlockContext();
  function getPageField(page) {
    if (page) {
      var _fields, _fields$type;
      var fields;
      var path = (block == null ? void 0 : block.path) || (SectionBlockContext == null ? void 0 : SectionBlockContext.path);
      var blockId = (block == null ? void 0 : block.id) || (SectionBlockContext == null ? void 0 : SectionBlockContext.id);
      if (path) {
        var _findSection, _findSection$items$fi;
        fields = (_findSection = findSection(page.sections || [], path)) == null ? void 0 : (_findSection$items$fi = _findSection.items.find(function (_ref) {
          var id = _ref.id;
          return id === blockId;
        })) == null ? void 0 : _findSection$items$fi.jaenFields;
      } else {
        fields = page.jaenFields;
      }
      return (_fields = fields) == null ? void 0 : (_fields$type = _fields[type]) == null ? void 0 : _fields$type[name];
    }
    return undefined;
  }
  var getField = function getField() {
    var state = store.getState();
    var page = state.page.pages.nodes[jaenPage.id];
    if (page) {
      return getPageField(page);
    }
    return undefined;
  };
  var getStaticField = function getStaticField() {
    var page = jaenPage;
    if (page) {
      return getPageField(page);
    }
    return undefined;
  };
  var _React$useState = React__default.useState(getField),
    field = _React$useState[0],
    setField = _React$useState[1];
  React__default.useEffect(function () {
    var unsubscribe = store.subscribe(function () {
      var newField = getField();
      if (JSON.stringify(newField) !== JSON.stringify(field)) {
        setField(newField);
      }
    });
    return function () {
      unsubscribe();
    };
  }, [field, store]);
  var staticField = getStaticField();
  var _useStatus = useStatus(),
    isEditing = _useStatus.isEditing;
  var props = useMemo(function () {
    return (field == null ? void 0 : field.props) || (staticField == null ? void 0 : staticField.props) || {};
  }, [field, staticField]);
  var write = React__default.useCallback(function (newValue) {
    store.dispatch(actions.field_write({
      pageId: jaenPage.id,
      section: SectionBlockContext ? {
        path: SectionBlockContext.path,
        id: SectionBlockContext.id
      } : undefined,
      fieldType: type,
      fieldName: name,
      value: newValue,
      props: props
    }));
  }, [jaenPage.id, SectionBlockContext, type, name, field, store, props]);
  var register = React__default.useCallback(function (props) {
    store.dispatch(actions.field_register({
      pageId: jaenPage.id,
      fieldType: type,
      fieldName: name,
      section: SectionBlockContext ? {
        path: SectionBlockContext.path,
        id: SectionBlockContext.id
      } : undefined,
      props: props
    }));
  }, [jaenPage.id, SectionBlockContext, type, name]);
  return {
    value: field == null ? void 0 : field.value,
    staticValue: staticField == null ? void 0 : staticField.value,
    props: props,
    jaenPageId: jaenPage.id,
    isEditing: isEditing,
    SectionBlockContext: SectionBlockContext,
    write: write,
    register: register
  };
}

var CLASSNAMES = {
  JAEN_HIGHLIGHT: 'jaen-highlight',
  JAEN_HIGHLIGHT_FRAME: 'jaen-highlight-frame',
  JAEN_HIGHLIGHT_TOOLTIP: 'jaen-highlight-tooltip',
  JAEN_ADMIN_BODY: 'jaen-admin-body'
};
var FONT_FAMILY = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; ';

var _global;
var theme = extendTheme({
  colors: _extends({}, theme$1.colors, {
    brand: theme$1.colors.blue
  }),
  fonts: {
    body: FONT_FAMILY,
    heading: FONT_FAMILY,
    mono: FONT_FAMILY
  },
  fontSizes: _extends({}, theme$1.fontSizes),
  styles: {
    global: (_global = {}, _global["." + CLASSNAMES.JAEN_ADMIN_BODY] = {
      minH: 'calc(100vh - 7rem)'
    }, _global['div:has(div):has(.jaen-image-wrapper)'] = {
      isolation: 'isolate'
    }, _global["." + CLASSNAMES.JAEN_HIGHLIGHT_FRAME] = {
      borderRadius: '11px',
      pointerEvents: 'none'
    }, _global["." + CLASSNAMES.JAEN_HIGHLIGHT_FRAME + ":before"] = {
      content: '""',
      position: 'absolute',
      top: '-6px',
      right: ' -6px',
      bottom: '-6px',
      left: '-6px',
      border: ' 2px solid var(--chakra-colors-pink-100)',
      borderRadius: '15px',
      pointerEvents: 'none'
    }, _global["." + CLASSNAMES.JAEN_HIGHLIGHT_TOOLTIP] = {}, _global['html, body, #root, #___gatsby'] = {
      margin: 0,
      display: 'block',
      '&::-webkit-scrollbar': {
        width: '16px',
        height: '16px'
      },
      '&::-webkit-scrollbar-corner, &::-webkit-scrollbar-track': {
        background: 'rgb(240, 241, 244)'
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(105, 112, 125, 0.5)',
        backgroundClip: 'content-box',
        borderRadius: '16px',
        border: '4px solid rgb(240, 241, 244)'
      }
    }, _global)
  },
  components: {
    Link: {
      baseStyle: {
        color: 'blue.500',
        _hover: {
          color: 'blue.600',
          textDecoration: 'underline'
        },
        _active: {
          color: 'blue.700'
        }
      },
      variants: {
        white: {
          color: 'white',
          _hover: {
            color: 'gray.100',
            textDecoration: 'underline'
          },
          _active: {
            color: 'gray.200'
          }
        },
        black: {
          color: 'black',
          _hover: {
            color: 'gray.900',
            textDecoration: 'underline'
          },
          _active: {
            color: 'blue.700'
          }
        }
      }
    },
    Button: {
      variants: {
        darkGhost: {
          bg: 'gray.800',
          color: 'white',
          _hover: {
            bg: 'gray.700'
          },
          _active: {
            bg: 'gray.700'
          }
        },
        jaenHighlightTooltip: {
          bg: 'rgba(254, 215, 226, 0.9)',
          backdropBlur: 8,
          color: 'pink.900',
          _hover: {
            bg: 'pink.200'
          },
          borderRadius: '0.5em',
          fontWeight: 'normal',
          fontSize: 'xs',
          height: '6',
          minWidth: '6',
          px: '2'
        },
        jaenHighlightTooltipText: {
          bg: 'rgba(254, 215, 226, 0.9)',
          backdropBlur: 8,
          color: 'pink.900',
          borderRadius: 'full',
          fontWeight: 'normal',
          cursor: 'default',
          fontSize: 'xs',
          height: '6',
          minWidth: '6',
          px: '2',
          mr: '2'
        }
      }
    }
  },
  shadows: {
    outline: '0 0 0 3px var(--chakra-colors-pink-400)'
  }
}, withDefaultColorScheme({
  colorScheme: 'pink'
}), theme$2);

var _excluded$j = ["cssVarsRoot"];
function ThemeProvider(_ref) {
  var _ref$cssVarsRoot = _ref.cssVarsRoot,
    cssVarsRoot = _ref$cssVarsRoot === void 0 ? 'coco' : _ref$cssVarsRoot,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$j);
  var themeOverride = props.theme;
  var t = themeOverride || theme;
  var computedTheme = useMemo(function () {
    return toCSSVar(t);
  }, [t]);
  return jsx(ThemeProvider$1, {
    theme: computedTheme,
    children: React__default.Children.map(props.children, function (child) {
      if (!React__default.isValidElement(child)) {
        return child;
      }
      return React__default.cloneElement(child, {
        id: cssVarsRoot
      });
    })
  });
}

var ModalType;
(function (ModalType) {
  ModalType[ModalType["Alert"] = 0] = "Alert";
  ModalType[ModalType["Confirm"] = 1] = "Confirm";
  ModalType[ModalType["Prompt"] = 2] = "Prompt";
})(ModalType || (ModalType = {}));
var defaultContext = {
  alert: function alert() {
    throw new Error('<ModalProvider> is missing');
  },
  confirm: function confirm() {
    throw new Error('<ModalProvider> is missing');
  },
  prompt: function prompt() {
    throw new Error('<ModalProvider> is missing');
  },
  toast: {}
};
var Context = createContext(defaultContext);
var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;
  var toast = useToast({
    position: 'bottom',
    duration: 2000,
    isClosable: true,
    variant: 'subtle'
  });
  var _useState = useState(null),
    modal = _useState[0],
    setModal = _useState[1];
  var input = useRef(null);
  var ok = useRef(null);
  var createOpener = useCallback(function (type) {
    return function (message, defaultValue) {
      if (defaultValue === void 0) {
        defaultValue = '';
      }
      try {
        return Promise.resolve(new Promise(function (resolve) {
          var handleClose = function handleClose(e) {
            e == null ? void 0 : e.preventDefault();
            setModal(null);
            resolve(null);
          };
          var handleCancel = function handleCancel(e) {
            e == null ? void 0 : e.preventDefault();
            setModal(null);
            if (type === ModalType.Prompt) resolve(null);else resolve(false);
          };
          var handleOK = function handleOK(e) {
            var _input$current;
            e == null ? void 0 : e.preventDefault();
            setModal(null);
            if (type === ModalType.Prompt) resolve((_input$current = input.current) == null ? void 0 : _input$current.value);else resolve(true);
          };
          setModal(jsxs(Modal, {
            isOpen: true,
            onClose: handleClose,
            initialFocusRef: type === ModalType.Prompt ? input : ok,
            children: [jsx(ModalOverlay, {}), jsx(ThemeProvider, {
              children: jsx(Box, {
                children: jsxs(ModalContent, {
                  children: [jsx(ModalBody, {
                    mt: 5,
                    children: jsxs(Stack, {
                      spacing: 5,
                      children: [jsxs(Text, {
                        children: [" ", message]
                      }), type === ModalType.Prompt && jsx(Input, {
                        ref: input,
                        defaultValue: defaultValue
                      })]
                    })
                  }), jsxs(ModalFooter, {
                    children: [type !== ModalType.Alert && jsx(Button, {
                      mr: 3,
                      variant: "ghost",
                      onClick: handleCancel,
                      children: "Cancel"
                    }), jsx(Button, {
                      onClick: handleOK,
                      ref: ok,
                      children: "OK"
                    })]
                  })]
                })
              })
            })]
          }));
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };
  }, [children]);
  return jsxs(Context.Provider, {
    value: {
      alert: createOpener(ModalType.Alert),
      confirm: createOpener(ModalType.Confirm),
      prompt: createOpener(ModalType.Prompt),
      toast: toast
    },
    children: [children, modal]
  });
};
var useModals = function useModals() {
  return useContext(Context);
};

function useEdit() {
  var status = useStatus();
  var _useModals = useModals(),
    toast = _useModals.toast;
  var toggleEditing = function toggleEditing() {
    setEditing(!status.isEditing);
  };
  var setEditing = function setEditing(isEditing) {
    if (isEditing) {
      toast({
        title: 'Editing mode enabled',
        description: 'You can now make changes to the content. Don’t forget to save your changes.',
        status: 'warning'
      });
    } else {
      toast({
        title: 'Editing mode disabled',
        description: 'You can no longer make changes to the content.'
      });
    }
    status.setEditing(isEditing);
  };
  return {
    isEditing: status.isEditing,
    toggleEditing: toggleEditing,
    setEditing: setEditing
  };
}

var PopupContext = React__default.createContext(undefined);
var usePopupContext = function usePopupContext() {
  var context = React__default.useContext(PopupContext);
  if (!context) {
    throw new Error('usePopupContext must be used within a PopupProvider');
  }
  return context;
};
var PopupProvider = function PopupProvider(_ref) {
  var id = _ref.id,
    popup = _ref.popup,
    children = _ref.children,
    modalProps = _ref.modalProps,
    modalContentProps = _ref.modalContentProps,
    triggers = _ref.triggers,
    customTrigger = _ref.customTrigger,
    advanced = _ref.advanced,
    forceOpen = _ref.forceOpen,
    onCloseProp = _ref.onClose,
    _ref$editable = _ref.editable,
    editable = _ref$editable === void 0 ? false : _ref$editable;
  var dispatch = useAppDispatch();
  var _useDisclosure = useDisclosure({
      defaultIsOpen: false,
      isOpen: forceOpen
    }),
    isOpen = _useDisclosure.isOpen,
    onClose = _useDisclosure.onClose,
    onOpen = _useDisclosure.onOpen;
  var _useEdit = useEdit(),
    isEditing = _useEdit.isEditing,
    setEditing = _useEdit.setEditing;
  React__default.useEffect(function () {
    if (editable) {
      var justOpened = isOpen && !isEditing;
      if (justOpened) {
        setEditing(true);
      }
    }
  }, [isEditing, isOpen, editable]);
  var handleClose = React__default.useCallback(function () {
    onCloseProp == null ? void 0 : onCloseProp();
    onClose();
  }, [onCloseProp, onClose]);
  React__default.useEffect(function () {
    var handleOpen = function handleOpen() {
      try {
        var _temp = function () {
          if (customTrigger) {
            return Promise.resolve(customTrigger()).then(function (shouldOpen) {
              if (shouldOpen) {
                onOpen();
              }
            });
          }
        }();
        return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void handleOpen();
  }, [isOpen]);
  React__default.useEffect(function () {
    if (triggers) {
      if (triggers.onPageLoad) {
        setTimeout(function () {
          onOpen();
        }, triggers.onPageLoad * 1000);
      }
      if (triggers.onPageScroll) {
        var _triggers$onPageScrol = triggers.onPageScroll,
          percentage = _triggers$onPageScrol.percentage,
          direction = _triggers$onPageScrol.direction;
        var handleScroll = function handleScroll() {
          var scrollPercentage = window.pageYOffset / (document.body.offsetHeight - window.innerHeight);
          if (direction === 'up' && scrollPercentage < percentage || direction === 'down' && scrollPercentage > percentage) {
            onOpen();
            window.removeEventListener('scroll', handleScroll);
          }
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
          window.removeEventListener('scroll', handleScroll);
        };
      }
    }
    return function () {};
  }, []);
  React__default.useEffect(function () {
    if (advanced) {
      if (advanced.showAfterXPageViews || advanced.showUntilXPageViews) {
        var showAfterXPageViews = advanced.showAfterXPageViews,
          showUntilXPageViews = advanced.showUntilXPageViews;
        if (showAfterXPageViews || showUntilXPageViews) {
          dispatch(increaseAdvancedPageViews(id));
        }
      }
    }
  }, [advanced]);
  return jsx(PopupContext.Provider, {
    value: {
      id: id,
      popup: popup
    },
    children: jsxs(Modal, _extends({
      isOpen: isOpen,
      onClose: handleClose
    }, modalProps, {
      children: [jsx(ModalOverlay, {}), jsx(ModalContent, _extends({}, modalContentProps, {
        children: children
      }))]
    }))
  });
};

function usePopupField(name, type) {
  if (!['IMA:TextField'].includes(type)) {
    throw new Error("Field type " + type + " is not supported inside a Popup");
  }
  var _usePopupContext = usePopupContext(),
    id = _usePopupContext.id,
    popup = _usePopupContext.popup;
  if (!id) {
    throw new Error('Popup id is undefined! connectField must be used within a Popup');
  }
  function getPopupField(p) {
    var _p$jaenFields, _p$jaenFields$type, _p$jaenFields$type$na;
    if (!p) {
      return;
    }
    return (_p$jaenFields = p.jaenFields) == null ? void 0 : (_p$jaenFields$type = _p$jaenFields[type]) == null ? void 0 : (_p$jaenFields$type$na = _p$jaenFields$type[name]) == null ? void 0 : _p$jaenFields$type$na.value;
  }
  var getValue = function getValue() {
    var state = store.getState();
    var p = state.popup.nodes[id];
    if (p) {
      return getPopupField(p);
    }
    return undefined;
  };
  var getStaticValue = function getStaticValue() {
    return getPopupField(popup);
  };
  var _useState = useState(getValue),
    value = _useState[0],
    setValue = _useState[1];
  useEffect(function () {
    var unsubscribe = store.subscribe(function () {
      var newValue = getValue();
      if (newValue !== value) {
        setValue(newValue);
      }
    });
    return function () {
      unsubscribe();
    };
  }, [value]);
  var staticValue = getStaticValue();
  var _useStatus = useStatus(),
    isEditing = _useStatus.isEditing;
  var write = useCallback(function (newValue) {
    store.dispatch(field_write({
      popupId: id,
      fieldType: type,
      fieldName: name,
      value: newValue
    }));
  }, [id, type, name, value]);
  var register = useCallback(function () {}, []);
  return {
    value: value,
    staticValue: staticValue,
    jaenPopupId: id,
    isEditing: isEditing,
    write: write,
    register: register
  };
}

var _excluded$i = ["id", "name", "style", "className", "idStrategy", "relatedName", "tunes", "isDisabled"];
var connectField = function connectField(Component, options) {
  var MyComp = function MyComp(_ref) {
    var _field$props2, _field$props3;
    var id = _ref.id,
      name = _ref.name,
      style = _ref.style,
      className = _ref.className,
      _ref$idStrategy = _ref.idStrategy,
      idStrategy = _ref$idStrategy === void 0 ? 'auto' : _ref$idStrategy,
      relatedName = _ref.relatedName,
      tunes = _ref.tunes,
      isDisabled = _ref.isDisabled,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
    console.log('Rest', rest, tunes);
    var field;
    try {
      field = usePopupField(name, options.fieldType);
    } catch (_unused) {
      field = useField(name, options.fieldType);
    }
    if (!id) {
      if (idStrategy === 'auto') {
        id = name;
        if (field.SectionBlockContext) {
          var _field$SectionBlockCo = field.SectionBlockContext,
            path = _field$SectionBlockCo.path,
            position = _field$SectionBlockCo.position;
          var fqn = path.map(function (p) {
            return p.sectionId ? p.fieldName + "-" + p.sectionId : p.fieldName;
          }).join('-');
          id = fqn + "-" + position + "-" + name;
        }
      } else if (idStrategy === 'value') {
        var value = field.value || field.staticValue;
        if (value) {
          id = "" + value.replace(/(<([^>]+)>)/gi, '').replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '-').toLowerCase();
        }
      }
      if (!id) {
        id = name;
      }
    }
    var register = useCallback(function (newProps) {
      field.register(_extends({
        id: id,
        relatedName: relatedName
      }, field.props, newProps));
    }, [id, relatedName, field.props]);
    var tune = useCallback(function (info) {
      var _field$props;
      var activeTunes = ((_field$props = field.props) == null ? void 0 : _field$props.activeTunes) || [];
      activeTunes = activeTunes.filter(function (activeTune) {
        return activeTune.name !== info.name && activeTune.groupName !== info.groupName;
      });
      if (!info.isActive) {
        activeTunes.push({
          name: info.name,
          groupName: info.groupName
        });
      }
      register({
        activeTunes: activeTunes.length > 0 ? activeTunes : undefined
      });
    }, [(_field$props2 = field.props) == null ? void 0 : _field$props2.activeTunes, register]);
    console.log('Field props', field);
    return jsx(Component, _extends({
      jaenField: {
        id: id,
        idStrategy: idStrategy,
        name: name,
        staticValue: field.staticValue,
        value: field.value,
        isEditing: field.isEditing && !isDisabled,
        onUpdateValue: field.write,
        register: register,
        tune: tune,
        style: style,
        className: className,
        relatedName: relatedName,
        tunes: tunes || [],
        activeTunes: (_field$props3 = field.props) == null ? void 0 : _field$props3.activeTunes,
        isDisabled: isDisabled
      }
    }, rest));
  };
  MyComp.options = options;
  return React__default.memo(MyComp);
};

var connectPage = function connectPage(Component, options) {
  var MyComp = function MyComp(props) {
    var _props$data, _props$data$allJaenPa;
    var jaenPage = _extends({
      id: props.pageContext.jaenPageId
    }, (_props$data = props.data) == null ? void 0 : _props$data.jaenPage);
    return jsx(Fragment, {
      children: jsx(PageProvider, {
        jaenPage: jaenPage,
        jaenPages: (_props$data$allJaenPa = props.data.allJaenPage) == null ? void 0 : _props$data$allJaenPa.nodes,
        children: jsx(Component, _extends({}, props))
      })
    });
  };
  MyComp.options = options;
  return MyComp;
};

var connectPopup = function connectPopup(Component, options) {
  var MyComp = function MyComp(props) {
    return jsx(PopupProvider, _extends({
      id: props.id,
      popup: props.popup,
      forceOpen: props.forceOpen,
      editable: props.edtiable,
      onClose: props.onClose
    }, options, {
      children: jsx(Component, _extends({}, props))
    }));
  };
  MyComp.options = options;
  return MyComp;
};

var connectTemplate = function connectTemplate(Component, options) {
  var MyComp = function MyComp(props) {
    var _props$data, _props$data$allJaenPa;
    var jaenPage = _extends({
      id: props.pageContext.jaenPageId
    }, (_props$data = props.data) == null ? void 0 : _props$data.jaenPage);
    return jsx(Fragment, {
      children: jsx(PageProvider, {
        jaenPage: jaenPage,
        jaenPages: (_props$data$allJaenPa = props.data.allJaenPage) == null ? void 0 : _props$data$allJaenPa.nodes,
        children: jsx(Component, _extends({}, props))
      })
    });
  };
  MyComp.options = options;
  return MyComp;
};

var ViewContext = React.createContext(undefined);
var ViewProvider = function ViewProvider(_ref) {
  var children = _ref.children;
  return jsx(ViewContext.Provider, {
    value: {},
    children: children
  });
};
var connectView = function connectView(Component, options) {
  var MyComp = function MyComp(props) {
    return jsx(ViewProvider, _extends({}, options, {
      children: jsx(Component, _extends({}, props))
    }));
  };
  MyComp.options = options;
  return MyComp;
};

var JaenLogo = createIcon({
  displayName: 'JaenLogo',
  viewBox: '0 0 512 512',
  path: jsxs("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 475 475",
    xmlSpace: "preserve",
    children: [jsx("style", {
      type: "text/css",
      children: ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#AF23A5;}\n   .st1{fill:#FFFFFF;}\n   .st2{fill:none;}\n   .st3{fill:#C1C1C1;}"
    }), jsx("g", {
      id: "layer1",
      transform: "translate(-41.732056,-64.283038)",
      children: jsx("path", {
        id: "Fill_1",
        className: "st0",
        d: "M467,114.2c-44.8-44.6-109.2-49.6-187.9-49.6c-78.8,0-143.2,5-188,49.8S41.8,223.5,41.8,302.2\n     S46.3,445.3,91.1,490s109.2,49.3,188,49.3s143.2-4.5,188-49.3s49.3-109.1,49.3-187.9C516.5,223.4,511.9,158.9,467,114.2L467,114.2z\n     "
      })
    }), jsx("path", {
      className: "st1",
      d: "M115.9,344.8c6.1,2.2,9.4,5.7,12.9,8.7c29.6,24.4,63.4,38.9,101.9,39.7c72.8,1.6,136.2-46.3,149.9-117.8\n   c11.6-60.2-8.1-110.1-58-145.8c-60.1-43-143.5-29.9-188,28.6c-29.3,38.5-35.7,81.5-20.3,127.4c3.6,10.9,3.8,20.7-3.6,29.9\n   c-6.3,7.8-14.7,10.8-24.5,9.5c-11-1.5-18.5-7.9-22.1-18.3c-5.3-15.4-8.9-31.3-9.8-47.5C51,199.9,70,148.8,114,108.6\n   c39.7-36.4,87.2-52.9,141.3-47.5c80.5,8.1,144.1,64.6,159.8,142.9c19.4,96.8-40.6,189-136.9,207c-60.2,11.2-113.3-5.1-154.4-53\n   c-2.1-2.5-3.8-5.4-5.6-8.1C117.5,348.7,117.1,347.4,115.9,344.8L115.9,344.8z"
    }), jsx("g", {
      transform: "translate(0.000000,860.000000) scale(0.100000,-0.100000)",
      children: jsx("path", {
        className: "st1",
        d: "M2046.4,5333.6c118,107.8,236.6,168.3,394.4,201.2c84.8,17.4,162.4,25.5,301.2,30.1c56.2,2.2,102.8,4,103.1,4\n     c0.3,0.3,5.6,23.3,11.8,51.2c54,243.1,175.5,656.2,323,1096.2c17.7,53.7,32,98.1,31.7,98.4c-0.6,0.6-144.4-142.5-319.5-318\n     l-318.9-318.9l5.3-19.3c13.7-52.2-19.9-114.9-76.1-141.6c-19.9-9.3-23.3-9.9-55.6-9.9c-33.2,0-34.8,0.3-57.8,11.8\n     c-83.8,41.3-101.9,148.4-36.3,214.3c32.3,32.3,77,46,117.7,36.3l16.1-4l318,318c174.8,174.8,317.4,318,317.1,318.6\n     c-0.6,0.3-60.2-18.9-132.6-42.9c-450.9-148.4-832.5-260.5-1052.7-308.7c-28.3-6.2-53.4-11.8-56.2-12.7c-4.3-1.2-5.3-12.7-6.8-93.8\n     c-6.8-334.8-66.1-521.7-219.9-693.1l-28.6-31.7l201.5-201.2l201.5-201.5L2046.4,5333.6z"
      })
    })]
  })
});
createIcon({
  displayName: 'JaenFullLogo',
  viewBox: '0 0 512 512',
  path: jsxs("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1112 475",
    enableBackground: "new 0 0 1112 475;",
    xmlSpace: "preserve",
    children: [jsx("style", {
      type: "text/css",
      children: ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#AF23A5;}\n.st1{fill:#FFFFFF;}\n.st2{fill:none;}\n.st3{fill:#C1C1C1;}"
    }), jsx("g", {
      id: "layer1",
      transform: "translate(-41.732056,-64.283038)",
      children: jsx("path", {
        id: "Fill_1",
        className: "st0",
        d: "M467,114.2c-44.8-44.6-109.2-49.6-187.9-49.6c-78.8,0-143.2,5-188,49.8S41.8,223.5,41.8,302.2\nS46.3,445.3,91.1,490s109.2,49.3,188,49.3s143.2-4.5,188-49.3s49.3-109.1,49.3-187.9C516.5,223.4,511.9,158.9,467,114.2L467,114.2z\n"
      })
    }), jsx("path", {
      className: "st1",
      d: "M115.9,344.8c6.1,2.2,9.4,5.7,12.9,8.7c29.6,24.4,63.4,38.9,101.9,39.7c72.8,1.6,136.2-46.3,149.9-117.8\nc11.6-60.2-8.1-110.1-58-145.8c-60.1-43-143.5-29.9-188,28.6c-29.3,38.5-35.7,81.5-20.3,127.4c3.6,10.9,3.8,20.7-3.6,29.9\nc-6.3,7.8-14.7,10.8-24.5,9.5c-11-1.5-18.5-7.9-22.1-18.3c-5.3-15.4-8.9-31.3-9.8-47.5C51,199.9,70,148.8,114,108.6\nc39.7-36.4,87.2-52.9,141.3-47.5c80.5,8.1,144.1,64.6,159.8,142.9c19.4,96.8-40.6,189-136.9,207c-60.2,11.2-113.3-5.1-154.4-53\nc-2.1-2.5-3.8-5.4-5.6-8.1C117.5,348.7,117.1,347.4,115.9,344.8L115.9,344.8z"
    }), jsxs("g", {
      children: [jsx("rect", {
        x: "542.8",
        y: "132.9",
        className: "st2",
        width: "582.2",
        height: "209.3"
      }), jsx("path", {
        className: "st3",
        d: "M542.8,366.5c11.2,0,17.4-7.9,17.4-23.2V194.9h32.7v151.5c0,31.8-17.7,49.7-47.7,49.7c-2.6,0-5.9,0-9.7-0.6\nl2.6-29.7C539.9,366.2,541.3,366.5,542.8,366.5z M597.5,149c0,11.8-9.7,21.2-21.2,21.2s-20.9-9.4-20.9-21.2\nc0-11.2,9.4-20.9,20.9-20.9S597.5,137.9,597.5,149z"
      }), jsx("path", {
        className: "st3",
        d: "M772.9,194.9v143.9h-33v-25.3c-10.3,17.9-28,28.2-50.9,28.2c-38.3,0-68.9-33.5-68.9-75\nc0-41.5,30.6-74.7,68.9-74.7c23,0,40.6,10.3,50.9,28.2v-25.3H772.9z M739.9,266.7c0-24.7-18.8-43.5-43.8-43.5\nc-24.4,0-43.8,19.4-43.8,43.5c0,24.4,19.4,43.8,43.8,43.8C721.1,310.6,739.9,291.7,739.9,266.7z"
      }), jsx("path", {
        className: "st3",
        d: "M942.4,274.7H832.9c3.5,23.2,19.4,37.4,42.7,37.4c16.2,0,30.9-7.1,37.7-18.2l26.2,16.8\nc-10.6,19.4-34.7,31.2-64.4,31.2c-41.5,0-74.7-32.7-74.7-75.6c0-41.8,32.7-74.1,74.1-74.1c38.8,0,69.1,30,69.1,68.6\nC943.5,264.4,943.2,270.3,942.4,274.7z M909.1,249.7c-1.8-17.9-16.8-30.6-36.5-30.6s-33.5,11.8-38.5,30.6H909.1z"
      }), jsx("path", {
        className: "st3",
        d: "M1106.8,256.7v82.1h-33v-78c0-22.7-13.8-37.4-34.7-37.4c-21.5,0-35.6,14.7-35.6,37.4v78h-32.7V194.9h32.7v22.7\nc9.1-16.2,24.4-25.6,43.5-25.6C1083.9,192,1106.8,216.7,1106.8,256.7z"
      })]
    }), jsx("g", {
      transform: "translate(0.000000,860.000000) scale(0.100000,-0.100000)",
      children: jsx("path", {
        className: "st1",
        d: "M2046.4,5333.6c118,107.8,236.6,168.3,394.4,201.2c84.8,17.4,162.4,25.5,301.2,30.1c56.2,2.2,102.8,4,103.1,4\nc0.3,0.3,5.6,23.3,11.8,51.2c54,243.1,175.5,656.2,323,1096.2c17.7,53.7,32,98.1,31.7,98.4c-0.6,0.6-144.4-142.5-319.5-318\nl-318.9-318.9l5.3-19.3c13.7-52.2-19.9-114.9-76.1-141.6c-19.9-9.3-23.3-9.9-55.6-9.9c-33.2,0-34.8,0.3-57.8,11.8\nc-83.8,41.3-101.9,148.4-36.3,214.3c32.3,32.3,77,46,117.7,36.3l16.1-4l318,318c174.8,174.8,317.4,318,317.1,318.6\nc-0.6,0.3-60.2-18.9-132.6-42.9c-450.9-148.4-832.5-260.5-1052.7-308.7c-28.3-6.2-53.4-11.8-56.2-12.7c-4.3-1.2-5.3-12.7-6.8-93.8\nc-6.8-334.8-66.1-521.7-219.9-693.1l-28.6-31.7l201.5-201.2l201.5-201.5L2046.4,5333.6z"
      })
    }), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {}), jsx("g", {})]
  })
});
var JaenFullLogoWhite = createIcon({
  displayName: 'JaenFullLogoWhite',
  viewBox: '0 0 512 512',
  path: jsxs("svg", {
    version: "1.1",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1112 475",
    enableBackground: "new 0 0 1112 475",
    xmlSpace: "preserve",
    children: [jsx("style", {
      type: "text/css",
      children: " .st0{fill:#FFFFFF;}\n .st1{fill:none;}"
    }), jsxs("g", {
      children: [jsx("path", {
        className: "st0",
        d: "M542.8,366.5c11.2,0,17.4-7.9,17.4-23.2V194.9h32.7v151.5c0,31.8-17.7,49.7-47.7,49.7c-2.6,0-5.9,0-9.7-0.6\n   l2.6-29.7C539.9,366.2,541.3,366.5,542.8,366.5z M597.5,149c0,11.8-9.7,21.2-21.2,21.2s-20.9-9.4-20.9-21.2\n   c0-11.2,9.4-20.9,20.9-20.9S597.5,137.9,597.5,149z"
      }), jsx("path", {
        className: "st0",
        d: "M772.9,194.9v143.9h-33v-25.3c-10.3,17.9-28,28.2-50.9,28.2c-38.3,0-68.9-33.5-68.9-75S650.7,192,689,192\n   c23,0,40.6,10.3,50.9,28.2v-25.3L772.9,194.9L772.9,194.9z M739.9,266.7c0-24.7-18.8-43.5-43.8-43.5c-24.4,0-43.8,19.4-43.8,43.5\n   c0,24.4,19.4,43.8,43.8,43.8C721.1,310.6,739.9,291.7,739.9,266.7z"
      }), jsx("path", {
        className: "st0",
        d: "M942.4,274.7H832.9c3.5,23.2,19.4,37.4,42.7,37.4c16.2,0,30.9-7.1,37.7-18.2l26.2,16.8\n   c-10.6,19.4-34.7,31.2-64.4,31.2c-41.5,0-74.7-32.7-74.7-75.6c0-41.8,32.7-74.1,74.1-74.1c38.8,0,69.1,30,69.1,68.6\n   C943.5,264.4,943.2,270.3,942.4,274.7z M909.1,249.7c-1.8-17.9-16.8-30.6-36.5-30.6s-33.5,11.8-38.5,30.6H909.1z"
      }), jsx("path", {
        className: "st0",
        d: "M1106.8,256.7v82.1h-33v-78c0-22.7-13.8-37.4-34.7-37.4c-21.5,0-35.6,14.7-35.6,37.4v78h-32.7V194.9h32.7v22.7\n   c9.1-16.2,24.4-25.6,43.5-25.6C1083.9,192,1106.8,216.7,1106.8,256.7z"
      })]
    }), jsxs("g", {
      children: [jsx("path", {
        className: "st1",
        d: "M255.3,61.1c-54.1-5.4-101.6,11.1-141.3,47.5c-44,40.2-63,91.3-59.7,150.6c0.9,16.2,4.5,32.1,9.8,47.5\n   c3.6,10.4,11.1,16.8,22.1,18.3c9.8,1.3,18.2-1.7,24.5-9.5c7.4-9.2,7.2-19,3.6-29.9c-15.4-45.9-9-88.9,20.3-127.4\n   c44.5-58.5,127.9-71.6,188-28.6c49.9,35.7,69.6,85.6,58,145.8c-13.7,71.5-77.1,119.4-149.9,117.8c-38.5-0.8-72.3-15.3-101.9-39.7\n   c-3.5-3-6.8-6.5-12.9-8.7c1.2,2.6,1.6,3.9,2.3,5.1c1.8,2.7,3.5,5.6,5.6,8.1c41.1,47.9,94.2,64.2,154.4,53\n   c96.3-18,156.3-110.2,136.9-207C399.4,125.7,335.8,69.2,255.3,61.1z"
      }), jsx("path", {
        className: "st0",
        d: "M425.3,49.9C380.5,5.3,316.1,0.3,237.4,0.3c-78.8,0-143.2,5-188,49.8C4.6,94.9,0.1,159.2,0.1,237.9\n   S4.6,381,49.4,425.7c44.8,44.7,109.2,49.3,188,49.3s143.2-4.5,188-49.3c44.8-44.8,49.3-109.1,49.3-187.9\n   C474.8,159.1,470.2,94.6,425.3,49.9z M278.2,411c-60.2,11.2-113.3-5.1-154.4-53c-2.1-2.5-3.8-5.4-5.6-8.1c-0.7-1.2-1.1-2.5-2.3-5.1\n   c6.1,2.2,9.4,5.7,12.9,8.7c29.6,24.4,63.4,38.9,101.9,39.7c72.8,1.6,136.2-46.3,149.9-117.8c11.6-60.2-8.1-110.1-58-145.8\n   c-60.1-43-143.5-29.9-188,28.6c-29.3,38.5-35.7,81.5-20.3,127.4c3.6,10.9,3.8,20.7-3.6,29.9c-6.3,7.8-14.7,10.8-24.5,9.5\n   c-11-1.5-18.5-7.9-22.1-18.3c-5.3-15.4-8.9-31.3-9.8-47.5C51,199.9,70,148.8,114,108.6c39.7-36.4,87.2-52.9,141.3-47.5\n   c80.5,8.1,144.1,64.6,159.8,142.9C434.5,300.8,374.5,393,278.2,411z M238.9,258.1c2.3,1.1,2.5,1.2,5.8,1.2c3.2,0,3.6-0.1,5.6-1\n   c5.6-2.7,9-8.9,7.6-14.2l-0.5-1.9l31.9-31.9c17.5-17.5,31.9-31.9,32-31.8c0,0-1.4,4.5-3.2,9.8c-14.8,44-26.9,85.3-32.3,109.6\n   c-0.6,2.8-1.1,5.1-1.2,5.1c0,0-4.7,0.2-10.3,0.4c-13.9,0.5-21.6,1.3-30.1,3c-15.8,3.3-27.6,9.3-39.4,20.1l-1.9,1.7l-20.2-20.1\n   l-20.2-20.1l2.9-3.2c15.4-17.1,21.3-35.8,22-69.3c0.1-8.1,0.2-9.3,0.7-9.4c0.3-0.1,2.8-0.7,5.6-1.3c22-4.8,60.2-16,105.3-30.9\n   c7.2-2.4,13.2-4.3,13.3-4.3c0,0.1-14.2,14.4-31.7,31.9l-31.8,31.8l-1.6-0.4c-4.1-1-8.5,0.4-11.8,3.6\n   C228.7,243.3,230.5,254,238.9,258.1z"
      })]
    })]
  })
});

var pluginConfig = {
  current_lang: 'en',
  autoclear_cookies: true,
  page_scripts: true,
  force_consent: true,
  gui_options: {
    settings_modal: {
      layout: 'box'
    },
    consent_modal: {
      layout: 'cloud'
    }
  },
  onFirstAction: function onFirstAction(_userPreferences, _cookie) {},
  onAccept: function onAccept(_cookie) {},
  onChange: function onChange(_cookie, _changedPreferences) {},
  languages: {
    en: {
      consent_modal: {
        title: 'We use cookies!',
        description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
        primary_btn: {
          text: 'Accept all',
          role: 'accept_all'
        },
        secondary_btn: {
          text: 'Reject all',
          role: 'accept_necessary'
        }
      },
      settings_modal: {
        title: 'Cookie Settings',
        save_settings_btn: 'Save settings',
        accept_all_btn: 'Accept all',
        reject_all_btn: 'Reject all',
        close_btn_label: 'Close',
        cookie_table_headers: [{
          col1: 'Name'
        }, {
          col2: 'Domain'
        }, {
          col3: 'Expiration'
        }, {
          col4: 'Description'
        }],
        blocks: [{
          title: 'Cookie usage 📢',
          description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
        }, {
          title: 'Strictly necessary cookies',
          description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
          toggle: {
            value: 'necessary',
            enabled: true,
            readonly: true
          }
        }, {
          title: 'Performance and Analytics cookies',
          description: 'These cookies allow the website to remember the choices you have made in the past',
          toggle: {
            value: 'analytics',
            enabled: false,
            readonly: false
          },
          cookie_table: [{
            col1: '^_ga',
            col2: 'google.com',
            col3: '2 years',
            col4: 'description ...',
            is_regex: true
          }, {
            col1: '_gid',
            col2: 'google.com',
            col3: '1 day',
            col4: 'description ...'
          }]
        }, {
          title: 'Advertisement and Targeting cookies',
          description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
          toggle: {
            value: 'targeting',
            enabled: false,
            readonly: false
          }
        }, {
          title: 'More information',
          description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contakt">contact us</a>.'
        }]
      }
    }
  }
};

var CookieConsent = function CookieConsent() {
  useEffect(function () {
    if (!document.getElementById('cc--main')) {
      window.CookieConsentApi = window.initCookieConsent();
      window.CookieConsentApi.run(pluginConfig);
    }
  }, []);
  return null;
};

function useDiscard() {
  var _useModals = useModals(),
    confirm = _useModals.confirm,
    toast = _useModals.toast;
  var discardChanges = useCallback(function () {
    try {
      return Promise.resolve(confirm("Are you sure you want to discard your changes? You won't be able to recover them.")).then(function (shouldDiscard) {
        if (!shouldDiscard) {
          return;
        }
        resetState({
          auth: store.getState().auth
        });
        toast({
          title: 'Changes discarded',
          status: 'success'
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  return {
    discardChanges: discardChanges
  };
}

var DiscardActionButton = function DiscardActionButton() {
  var isMobile = useBreakpointValue({
    base: true,
    lg: false
  }, {
    ssr: false
  });
  var _useDiscard = useDiscard(),
    discardChanges = _useDiscard.discardChanges;
  var handleClick = function handleClick() {
    void discardChanges();
  };
  if (isMobile) {
    return jsx(IconButton, {
      borderRadius: "full",
      icon: jsx(DeleteIcon, {}),
      "aria-label": "Discard changes",
      onClick: handleClick
    });
  }
  return jsx(Button, {
    onClick: handleClick,
    borderRadius: "full",
    leftIcon: jsx(DeleteIcon, {}),
    children: "Discard"
  });
};

var EditActionButton = function EditActionButton() {
  var _useEdit = useEdit(),
    isEditing = _useEdit.isEditing,
    toggleEditing = _useEdit.toggleEditing;
  return jsx(Button, {
    onClick: toggleEditing,
    leftIcon: jsx(EditIcon, {}),
    rightIcon: isEditing ? jsx(Badge, {
      rounded: "full",
      colorScheme: "green",
      children: "On"
    }) : jsx(Badge, {
      rounded: "full",
      children: "Off"
    }),
    children: "Edit"
  });
};

var HighlightProviderContext = createContext({
  ref: function ref() {}
});
var Tooltip = forwardRef(function (props, ref) {
  return jsx(ThemeProvider, {
    children: jsx(HStack, {
      ref: ref,
      id: "coco",
      fontFamily: FONT_FAMILY,
      w: "fit-content",
      mt: "-6",
      p: "1",
      mx: "auto",
      justifyContent: "center",
      spacing: "1",
      pointerEvents: "all",
      children: props.actions.map(function (action, index) {
        return jsx(React__default.Fragment, {
          children: action
        }, index);
      })
    })
  });
});
var HighlightProvider = function HighlightProvider(props) {
  var itemsRef = useRef([]);
  var tooltipHightRef = useRef(null);
  var setHighlight = function setHighlight(element) {
    var appRoot = document.getElementById('___gatsby');
    if (!appRoot) {
      alert('appRoot root not found, please contact support');
      return;
    }
    var frameRoot = appRoot.querySelector("." + CLASSNAMES.JAEN_HIGHLIGHT_FRAME);
    if (frameRoot) {
      frameRoot.remove();
    }
    frameRoot = appRoot.appendChild(document.createElement('div'));
    frameRoot.classList.add(CLASSNAMES.JAEN_HIGHLIGHT_FRAME);
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    frameRoot.style.position = 'absolute';
    var tooltipRoot = frameRoot.appendChild(document.createElement('div'));
    tooltipRoot.classList.add(CLASSNAMES.JAEN_HIGHLIGHT_TOOLTIP);
    tooltipRoot.style.position = 'sticky';
    tooltipRoot.style.top = "3.5rem";
    tooltipRoot.style.pointerEvents = 'none';
    var observer = new ResizeObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      var elementRect = entry.target.getBoundingClientRect();
      if (!frameRoot) throw new Error('elementRect is null. This should not happen.');
      frameRoot.style.top = elementRect.top + scrollTop + "px";
      frameRoot.style.left = elementRect.left + scrollLeft + "px";
      frameRoot.style.width = elementRect.width + "px";
      frameRoot.style.height = elementRect.height + "px";
      tooltipRoot.style.width = '100%';
    });
    observer.observe(element);
    var item = itemsRef.current.find(function (item) {
      return item.ref === element;
    });
    if (item != null && item.ref) {
      var tooltipButtons = (item == null ? void 0 : item.tooltipButtons) || [];
      var root = createRoot(tooltipRoot);
      root.render(jsx(Tooltip, {
        actions: tooltipButtons,
        ref: tooltipHightRef
      }));
    }
  };
  var findClosestParentMatching = function findClosestParentMatching(element, find) {
    var currentElement = element;
    var index = -1;
    while (currentElement) {
      index++;
      if (find(currentElement)) {
        return {
          element: currentElement,
          index: index
        };
      }
      currentElement = currentElement.parentElement;
    }
    return null;
  };
  var _useStatus = useStatus(),
    isEditing = _useStatus.isEditing;
  var mouseEnterHandler = useCallback(function (e) {
    var element = e.target;
    element.focus({
      preventScroll: true
    });
  }, []);
  var mouseLeaveHandler = useCallback(function (e) {
    var relatedTarget = e.relatedTarget;
    var nextItem = itemsRef.current.find(function (item) {
      return item.ref === relatedTarget;
    });
    if (nextItem) {
      var _nextItem$ref;
      nextItem == null ? void 0 : (_nextItem$ref = nextItem.ref) == null ? void 0 : _nextItem$ref.focus({
        preventScroll: true
      });
    } else {
      var closestParent = findClosestParentMatching(relatedTarget, function (element) {
        return itemsRef.current.some(function (item) {
          return item.ref === element;
        });
      });
      if (closestParent) {
        var _closestItem$ref;
        var closestItem = itemsRef.current.find(function (item) {
          return item.ref === closestParent.element;
        });
        closestItem == null ? void 0 : (_closestItem$ref = closestItem.ref) == null ? void 0 : _closestItem$ref.focus({
          preventScroll: true
        });
      }
    }
  }, []);
  var focusHandler = useCallback(function (e) {
    var element = e.target;
    if (element.isContentEditable) {
      var range = document.createRange();
      var selection = window.getSelection();
      if (!selection) return;
      range.selectNodeContents(element);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
    setHighlight(element);
  }, []);
  var blurHandler = useCallback(function (e) {
    var _tooltipHightRef$curr;
    var highlightRoot = document.querySelector("." + CLASSNAMES.JAEN_HIGHLIGHT_FRAME);
    if (!highlightRoot) return;
    if ((_tooltipHightRef$curr = tooltipHightRef.current) != null && _tooltipHightRef$curr.contains(e.relatedTarget)) {
      return;
    }
    var element = e.currentTarget;
    if (element.contains(e.relatedTarget)) {
      return;
    }
    highlightRoot.remove();
  }, []);
  var ref = useCallback(function (ref, tooltipButtons) {
    if (ref) {
      var _itemsRef$current$ind;
      ref.addEventListener('mouseenter', mouseEnterHandler);
      ref.addEventListener('mouseleave', mouseLeaveHandler);
      ref.addEventListener('focus', focusHandler);
      ref.addEventListener('blur', blurHandler);
      var index = itemsRef.current.findIndex(function (item) {
        return item.ref === ref;
      });
      if (index === -1) {
        itemsRef.current.push({
          ref: ref,
          tooltipButtons: tooltipButtons
        });
      } else if (((_itemsRef$current$ind = itemsRef.current[index]) == null ? void 0 : _itemsRef$current$ind.tooltipButtons) !== tooltipButtons) {
        itemsRef.current[index] = {
          ref: ref,
          tooltipButtons: tooltipButtons
        };
      }
    }
  }, [itemsRef.current]);
  useEffect(function () {
    for (var _iterator = _createForOfIteratorHelperLoose(itemsRef.current), _step; !(_step = _iterator()).done;) {
      var item = _step.value;
      if (!item.ref) continue;
      if (isEditing) {
        item.ref.addEventListener('mouseenter', mouseEnterHandler);
        item.ref.addEventListener('mouseleave', mouseLeaveHandler);
        item.ref.addEventListener('focus', focusHandler);
        item.ref.addEventListener('blur', blurHandler);
      }
    }
    return function () {
      for (var _iterator2 = _createForOfIteratorHelperLoose(itemsRef.current), _step2; !(_step2 = _iterator2()).done;) {
        var item = _step2.value;
        if (!item.ref) continue;
        item.ref.removeEventListener('mouseenter', mouseEnterHandler);
        item.ref.removeEventListener('mouseleave', mouseLeaveHandler);
        item.ref.removeEventListener('focus', focusHandler);
        item.ref.removeEventListener('blur', blurHandler);
      }
    };
  }, [isEditing, itemsRef.current, mouseEnterHandler, mouseLeaveHandler, focusHandler, blurHandler]);
  return jsx(HighlightProviderContext.Provider, {
    value: {
      ref: ref
    },
    children: props.children
  });
};
var useHighlight = function useHighlight(_ref) {
  var tooltipButtons = _ref.tooltipButtons;
  var _useContext = useContext(HighlightProviderContext),
    ref = _useContext.ref;
  var refOnly = useCallback(function (theRef) {
    ref(theRef, tooltipButtons);
  }, [tooltipButtons, ref]);
  return {
    ref: refOnly
  };
};

var HighlightContext = {
  __proto__: null,
  HighlightProviderContext: HighlightProviderContext,
  HighlightProvider: HighlightProvider,
  useHighlight: useHighlight,
  'default': HighlightProvider
};

var _excluded$h = ["actions", "as", "asAs", "isEditing", "children"];
var HighlightTooltip = forwardRef(function (_ref, ref) {
  var actions = _ref.actions,
    as = _ref.as,
    asAs = _ref.asAs,
    isEditing = _ref.isEditing,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var _useHighlight = useHighlight({
      tooltipButtons: actions
    }),
    highlightRef = _useHighlight.ref;
  var setRefs = useCallback(function (node) {
    if (typeof ref === 'function') {
      ref(node);
    } else {
      if (ref) ref.current = node;
    }
    highlightRef(node);
  }, [ref, highlightRef]);
  var Wrapper = as || Box;
  var memoedChildren = useMemo(function () {
    if (typeof children === 'function') {
      return children({
        ref: setRefs,
        tabIndex: isEditing ? 1 : undefined
      });
    }
    return children;
  }, [setRefs, isEditing, children]);
  if (typeof children === 'function') {
    return jsx(Wrapper, _extends({}, props, {
      as: asAs,
      id: props.id,
      _focus: {
        outline: 'none'
      },
      children: memoedChildren
    }));
  }
  return jsx(Wrapper, _extends({}, props, {
    ref: setRefs,
    as: asAs,
    id: props.id,
    tabIndex: isEditing ? 1 : undefined,
    _focus: {
      outline: 'none'
    },
    children: memoedChildren
  }));
});

var useAdminStaticQuery = function useAdminStaticQuery() {
  return useAdminStaticQuery$1();
};

var SnekFinderProvider = React__default.lazy(function () {
  try {
    return Promise.resolve(import('@snek-at/snek-finder').then(function (module) {
      return {
        "default": module.SnekFinderProvider
      };
    }));
  } catch (e) {
    return Promise.reject(e);
  }
});
var Backend = new OSGBackend('snek-finder-osg-backend-root');
var SnekFinder = withRedux(function (_ref) {
  var children = _ref.children;
  var isSSR = typeof window === 'undefined';
  var _useAdminStaticQuery = useAdminStaticQuery(),
    jaenInternal = _useAdminStaticQuery.jaenInternal;
  var dynamicFinderUrl = useAppSelector(function (state) {
    return state.finderUrl;
  });
  var finderUrl = dynamicFinderUrl || jaenInternal.finderUrl;
  return jsx(React__default.Suspense, {
    fallback: null,
    children: !isSSR && jsx(SnekFinderProvider, {
      backend: Backend,
      initDataLink: finderUrl || undefined,
      children: children
    })
  });
});

var prepareMigration = function prepareMigration(filenameScope, withRouting) {
  if (filenameScope === void 0) {
    filenameScope = 'draft';
  }
  if (withRouting === void 0) {
    withRouting = false;
  }
  try {
    var state = store.getState();
    var migrationData = {};
    return Promise.resolve(Backend.readIndex()).then(function (finderBackendIndex) {
      migrationData.jaen = {
        site: state.site,
        finderUrl: finderBackendIndex == null ? void 0 : finderBackendIndex.src,
        widgets: state.widget.nodes
      };
      migrationData.pages = _extends({}, state.page.pages.nodes);
      if (withRouting) {
        migrationData.pageRouting = _extends({}, state.page.routing);
      }
      migrationData.popups = _extends({}, state.popup.nodes);
      var blob = new Blob([JSON.stringify(migrationData)], {
        type: 'application/json'
      });
      return {
        data: migrationData,
        filename: "jaen-" + filenameScope + "-" + new Date().toISOString() + ".jaen",
        blob: blob
      };
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var insertMigration = function insertMigration(migrationData) {
  try {
    resetState({
      finderUrl: migrationData.jaen.finderUrl,
      site: migrationData.jaen.site,
      page: {
        routing: migrationData.pageRouting,
        pages: {
          nodes: migrationData.pages
        }
      },
      popup: {
        nodes: migrationData.popups
      },
      widget: {
        nodes: migrationData.jaen.widgets
      }
    });
    Backend.indexKey = migrationData.jaen.finderUrl;
    return Promise.resolve(Backend.readIndex()).then(function () {});
  } catch (e) {
    return Promise.reject(e);
  }
};

var URL$1 = 'https://osg.snek.at/storage';
var upload = function upload(payload, filename) {
  if (filename === void 0) {
    filename = 'jaen-index.json';
  }
  try {
    var formData = new FormData();
    if (payload instanceof Blob || payload instanceof File) {
      formData.append('file', payload);
    } else {
      formData.append('file', new File([JSON.stringify(payload)], filename, {
        type: 'application/json'
      }));
    }
    return Promise.resolve(fetch(URL$1, {
      body: formData,
      method: 'POST'
    })).then(function (resp) {
      return Promise.resolve(resp.json()).then(function (json) {
        return URL$1 + "/" + json.file_id;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var usePublish = function usePublish() {
  var _useState = useState(false),
    isPublishing = _useState[0],
    setIsPublishing = _useState[1];
  var publish = useCallback(function () {
    try {
      return Promise.resolve(prepareMigration()).then(function (_ref) {
        var blob = _ref.blob,
          filename = _ref.filename;
        return Promise.resolve(upload(blob, filename)).then(function (migrationURL) {
          console.info("Jaen publish migrationURL: " + migrationURL);
          return Promise.resolve(sq.mutate(function (Mutation) {
            return Mutation.jaenPublish({
              resourceId: snekResourceId,
              migrationURL: migrationURL
            });
          })).then(function (_ref2) {
            var _ = _ref2[0],
              errors = _ref2[1];
            if (errors) {
              throw new Error("Error while publishing: " + errors.map(function (e) {
                return e.message;
              }).join(', '));
            }
            setIsPublishing(true);
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  return {
    isPublishing: isPublishing,
    publish: publish
  };
};

function _catch$4(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var PublishActionButton = function PublishActionButton() {
  var _useModals = useModals(),
    confirm = _useModals.confirm,
    toast = _useModals.toast;
  var _usePublish = usePublish(),
    isPublishing = _usePublish.isPublishing,
    publish = _usePublish.publish;
  var isMobile = useBreakpointValue({
    base: true,
    md: false
  }, {
    ssr: false
  });
  var handleClick = function handleClick() {
    try {
      return Promise.resolve(confirm("Are you sure you want to publish this page?")).then(function (shouldPublish) {
        if (!shouldPublish) {
          return;
        }
        var _temp = _catch$4(function () {
          return Promise.resolve(publish()).then(function () {
            toast({
              title: "Publishing...",
              description: "Your page is being published. This may take a few minutes.",
              status: 'success',
              isClosable: true
            });
          });
        }, function () {
          toast({
            title: "Publishing failed",
            description: "Your page could not be published. Please try again later.",
            status: 'error',
            isClosable: true
          });
        });
        if (_temp && _temp.then) return _temp.then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var commonProps = {
    onClick: handleClick,
    isLoading: isPublishing
  };
  if (isMobile) {
    return jsx(IconButton, _extends({
      icon: jsx(Icon, {
        as: BiRocket,
        boxSize: "5"
      }),
      "aria-label": "Publish now"
    }, commonProps));
  }
  return jsx(Button, _extends({
    variant: "solid",
    leftIcon: jsx(Icon, {
      as: BiRocket,
      boxSize: "5"
    })
  }, commonProps, {
    children: "Publish now"
  }));
};

var useSaveDraft = function useSaveDraft() {
  var _useState = useState(false),
    isSaving = _useState[0],
    setIsSaving = _useState[1];
  var _useState2 = useState(false),
    isSaved = _useState2[0],
    setIsSaved = _useState2[1];
  var saveDraft = useCallback(function () {
    try {
      setIsSaving(true);
      return Promise.resolve(prepareMigration('draft', true)).then(function (_ref) {
        var blob = _ref.blob,
          filename = _ref.filename;
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
        setIsSaving(false);
        setIsSaved(true);
        setTimeout(function () {
          setIsSaved(false);
        }, 2000);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  return {
    isSaving: isSaving,
    isSaved: isSaved,
    saveDraft: saveDraft
  };
};

var useHasChanges = function useHasChanges() {
  var pageNodes = useAppSelector(function (state) {
    return state.page.pages.nodes;
  });
  var popupNodes = useAppSelector(function (state) {
    return state.popup.nodes;
  });
  var siteMetadata = useAppSelector(function (state) {
    return state.site.siteMetadata;
  });
  return Object.keys(pageNodes).length > 0 || Object.keys(popupNodes).length > 0 || Object.keys(siteMetadata).length > 0;
};

var SaveDraftActionButton = function SaveDraftActionButton() {
  var isMobile = useBreakpointValue({
    base: true,
    lg: false
  }, {
    ssr: false
  });
  var _useModals = useModals(),
    toast = _useModals.toast;
  var _useSaveDraft = useSaveDraft(),
    isSaving = _useSaveDraft.isSaving,
    isSaved = _useSaveDraft.isSaved,
    saveDraft = _useSaveDraft.saveDraft;
  var hasChanges = useHasChanges();
  useEffect(function () {
    if (isSaved) {
      toast({
        title: 'Draft saved',
        description: 'Your draft has been saved',
        status: 'success'
      });
    }
  }, [isSaved]);
  var saveProps = {
    isLoading: isSaving,
    onClick: function onClick() {
      void saveDraft();
    }
  };
  if (isMobile) {
    return jsx(IconButton, _extends({
      borderRadius: "full",
      icon: jsx(Icon, {
        as: BiSave,
        boxSize: "5",
        color: hasChanges ? 'orange.200' : 'white'
      }),
      "aria-label": "Save draft"
    }, saveProps));
  }
  return jsx(Button, _extends({
    borderRadius: "full",
    leftIcon: jsx(Icon, {
      as: BiSave,
      boxSize: "5"
    }),
    rightIcon: hasChanges ? jsx(Badge, {
      size: "4",
      bg: "orange.200",
      children: "Changes"
    }) : undefined
  }, saveProps, {
    children: "Save draft"
  }));
};

var _excluded$g = ["templates", "finalFocusRef", "isOpen", "isTemplatesLoading", "onClose"];
var TemplateSelector = function TemplateSelector(_ref) {
  var selectedTemplate = _ref.selectedTemplate,
    templates = _ref.templates,
    onSelect = _ref.onSelect;
  var handleSelect = function handleSelect(templateName) {
    var newSelectedTemplate = templateName;
    if (newSelectedTemplate === selectedTemplate) {
      newSelectedTemplate = '';
    }
    onSelect(newSelectedTemplate);
  };
  if (templates.length === 0) {
    return jsx(Text, {
      size: "xs",
      color: "gray.400",
      children: "No templates found."
    });
  }
  return jsx(Fragment, {
    children: templates.map(function (_ref2, key) {
      var name = _ref2.name,
        label = _ref2.label;
      return jsx(Button, {
        variant: "outline",
        colorScheme: selectedTemplate && selectedTemplate === name ? 'pink' : 'gray',
        mr: 2,
        onClick: function onClick() {
          handleSelect(name);
        },
        children: label
      }, key);
    })
  });
};
var PageCreator = function PageCreator(_ref3) {
  var _errors$slug, _errors$template, _errors$template2, _errors$template3, _errors$template3$nam;
  var templates = _ref3.templates,
    finalFocusRef = _ref3.finalFocusRef,
    isOpen = _ref3.isOpen,
    isTemplatesLoading = _ref3.isTemplatesLoading,
    onClose = _ref3.onClose,
    form = _objectWithoutPropertiesLoose(_ref3, _excluded$g);
  var initialFocusRef = React.useRef();
  var _useModals = useModals(),
    toast = _useModals.toast;
  var _useForm = useForm({
      defaultValues: form.values
    }),
    register = _useForm.register,
    reset = _useForm.reset,
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    _useForm$formState = _useForm.formState,
    errors = _useForm$formState.errors,
    isSubmitting = _useForm$formState.isSubmitting,
    isDirty = _useForm$formState.isDirty;
  var _onSubmit = function onSubmit(values) {
    values.template = templates.find(function (e) {
      return e.name === values.template.name;
    });
    form.onSubmit(values);
    reset();
    toast({
      title: 'Page created',
      description: "Page \"" + values.slug + "\" created",
      status: 'success'
    });
  };
  var onCancel = function onCancel() {
    reset();
    onClose();
  };
  return jsxs(Modal, {
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    isOpen: isOpen,
    onClose: onClose,
    children: [jsx(ModalOverlay, {}), jsx(ModalContent, {
      children: jsxs("form", {
        onSubmit: function onSubmit(e) {
          void handleSubmit(_onSubmit)(e);
        },
        children: [jsx(ModalHeader, {
          children: "Create a page"
        }), jsx(ModalCloseButton, {}), jsxs(ModalBody, {
          pb: 6,
          children: [jsxs(FormControl, {
            mt: 4,
            isInvalid: !(errors.slug == null),
            children: [jsx(FormLabel, {
              children: "Slug"
            }), jsx(Input, _extends({
              placeholder: "the-slug"
            }, register('slug', {
              required: 'This is required',
              pattern: {
                value: /^[a-z0-9-]+$/,
                message: 'Only lowercase letters, numbers and hyphens are allowed'
              },
              validate: function validate(value) {
                var externalValidation = form.externalValidation;
                if (externalValidation) {
                  var validation = externalValidation('slug', value);
                  if (validation) {
                    return validation;
                  }
                }
                return true;
              }
            }))), errors.slug == null && jsx(FormHelperText, {
              children: "Make sure the slug is unique between siblings."
            }), jsx(FormErrorMessage, {
              children: (_errors$slug = errors.slug) == null ? void 0 : _errors$slug.message
            })]
          }), jsxs(FormControl, {
            mt: 4,
            isInvalid: !(((_errors$template = errors.template) == null ? void 0 : _errors$template.name) == null),
            children: [jsx(FormLabel, {
              children: "Template"
            }), jsx(Controller, {
              control: control,
              name: "template.name",
              rules: {
                required: 'Please select a template'
              },
              render: function render(_ref4) {
                var _ref4$field = _ref4.field,
                  value = _ref4$field.value,
                  onChange = _ref4$field.onChange;
                return jsx(Fragment, {
                  children: isTemplatesLoading ? jsx("div", {
                    children: "Loading..."
                  }) : jsx(TemplateSelector, {
                    selectedTemplate: value,
                    templates: templates,
                    onSelect: function onSelect(templateName) {
                      onChange(templateName);
                    }
                  })
                });
              }
            }), ((_errors$template2 = errors.template) == null ? void 0 : _errors$template2.name) == null && jsx(FormHelperText, {
              children: "Select the template to use for this page."
            }), jsx(FormErrorMessage, {
              children: (_errors$template3 = errors.template) == null ? void 0 : (_errors$template3$nam = _errors$template3.name) == null ? void 0 : _errors$template3$nam.message
            })]
          })]
        }), jsxs(ModalFooter, {
          children: [jsx(Button, {
            onClick: onCancel,
            variant: "ghost",
            children: "Cancel"
          }), jsx(Button, {
            ml: 3,
            isLoading: isSubmitting,
            disabled: !isDirty,
            type: "submit",
            children: "Create"
          })]
        })]
      })
    })]
  });
};

function pageUpdateValidation(_ref) {
  var name = _ref.name,
    value = _ref.value,
    parentId = _ref.parentId,
    pageTree = _ref.pageTree;
  if (name === 'slug') {
    var siblings = [];
    if (parentId) {
      var parentPage = pageTree.find(function (p) {
        return p.id === parentId;
      });
      if (parentPage) {
        for (var _iterator = _createForOfIteratorHelperLoose(parentPage.children), _step; !(_step = _iterator()).done;) {
          var child = _step.value;
          siblings.push(child.id);
        }
      }
    } else {
      for (var _iterator2 = _createForOfIteratorHelperLoose(pageTree), _step2; !(_step2 = _iterator2()).done;) {
        var page = _step2.value;
        if (page.parent == null) {
          siblings.push(page.id);
        }
      }
    }
    var slugTaken = siblings.some(function (siblingId) {
      var sibling = pageTree.find(function (p) {
        return p.id === siblingId;
      });
      if (sibling) {
        if (sibling.deleted) {
          return false;
        }
        return sibling.slug === value;
      }
      return false;
    });
    if (slugTaken) {
      return 'Slug is already taken';
    }
  }
  return '';
}

var templateLoader = function templateLoader(relativePath) {
  try {
    return Promise.resolve(import(___JAEN_SOURCE_TEMPLATES___ + "/" + relativePath)).then(function (_import) {
      return _import["default"];
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var pageLoader = function pageLoader(relativePath) {
  try {
    return Promise.resolve(import(___JAEN_SOURCE_PAGES___ + "/" + relativePath)).then(function (_import2) {
      return _import2["default"];
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var viewLoader = function viewLoader(relativePath) {
  try {
    return Promise.resolve(import(___JAEN_SOURCE_VIEWS___ + "/" + relativePath)).then(function (_import3) {
      return _import3["default"];
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var popupLoader = function popupLoader(relativePath) {
  try {
    return Promise.resolve(import(___JAEN_SOURCE_POPUPS___ + "/" + relativePath)).then(function (_import4) {
      return _import4["default"];
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var useDynamicRedirect = function useDynamicRedirect() {
  var windowPathname = typeof window !== 'undefined' ? window.location.pathname : '';
  var dynamicPaths = useAppSelector(function (state) {
    return state.page.routing.dynamicPaths;
  });
  React__default.useEffect(function () {
    var withoutTrailingSlash = windowPathname.replace(/\/$/, '');
    var pageId = dynamicPaths[withoutTrailingSlash];
    if (pageId) {
      var withDynamicPrefix = "/r#" + withoutTrailingSlash;
      void navigate(withDynamicPrefix);
    }
  }, [windowPathname]);
};

var SiteContext = React__default.createContext(undefined);
var SiteProvider = withRedux(function (_ref) {
  var children = _ref.children;
  useDynamicRedirect();
  return jsx(SiteContext.Provider, {
    value: {
      templateLoader: templateLoader,
      pageLoader: pageLoader
    },
    children: children
  });
});
var useSiteContext = function useSiteContext() {
  var context = React__default.useContext(SiteContext);
  if (context === undefined) {
    throw new Error('useSiteContext must be within SiteProvider');
  }
  return context;
};

const _iteratorSymbol$1 = typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
function _settle$1(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact$1) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }
        value = value.v;
      } else {
        value.o = _settle$1.bind(null, pact, state);
        return;
      }
    }
    if (value && value.then) {
      value.then(_settle$1.bind(null, pact, state), _settle$1.bind(null, pact, 2));
      return;
    }
    pact.s = state;
    pact.v = value;
    var observer = pact.o;
    if (observer) {
      observer(pact);
    }
  }
}
var _Pact$1 = /*#__PURE__*/function () {
  function _Pact() {}
  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;
    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;
      if (callback) {
        try {
          _settle$1(result, 1, callback(this.v));
        } catch (e) {
          _settle$1(result, 2, e);
        }
        return result;
      } else {
        return this;
      }
    }
    this.o = function (_this) {
      try {
        var value = _this.v;
        if (_this.s & 1) {
          _settle$1(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle$1(result, 1, onRejected(value));
        } else {
          _settle$1(result, 2, value);
        }
      } catch (e) {
        _settle$1(result, 2, e);
      }
    };
    return result;
  };
  return _Pact;
}();
function _isSettledPact$1(thenable) {
  return thenable instanceof _Pact$1 && thenable.s & 1;
}
function _forTo$1(array, body, check) {
  var i = -1,
    pact,
    reject;
  function _cycle(result) {
    try {
      while (++i < array.length && (!check || !check())) {
        result = body(i);
        if (result && result.then) {
          if (_isSettledPact$1(result)) {
            result = result.v;
          } else {
            result.then(_cycle, reject || (reject = _settle$1.bind(null, pact = new _Pact$1(), 2)));
            return;
          }
        }
      }
      if (pact) {
        _settle$1(pact, 1, result);
      } else {
        pact = result;
      }
    } catch (e) {
      _settle$1(pact || (pact = new _Pact$1()), 2, e);
    }
  }
  _cycle();
  return pact;
}
function _forOf$1(target, body, check) {
  if (typeof target[_iteratorSymbol$1] === "function") {
    var _cycle = function _cycle(result) {
      try {
        while (!(step = iterator.next()).done && (!check || !check())) {
          result = body(step.value);
          if (result && result.then) {
            if (_isSettledPact$1(result)) {
              result = result.v;
            } else {
              result.then(_cycle, reject || (reject = _settle$1.bind(null, pact = new _Pact$1(), 2)));
              return;
            }
          }
        }
        if (pact) {
          _settle$1(pact, 1, result);
        } else {
          pact = result;
        }
      } catch (e) {
        _settle$1(pact || (pact = new _Pact$1()), 2, e);
      }
    };
    var iterator = target[_iteratorSymbol$1](),
      step,
      pact,
      reject;
    _cycle();
    if (iterator["return"]) {
      var _fixup = function _fixup(value) {
        try {
          if (!step.done) {
            iterator["return"]();
          }
        } catch (e) {}
        return value;
      };
      if (pact && pact.then) {
        return pact.then(_fixup, function (e) {
          throw _fixup(e);
        });
      }
      _fixup();
    }
    return pact;
  }
  // No support for Symbol.iterator
  if (!("length" in target)) {
    throw new TypeError("Object is not iterable");
  }
  // Handle live collections properly
  var values = [];
  for (var i = 0; i < target.length; i++) {
    values.push(target[i]);
  }
  return _forTo$1(values, function (i) {
    return body(values[i]);
  }, check);
}
var useJaenTemplates = function useJaenTemplates() {
  var site = useSiteContext();
  var _useAdminStaticQuery = useAdminStaticQuery(),
    jaenTemplates = _useAdminStaticQuery.jaenTemplate.nodes;
  var _React$useState = React__default.useState(true),
    isLoading = _React$useState[0],
    setIsLoading = _React$useState[1];
  var _React$useState2 = React__default.useState(null),
    templates = _React$useState2[0],
    setTemplates = _React$useState2[1];
  React__default.useEffect(function () {
    var load = function load() {
      try {
        var _temp5 = function _temp5() {
          setTemplates(tmpls);
          setIsLoading(false);
        };
        setIsLoading(true);
        var tmpls = {};
        var _temp4 = _forOf$1(jaenTemplates, function (templateNode) {
          var loadTemplate = templateNode.name;
          var _temp3 = function () {
            if (loadTemplate && !(loadTemplate in (templates || {}))) {
              return Promise.resolve(site.templateLoader(loadTemplate)).then(function (Component) {
                function _temp2() {
                  tmpls[loadTemplate] = {
                    name: loadTemplate,
                    label: Component.options.label,
                    children: children,
                    isRootTemplate: Component.options.isRootTemplate
                  };
                }
                var children = [];
                var _temp = _forOf$1(Component.options.children, function (child) {
                  return Promise.resolve(site.templateLoader(child)).then(function (ad) {
                    children.push({
                      name: child,
                      label: ad.options.label
                    });
                  });
                });
                return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
              });
            }
          }();
          if (_temp3 && _temp3.then) return _temp3.then(function () {});
        });
        return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp5) : _temp5(_temp4));
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void load();
  }, []);
  var templatesArray = React__default.useMemo(function () {
    return Object.values(templates || {});
  }, [templates]);
  return {
    templates: templatesArray,
    isLoading: isLoading
  };
};

var loadTemplatesForPage = function loadTemplatesForPage(_ref) {
  var page = _ref.page,
    templates = _ref.templates;
  try {
    var _temp4 = function _temp4(_result3) {
      return _exit ? _result3 : [];
    };
    var _exit;
    var _temp3 = function () {
      if (page == null) {
        _exit = 1;
        return templates;
      } else return function () {
        if (page.template) {
          var _templates$find;
          var _temp = ((_templates$find = templates.find(function (template) {
            return template.name === page.template;
          })) == null ? void 0 : _templates$find.children) || [];
          _exit = 1;
          return _temp;
        } else return function () {
          if (page.componentName) {
            return Promise.resolve(pageLoader(page.componentName)).then(function (loadedPage) {
              var _loadedPage$options, _loadedPage$options$c;
              var _temp2 = (loadedPage == null ? void 0 : (_loadedPage$options = loadedPage.options) == null ? void 0 : (_loadedPage$options$c = _loadedPage$options.children) == null ? void 0 : _loadedPage$options$c.map(function (child) {
                var t = templates.find(function (template) {
                  return template.name === child;
                });
                if (t == null) {
                  throw new Error("Could not find template " + child);
                }
                return {
                  name: child,
                  label: t.label
                };
              })) || [];
              _exit = 1;
              return _temp2;
            });
          }
        }();
      }();
    }();
    return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3));
  } catch (e) {
    return Promise.reject(e);
  }
};
var useTemplatesForPage = function useTemplatesForPage(page) {
  var _useState = useState(false),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var _useState2 = useState([]),
    templates = _useState2[0],
    setTemplates = _useState2[1];
  var jaenTemplates = useJaenTemplates();
  useEffect(function () {
    var load = function load() {
      try {
        setIsLoading(true);
        return Promise.resolve(loadTemplatesForPage({
          page: page,
          templates: jaenTemplates.templates
        })).then(function (templates) {
          setTemplates(templates);
          setIsLoading(false);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    if (!jaenTemplates.isLoading) {
      void load();
    }
  }, [page, jaenTemplates.templates]);
  return {
    isLoading: isLoading,
    templates: templates,
    allTemplates: jaenTemplates.templates
  };
};

var getStatePages = function getStatePages(state) {
  return Object.keys(state.page.pages.nodes).map(function (id) {
    var page = state.page.pages.nodes[id];
    if (page == null) {
      throw new Error('Page not found');
    }
    var slug = page.slug,
      parent = page.parent,
      children = page.children,
      jaenPageMetadata = page.jaenPageMetadata,
      template = page.template,
      deleted = page.deleted,
      excludedFromIndex = page.excludedFromIndex;
    return _extends({
      id: id
    }, slug && {
      slug: slug
    }, parent !== undefined && {
      parent: parent
    }, children && {
      children: children
    }, jaenPageMetadata && {
      jaenPageMetadata: jaenPageMetadata
    }, template && {
      template: template
    }, deleted && {
      deleted: deleted
    }, excludedFromIndex && {
      excludedFromIndex: excludedFromIndex
    });
  });
};
var mergeStaticWithStatePages = function mergeStaticWithStatePages(staticPages, statePages) {
  return staticPages.concat(statePages.filter(function (item) {
    return staticPages.findIndex(function (n) {
      return n.id === item.id;
    }) === -1;
  })).map(function (_ref) {
    var id = _ref.id;
    var p1 = staticPages.find(function (e) {
      return e.id === id;
    });
    var p2 = statePages.find(function (e) {
      return e.id === id;
    });
    var merged = deepmerge(p1 || {}, p2 || {}, {
      arrayMerge: deepmergeArrayIdMerge
    });
    return merged;
  });
};
var useJaenPageTree = function useJaenPageTree(options) {
  var _useAdminStaticQuery = useAdminStaticQuery(),
    staticPages = _useAdminStaticQuery.allJaenPage.nodes;
  var pages = useAppDeepEqualSelector(function (state) {
    return getStatePages(state);
  });
  var mergeData = useMemo(function () {
    return mergeStaticWithStatePages(staticPages, pages);
  }, [staticPages, pages]);
  var filteredData = useMemo(function () {
    return mergeData.filter(function (item) {
      return !['JaenPage /admin', 'JaenPage /admin/login'].includes(item.id);
    });
  }, [mergeData]);
  var cleanPages = useMemo(function () {
    if (options != null && options.includeDeleted) return filteredData;
    var pages = [];
    for (var _iterator = _createForOfIteratorHelperLoose(filteredData), _step; !(_step = _iterator()).done;) {
      var page = _step.value;
      if (page.deleted) {
        continue;
      }
      var newIndex = pages.push(page) - 1;
      if (page.children.length > 0) {
        for (var _iterator2 = _createForOfIteratorHelperLoose(page.children.entries()), _step2; !(_step2 = _iterator2()).done;) {
          var _step2$value = _step2.value,
            childIndex = _step2$value[0],
            child = _step2$value[1];
          if (child.deleted) {
            continue;
          }
          pages[newIndex].children[childIndex] = child;
        }
      }
    }
    return pages;
  }, [filteredData, options == null ? void 0 : options.includeDeleted]);
  return cleanPages;
};

var AdminPageManagerContext = React__default.createContext(undefined);
var usePageManager = function usePageManager() {
  var context = React__default.useContext(AdminPageManagerContext);
  if (context == null) {
    throw new Error('usePageManager must be used within a AdminPageManagerContext');
  }
  return context;
};

var _excluded$f = ["children"];
var AdminPageManagerProvider = function AdminPageManagerProvider(_ref) {
  var children = _ref.children,
    contextValue = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  return jsx(AdminPageManagerContext.Provider, {
    value: contextValue,
    children: children
  });
};

var PageManagerProvider = function PageManagerProvider(_ref) {
  var children = _ref.children;
  var rootPageId = 'JaenPage /';
  var dispatch = useAppDispatch();
  var pageTree = useJaenPageTree({
    includeDeleted: true
  });
  var latestAddedPageId = useAppSelector(function (state) {
    return state.page.pages.lastAddedNodeId;
  });
  var _React$useState = React__default.useState(null),
    shouldUpdateDpathsFor = _React$useState[0],
    setShouldUpdateDpathsFor = _React$useState[1];
  React__default.useEffect(function () {
    if (shouldUpdateDpathsFor) {
      var pageId = shouldUpdateDpathsFor.pageId,
        create = shouldUpdateDpathsFor.create;
      dispatch(actions.updateDynamicPaths({
        jaenPageTree: pageTree,
        pageId: pageId,
        create: create
      }));
      setShouldUpdateDpathsFor(null);
    }
  }, [pageTree]);
  React__default.useEffect(function () {
    if (latestAddedPageId) {
      dispatch(actions.updateDynamicPaths({
        jaenPageTree: pageTree,
        pageId: latestAddedPageId,
        create: true
      }));
    }
  }, [latestAddedPageId]);
  var handlePageGet = React__default.useCallback(function (id) {
    var jaenPage = pageTree.find(function (p) {
      return p.id === id;
    });
    if (jaenPage == null) {
      jaenPage = pageTree.find(function (p) {
        return p.id === latestAddedPageId;
      });
    }
    if (jaenPage == null) {
      return null;
    }
    return jaenPage;
  }, [pageTree]);
  var getPageIdFromPath = React__default.useCallback(function (path) {
    var page = pageTree.find(function (p) {
      var pagePath = generatePageOriginPath(pageTree, p);
      return pagePath && matchPath(path, pagePath) && !p.deleted;
    });
    if (!(page != null && page.id)) return null;
    return page.id;
  }, [pageTree]);
  var getPathFromPageId = React__default.useCallback(function (pageId) {
    var page = pageTree.find(function (p) {
      return p.id === pageId;
    });
    if (page == null) {
      return null;
    }
    return generatePageOriginPath(pageTree, page) || null;
  }, [pageTree]);
  var handlePageCreate = React__default.useCallback(function (parentId, values) {
    return dispatch(actions.page_updateOrCreate({
      parent: {
        id: parentId || rootPageId
      },
      slug: values.slug,
      jaenPageMetadata: {
        title: values.title
      },
      template: values.template.name
    }));
  }, []);
  var handlePageDelete = React__default.useCallback(function (id) {
    setShouldUpdateDpathsFor({
      pageId: id,
      create: false
    });
    dispatch(actions.page_markForDeletion(id));
  }, [pageTree]);
  var handlePageMove = React__default.useCallback(function (id, oldParentId, newParentId) {
    setShouldUpdateDpathsFor({
      pageId: id,
      create: true
    });
    dispatch(actions.page_updateOrCreate({
      id: id,
      parent: newParentId ? {
        id: newParentId
      } : null,
      fromId: oldParentId || undefined
    }));
  }, []);
  var handlePageUpdate = React__default.useCallback(function (id, values) {
    if ('slug' in values) {
      setShouldUpdateDpathsFor({
        pageId: id,
        create: true
      });
    }
    dispatch(actions.page_updateOrCreate({
      id: id,
      slug: values.slug,
      jaenPageMetadata: {
        title: values.title,
        description: values.description,
        image: values.image
      },
      excludedFromIndex: values.excludedFromIndex
    }));
  }, []);
  var handlePageNavigate = React__default.useCallback(function (path) {
    void navigate(path);
  }, []);
  var pagePaths = React__default.useMemo(function () {
    var paths = generateAllPaths(pageTree);
    return Object.keys(paths).map(function (path) {
      var pageId = paths[path];
      var page = pageTree.find(function (p) {
        return p.id === pageId;
      });
      if (page == null || page.deleted) {
        return undefined;
      }
      var isRoot = path === '/';
      return {
        path: path,
        title: page.slug || 'root',
        isLocked: isRoot || !page.template
      };
    }).filter(Boolean);
  }, [pageTree]);
  var _React$useState2 = React__default.useState(null),
    creatorState = _React$useState2[0],
    setCreatorState = _React$useState2[1];
  var parentCreatorPage = React__default.useMemo(function () {
    return creatorState != null && creatorState.parentId ? handlePageGet(creatorState.parentId) : null;
  }, [creatorState]);
  var templates = useTemplatesForPage(parentCreatorPage);
  var creator = useDisclosure();
  var handleCreatorToggle = function handleCreatorToggle(parentId) {
    setCreatorState({
      parentId: parentId
    });
    creator.onToggle();
  };
  var handleCreatorClose = function handleCreatorClose() {
    setCreatorState(null);
    creator.onClose();
  };
  var handleCreatorSubmit = function handleCreatorSubmit(values) {
    if (creatorState) {
      handlePageCreate(creatorState == null ? void 0 : creatorState.parentId, values);
    }
    handleCreatorClose();
  };
  return jsxs(AdminPageManagerProvider, {
    latestAddedPageId: latestAddedPageId,
    getPageIdFromPath: getPageIdFromPath,
    getPathFromPageId: getPathFromPageId,
    onCreate: handlePageCreate,
    onDelete: handlePageDelete,
    onMove: handlePageMove,
    onUpdate: handlePageUpdate,
    onGet: handlePageGet,
    onNavigate: handlePageNavigate,
    pageTree: pageTree,
    pagePaths: pagePaths,
    templates: templates.allTemplates,
    isTemplatesLoading: templates.isLoading,
    rootPageId: rootPageId,
    onToggleCreator: handleCreatorToggle,
    children: [jsx(PageCreator, {
      finalFocusRef: null,
      isTemplatesLoading: templates.isLoading,
      values: {
        slug: '',
        template: {
          name: '',
          label: ''
        }
      },
      templates: templates.templates,
      isOpen: creator.isOpen,
      onClose: handleCreatorClose,
      onSubmit: handleCreatorSubmit,
      externalValidation: function externalValidation(name, value) {
        return pageUpdateValidation({
          name: name,
          value: value,
          pageTree: pageTree,
          parentId: creatorState == null ? void 0 : creatorState.parentId
        });
      }
    }), children]
  });
};

var ContextMenuEvent;
(function (ContextMenuEvent) {
  ContextMenuEvent["Open"] = "contextmenu.open";
  ContextMenuEvent["Close"] = "contextmenu.close";
})(ContextMenuEvent || (ContextMenuEvent = {}));
function ContextMenu(props) {
  var _props$menuProps2;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = useState(false),
    isRendered = _useState2[0],
    setIsRendered = _useState2[1];
  var _useState3 = useState(false),
    isDeferredOpen = _useState3[0],
    setIsDeferredOpen = _useState3[1];
  var _useState4 = useState([0, 0]),
    position = _useState4[0],
    setPosition = _useState4[1];
  var targetRef = useRef(null);
  useEffect(function () {
    if (isOpen) {
      var timeout = setTimeout(function () {
        setIsRendered(true);
        var timeout = setTimeout(function () {
          setIsDeferredOpen(true);
        });
        return function () {
          clearTimeout(timeout);
        };
      });
      return function () {
        clearTimeout(timeout);
      };
    } else {
      setIsDeferredOpen(false);
      var _timeout = setTimeout(function () {
        setIsRendered(isOpen);
      }, 1000);
      return function () {
        clearTimeout(_timeout);
      };
    }
  }, [isOpen]);
  var handleEventOpen = useCallback(function (e) {
    var _targetRef$current;
    if (e.detail === 27 || (_targetRef$current = targetRef.current) != null && _targetRef$current.contains(e.target) || e.target === targetRef.current) {
      var x = e.clientX;
      var y = e.clientY;
      e.preventDefault();
      setIsOpen(true);
      setPosition([x, y]);
    } else {
      setIsOpen(false);
    }
  }, [targetRef]);
  var handleCloseEvent = useCallback(function () {
    setIsOpen(false);
  }, []);
  useEventListener('contextmenu', handleEventOpen);
  useEventListener(ContextMenuEvent.Open, handleEventOpen, targetRef.current);
  useEventListener(ContextMenuEvent.Close, handleCloseEvent, targetRef.current);
  var onCloseHandler = useCallback(function () {
    var _props$menuProps;
    (_props$menuProps = props.menuProps) == null ? void 0 : _props$menuProps.onClose == null ? void 0 : _props$menuProps.onClose();
    setIsOpen(false);
  }, [(_props$menuProps2 = props.menuProps) == null ? void 0 : _props$menuProps2.onClose, setIsOpen]);
  return jsxs(Fragment, {
    children: [props.children(targetRef), isRendered && jsx(Portal, _extends({}, props.portalProps, {
      children: jsxs(Menu, _extends({
        isOpen: isDeferredOpen,
        gutter: 0
      }, props.menuProps, {
        onClose: onCloseHandler,
        children: [jsx(MenuButton, _extends({
          "aria-hidden": true,
          w: 1,
          h: 1,
          style: {
            position: 'absolute',
            left: position[0],
            top: position[1],
            cursor: 'default'
          }
        }, props.menuButtonProps)), props.renderMenu()]
      }))
    }))]
  });
}

var _excluded$e = ["isNavigatorMode", "onSelectPage", "onViewPage", "onAddPage", "onDeletePage", "onMovePage", "nodes", "defaultSelectedPath", "selectedPath"];
var useTreeState = function useTreeState(initTreeData, opt) {
  var _React$useState = React__default.useState(initTreeData),
    treeData = _React$useState[0],
    setTreeData = _React$useState[1];
  useEffect(function () {
    setTreeData(initTreeData);
  }, [initTreeData]);
  var _ref = opt || {},
    shouldPerformDrop = _ref.shouldPerformDrop,
    onViewPage = _ref.onViewPage,
    onSelectPage = _ref.onSelectPage,
    defaultSelectedPath = _ref.defaultSelectedPath,
    selectedPath = _ref.selectedPath,
    isNavigatorMode = _ref.isNavigatorMode;
  var onSelect = function onSelect(selectedKeys, info) {
    var _selectedKeys$;
    var path = ((_selectedKeys$ = selectedKeys[0]) == null ? void 0 : _selectedKeys$.toString()) || '/';
    if (isNavigatorMode) {
      onViewPage == null ? void 0 : onViewPage(path);
    } else {
      if (selectedKeys.length === 0) {
        onViewPage == null ? void 0 : onViewPage(info.node.key.toString());
      } else {
        onSelectPage == null ? void 0 : onSelectPage(path);
      }
    }
  };
  var onDrop = function onDrop(info) {
    if (isNavigatorMode) {
      return;
    }
    var dropKey = info.node.key;
    var dragKey = info.dragNode.key;
    var dropPos = info.node.pos.split('-');
    var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
    if (shouldPerformDrop && !shouldPerformDrop({
      dragNode: info.dragNode,
      node: info.node,
      dropPosition: dropPosition
    })) {
      return;
    }
    var loop = function loop(data, key, callback) {
      data.forEach(function (item, index, arr) {
        if (item.key === key) {
          callback(item, index, arr);
          return;
        }
        if (item.children) {
          loop(item.children, key, callback);
        }
      });
    };
    var data = [].concat(treeData);
    var dragObj;
    loop(data, dragKey, function (item, index, arr) {
      arr.splice(index, 1);
      dragObj = item;
    });
    if (dropPosition === 0) {
      loop(data, dropKey, function (item) {
        item.children = item.children || [];
        item.children.unshift(dragObj);
      });
    } else {
      var ar = [];
      var i = 0;
      loop(data, dropKey, function (_item, index, arr) {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }
    setTreeData(data);
    if (opt != null && opt.onMovePage) {
      opt.onMovePage({
        dragPath: dragKey.toString(),
        dropPath: dropKey.toString(),
        dragParentPath: getParentNodePath(dragKey.toString())
      });
    }
  };
  var onDragEnter = function onDragEnter() {};
  var onDragStart = function onDragStart() {};
  var defaultCheckedKeys = [];
  var defaultSelectedKeys = defaultSelectedPath ? [defaultSelectedPath] : [];
  var selectedKeys = selectedPath ? [selectedPath] : undefined;
  var getParentNodePath = function getParentNodePath(path) {
    path = path.replace(/\/$/, '');
    var parts = path.split('/');
    if (parts.length === 1) {
      return '/';
    }
    parts.pop();
    return parts.join('/') + '/';
  };
  return {
    onSelect: onSelect,
    defaultCheckedKeys: defaultCheckedKeys,
    defaultSelectedKeys: defaultSelectedKeys,
    selectedKeys: selectedKeys,
    treeData: treeData,
    onDrop: onDrop,
    onDragEnter: onDragEnter,
    onDragStart: onDragStart
  };
};
var nodesToTreeData = function nodesToTreeData(nodes) {
  var treeData = [];
  nodes.forEach(function (node) {
    var pathParts = node.path.split('/').filter(Boolean);
    var title = node.title;
    var currentTreeData = treeData;
    pathParts.forEach(function (pathPart, index) {
      var isLast = index === pathParts.length - 1;
      var curPath = "/" + pathParts.slice(0, index + 1).join('/') + "/";
      var existingNode = currentTreeData.find(function (treeDataNode) {
        return treeDataNode.key === curPath;
      });
      if (existingNode) {
        if (isLast) {
          existingNode.title = title;
        }
        currentTreeData = existingNode.children || [];
      } else {
        var newNode = {
          key: curPath,
          title: isLast ? title : pathPart,
          children: []
        };
        currentTreeData.push(newNode);
        currentTreeData = newNode.children || [];
      }
    });
  });
  var rootNode = nodes.find(function (node) {
    return node.path === '/';
  }) || {
    title: 'root',
    path: '/',
    isLocked: true
  };
  return [{
    key: rootNode.path,
    title: rootNode.title,
    children: treeData
  }];
};
var PageTree = function PageTree(_ref2) {
  var isNavigatorMode = _ref2.isNavigatorMode,
    onSelectPage = _ref2.onSelectPage,
    onViewPage = _ref2.onViewPage,
    onAddPage = _ref2.onAddPage,
    onDeletePage = _ref2.onDeletePage,
    onMovePage = _ref2.onMovePage,
    nodes = _ref2.nodes,
    defaultSelectedPath = _ref2.defaultSelectedPath,
    selectedPath = _ref2.selectedPath,
    boxProps = _objectWithoutPropertiesLoose(_ref2, _excluded$e);
  var getNodeFromDataNode = function getNodeFromDataNode(dataNode) {
    var node = nodes.find(function (node) {
      return matchPath(node.path, dataNode.key.toString());
    });
    if (node == null) {
      return {
        title: 'Loading...',
        path: '/',
        isLocked: true
      };
    }
    return node;
  };
  var initTreeData = useMemo(function () {
    return nodesToTreeData((nodes == null ? void 0 : nodes.length) > 0 ? nodes : [{
      path: '/',
      title: 'root',
      isLocked: true
    }]);
  }, [nodes]);
  var _useTreeState = useTreeState(initTreeData, {
      isNavigatorMode: isNavigatorMode,
      onViewPage: onViewPage,
      onSelectPage: onSelectPage,
      onMovePage: onMovePage,
      shouldPerformDrop: function shouldPerformDrop(_ref3) {
        var dragNode = _ref3.dragNode,
          dropPosition = _ref3.dropPosition;
        if (getNodeFromDataNode(dragNode).isLocked) {
          return false;
        }
        if (dropPosition === -1) {
          return false;
        }
        return true;
      },
      defaultSelectedPath: defaultSelectedPath,
      selectedPath: selectedPath
    }),
    _onSelect = _useTreeState.onSelect,
    onDrop = _useTreeState.onDrop,
    defaultCheckedKeys = _useTreeState.defaultCheckedKeys,
    defaultSelectedKeys = _useTreeState.defaultSelectedKeys,
    selectedKeys = _useTreeState.selectedKeys,
    treeData = _useTreeState.treeData;
  var contextRefs = React__default.useRef({});
  return jsx(Box, _extends({
    overflowY: "auto",
    userSelect: "none",
    h: "full"
  }, boxProps, {
    children: jsx(Tree, {
      titleRender: function titleRender(node) {
        var _node$children;
        var childrenLength = ((_node$children = node.children) == null ? void 0 : _node$children.length) || 0;
        var data = getNodeFromDataNode(node);
        return jsx(ContextMenu, {
          renderMenu: function renderMenu() {
            return jsx(Fragment, {
              children: !isNavigatorMode && jsxs(MenuList, {
                children: [jsx(MenuItem, {
                  icon: jsx(AddIcon, {}),
                  onClick: function onClick() {
                    onAddPage == null ? void 0 : onAddPage(node.key.toString());
                  },
                  children: "Add"
                }), jsx(MenuItem, {
                  icon: jsx(FaEye, {}),
                  onClick: function onClick() {
                    onViewPage == null ? void 0 : onViewPage(node.key.toString());
                  },
                  children: "View"
                }), jsx(MenuDivider, {}), jsx(MenuItem, {
                  isDisabled: data.isLocked,
                  icon: jsx(DeleteIcon, {
                    color: "red"
                  }),
                  onClick: function onClick() {
                    onDeletePage == null ? void 0 : onDeletePage(node.key.toString());
                  },
                  children: "Delete"
                })]
              })
            });
          },
          children: function children(ref) {
            contextRefs.current[node.key] = ref;
            return jsxs(HStack, {
              ref: ref,
              w: "full",
              h: "full",
              py: "2",
              px: "2",
              children: [jsx(Icon, {
                as: HiDocument,
                backgroundColor: "white"
              }), jsx(Text, {
                whiteSpace: "break-spaces",
                wordBreak: "break-word",
                noOfLines: 1,
                as: "span",
                w: "full",
                h: "full",
                children: jsx(Fragment, {
                  children: node.title
                })
              }), childrenLength > 0 && jsx(Tooltip$1, {
                label: childrenLength + " total child pages",
                children: jsx(Tag, {
                  size: "sm",
                  colorScheme: "gray",
                  children: childrenLength
                })
              }), data.isLocked && jsx(Icon, {
                as: HiLockClosed
              })]
            });
          }
        });
      },
      showLine: true,
      checkStrictly: true,
      defaultExpandAll: true,
      draggable: true,
      onDragStart: function onDragStart(_event) {},
      onDragEnter: function onDragEnter(_event) {},
      onDrop: onDrop,
      autoExpandParent: true,
      defaultSelectedKeys: defaultSelectedKeys,
      defaultCheckedKeys: defaultCheckedKeys,
      selectedKeys: selectedKeys,
      onSelect: function onSelect(keys, info) {
        var _ref$current;
        var nativeEvent = info.nativeEvent;
        var ref = contextRefs.current[info.node.key];
        if (!(ref != null && ref.current && ref != null && (_ref$current = ref.current) != null && _ref$current.contains(nativeEvent.target))) {
          return;
        }
        _onSelect(keys, info);
      },
      onRightClick: function onRightClick(info) {
        var event = info.event,
          node = info.node;
        event.preventDefault();
        event.stopPropagation();
        var ref = contextRefs.current[node.key];
        if (ref != null && ref.current) {
          ref.current.dispatchEvent(new MouseEvent(ContextMenuEvent.Open, {
            bubbles: true,
            cancelable: true,
            view: window,
            button: 2,
            buttons: 2,
            clientX: event.clientX,
            clientY: event.clientY
          }));
          for (var key in contextRefs.current) {
            if (key !== node.key) {
              var _contextRefs$current$, _contextRefs$current$2;
              (_contextRefs$current$ = contextRefs.current[key]) == null ? void 0 : (_contextRefs$current$2 = _contextRefs$current$.current) == null ? void 0 : _contextRefs$current$2.dispatchEvent(new MouseEvent(ContextMenuEvent.Close));
            }
          }
        }
      },
      icon: jsx(Fragment, {}),
      treeData: treeData,
      switcherIcon: function switcherIcon(nodeProps) {
        if (nodeProps.isLeaf) {
          return null;
        }
        return jsx(Icon, {
          as: nodeProps.expanded ? HiMinus : HiPlus,
          backgroundColor: "white"
        });
      }
    })
  }));
};

var PageNavigator = function PageNavigator() {
  var windowPath = typeof window !== 'undefined' && window.location.pathname;
  var path = useMemo(function () {
    if (typeof window === 'undefined') return null;
    var pathname = window.location.pathname;
    var hash = window.location.hash;
    if (hash) {
      pathname = hash.replace('#', '');
    }
    return pathname;
  }, [windowPath]);
  var title = typeof window !== 'undefined' && window.document.title || path || 'No Title';
  var manager = usePageManager();
  return jsx(Menu, {
    children: function children(_ref) {
      var isOpen = _ref.isOpen;
      return jsxs(Fragment, {
        children: [jsx(Tooltip$1, {
          label: "Navigation",
          children: jsx(MenuButton, {
            as: Button,
            leftIcon: jsx(FaSitemap, {}),
            rightIcon: isOpen ? jsx(ChevronUpIcon, {}) : jsx(ChevronDownIcon, {}),
            fontWeight: "normal",
            size: "sm",
            w: {
              base: '24',
              md: '44'
            },
            rounded: "lg",
            bg: "gray.50",
            color: "gray.500",
            _hover: {
              bg: 'pink.50'
            },
            py: {
              base: 1
            },
            px: {
              base: 2
            },
            _active: {
              bg: 'pink.100'
            },
            children: jsx(Text, {
              isTruncated: true,
              children: title
            })
          })
        }), jsx(MenuList, {
          bg: "white",
          color: "black",
          h: "xs",
          overflowY: "auto",
          px: "2",
          py: "1",
          children: jsx(PageTree, {
            nodes: manager.pagePaths,
            isNavigatorMode: true,
            selectedPath: path || '/',
            onViewPage: manager.onNavigate
          })
        })]
      });
    }
  });
};

var ActionBar = function ActionBar() {
  return jsx(Fragment, {
    children: jsxs(HStack, {
      color: "gray.500",
      w: "full",
      justifyItems: "start",
      display: {
        base: 'none',
        md: 'flex'
      },
      children: [jsx(PageManagerProvider, {
        children: jsx(PageNavigator, {})
      }), jsxs(ButtonGroup, {
        isAttached: true,
        variant: "solid",
        size: "sm",
        children: [jsx(EditActionButton, {}), jsx(DiscardActionButton, {}), jsx(SaveDraftActionButton, {}), jsx(PublishActionButton, {})]
      })]
    })
  });
};

function LocationBreadcrumbs() {
  var _useState = useState([]),
    breadcrumbs = _useState[0],
    setBreadcrumbs = _useState[1];
  useEffect(function () {
    var hash = window.location.hash.split('#')[1];
    var hashParts = (hash == null ? void 0 : hash.split('/').filter(function (part) {
      return part !== '';
    })) || [];
    var newBreadcrumbs = hashParts.map(function (part, index) {
      var isLast = index === hashParts.length - 1;
      var path = hashParts.slice(0, index + 1).join('/');
      return {
        path: path,
        name: part,
        isLast: isLast
      };
    });
    setBreadcrumbs(newBreadcrumbs);
  }, [window.location.hash]);
  return jsx(Breadcrumb, {
    spacing: "1",
    separator: jsx(ChevronRightIcon, {
      color: "gray.500"
    }),
    fontSize: "sm",
    children: breadcrumbs.length > 0 ? breadcrumbs.map(function (breadcrumb) {
      return jsx(BreadcrumbItem, {
        children: jsx(BreadcrumbLink, {
          href: "#/" + breadcrumb.path,
          textTransform: "capitalize",
          children: jsx(Tag, {
            colorScheme: breadcrumb.isLast ? 'gray' : 'pink',
            children: breadcrumb.name
          })
        })
      }, breadcrumb.path);
    }) : jsx(BreadcrumbItem, {
      children: jsx(BreadcrumbLink, {
        href: "#/",
        textTransform: "capitalize",
        children: jsx(Tag, {
          colorScheme: "gray",
          children: "Home"
        })
      })
    }, "/")
  });
}

var ToolbarActionContext = createContext({
  actions: [],
  register: function register() {}
});
var useToolbarActions = function useToolbarActions() {
  var context = useContext(ToolbarActionContext);
  if (!context) {
    throw new Error('useToolbarActions must be used within a ToolbarActionProvider');
  }
  return context;
};
var ToolbarActionProvider = function ToolbarActionProvider(_ref) {
  var children = _ref.children;
  var _useState = useState([]),
    elements = _useState[0],
    setElements = _useState[1];
  return jsx(ToolbarActionContext.Provider, {
    value: {
      actions: elements,
      register: function register(elements) {
        setElements(elements);
      }
    },
    children: children
  });
};

var AdminSecondaryToolbar = function AdminSecondaryToolbar(_ref) {
  var isSidebarOpen = _ref.isSidebarOpen,
    onToggleSidebar = _ref.onToggleSidebar;
  return jsx(ThemeProvider, {
    children: jsxs(Flex, {
      minH: "12",
      w: "full",
      align: "center",
      px: {
        base: 4
      },
      boxShadow: "md",
      borderTop: "1px",
      borderTopColor: "gray.200",
      bg: "white",
      children: [jsxs(HStack, {
        children: [jsx(IconButton, {
          "aria-label": "Open sidebar",
          icon: jsx(HamburgerIcon, {}),
          fontSize: "xl",
          variant: "ghost",
          colorScheme: "gray",
          onClick: onToggleSidebar,
          isActive: isSidebarOpen
        }), jsx(LocationBreadcrumbs, {})]
      }), jsx(Spacer, {}), jsx(ToolbarActionContext.Consumer, {
        children: function children(actions) {
          return jsx(HStack, {
            spacing: "4",
            children: actions.actions.map(function (action, index) {
              return jsx(Box, {
                children: action
              }, index);
            })
          });
        }
      })]
    })
  });
};

function _catch$3(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var useImportDraft = function useImportDraft() {
  var _useState = useState({}),
    file = _useState[0],
    setFile = _useState[1];
  var _useState2 = useState(false),
    isImporting = _useState2[0],
    setIsImporting = _useState2[1];
  var _useState3 = useState(false),
    isImported = _useState3[0],
    setIsImported = _useState3[1];
  var handleFileSelect = function handleFileSelect(event) {
    var _event$target$files;
    setIsImporting(true);
    var selectedFile = (_event$target$files = event.target.files) == null ? void 0 : _event$target$files[0];
    if (!selectedFile) return;
    var reader = new FileReader();
    reader.onload = function (event) {
      try {
        var _event$target;
        var content = ((_event$target = event.target) == null ? void 0 : _event$target.result) || '{}';
        var _temp = _catch$3(function () {
          var parsed = JSON.parse(content);
          setFile(parsed);
          setIsImported(true);
          return Promise.resolve(insertMigration(parsed)).then(function () {});
        }, function () {
          alert('Please upload a valid JSON file.');
          setIsImporting(false);
        });
        return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    reader.readAsText(selectedFile);
  };
  var handleImportClick = useCallback(function () {
    setIsImporting(true);
    setIsImported(false);
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = '.jaen';
    input.onchange = function (e) {
      handleFileSelect(e);
    };
    input.click();
  }, []);
  return {
    file: file,
    isImporting: isImporting,
    isImported: isImported,
    handleImportClick: handleImportClick
  };
};

var _excluded$d = ["withoutShadow"];
var AdminToolbar = function AdminToolbar(_ref) {
  var withoutShadow = _ref.withoutShadow,
    stackProps = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var isOnJaenAdmin = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
  var _useModals = useModals(),
    toast = _useModals.toast;
  var _useAuthentication = useAuthentication(),
    logout = _useAuthentication.logout,
    isLoading = _useAuthentication.isLoading,
    user = _useAuthentication.user;
  var _useImportDraft = useImportDraft(),
    handleImportClick = _useImportDraft.handleImportClick,
    isImported = _useImportDraft.isImported;
  useEffect(function () {
    if (isImported) {
      window.location.reload();
      toast({
        title: 'Draft imported',
        description: 'Your draft has been imported',
        status: 'success'
      });
    }
  }, [isImported]);
  return jsxs(HStack, _extends({}, stackProps, {
    spacing: {
      base: 0,
      md: 2,
      lg: 4,
      xl: 8
    },
    alignItems: "center",
    justifyContent: "space-between",
    bg: "gray.800",
    position: "relative",
    w: "full",
    boxShadow: withoutShadow ? undefined : 'xl',
    color: "white",
    h: 14,
    py: {
      base: 2
    },
    px: {
      base: 4
    },
    align: "center",
    children: [jsx(Button, {
      minW: "unset",
      display: "flex",
      alignItems: "center",
      rounded: "full",
      variant: "darkGhost",
      px: "3",
      py: "1",
      fontSize: "sm",
      userSelect: "none",
      cursor: "pointer",
      outline: "0",
      transition: "all 0.2s",
      onClick: function onClick() {
        void navigate(isOnJaenAdmin ? '/' : '/admin');
      },
      children: jsxs(HStack, {
        flex: "1",
        spacing: "2",
        children: [isOnJaenAdmin ? jsx(ChevronLeftIcon, {}) : jsx(ChevronRightIcon, {}), jsx(JaenLogo, {
          w: "10",
          h: "full",
          color: "white"
        }), jsxs(Text, {
          textAlign: "left",
          minW: "24",
          fontWeight: "bold",
          fontFamily: "monospace",
          children: [isOnJaenAdmin ? 'Jaen Site' : 'Jaen Admin', ' ']
        })]
      })
    }), jsx(ActionBar, {}), jsxs(HStack, {
      children: [jsxs(Menu, {
        children: [jsx(Tooltip$1, {
          label: "Need help?",
          children: jsx(MenuButton, {
            as: IconButton,
            "aria-label": "Help",
            icon: jsx(Icon, {
              as: IoHelpBuoySharp,
              boxSize: "5"
            }),
            variant: "darkGhost",
            fontSize: "xl"
          })
        }), jsxs(MenuList, {
          color: "black",
          children: [jsxs(HStack, {
            p: "2",
            justifyContent: "space-between",
            fontWeight: "bold",
            children: [jsx(Text, {
              children: "Help"
            }), jsx(Text, {
              children: "v 3.0.0"
            })]
          }), jsx(MenuDivider, {}), jsx(MenuItem, {
            as: Link$1,
            disabled: true,
            children: "Jaen documentation"
          }), jsx(MenuItem, {
            as: Link$1,
            disabled: true,
            children: "Ask snek"
          }), jsx(MenuItem, {
            children: jsxs(HStack, {
              children: [jsx(FaGithub, {}), jsx(Link$1, {
                href: "https://github.com/snek-at/jaen/issues/new/choose",
                isExternal: true,
                children: "Open an issue in GitHub"
              })]
            })
          })]
        })]
      }), jsxs(Menu, {
        children: [jsx(Tooltip$1, {
          label: "Menu",
          children: jsx(MenuButton, {
            as: IconButton,
            "aria-label": "Account",
            icon: jsx(Avatar, {
              boxSize: "6",
              size: "sm",
              name: "Nico Schett"
            }),
            variant: "darkGhost",
            fontSize: "xl",
            isLoading: isLoading
          })
        }), jsxs(MenuList, {
          color: "black",
          children: [jsxs(HStack, {
            p: "2",
            justifyContent: "space-between",
            fontWeight: "bold",
            children: [jsx(Text, {
              children: user == null ? void 0 : user.username
            }), jsx(Text, {})]
          }), jsx(MenuDivider, {}), jsx(MenuItem, {
            as: Link$1,
            disabled: true,
            children: "Jaen documentation"
          }), jsx(MenuItem, {
            icon: jsx(AiOutlineUser, {}),
            children: "Edit profile"
          }), jsx(MenuItem, {
            icon: jsx(FaFileImport, {}),
            onClick: handleImportClick,
            children: "Import savefile"
          }), jsx(MenuDivider, {}), jsx(MenuItem, {
            icon: jsx(FaSignOutAlt, {}),
            onClick: function onClick() {
              void logout();
            },
            children: "Sign out"
          })]
        })]
      })]
    })]
  }));
};

var IncomingBuildAlert = function IncomingBuildAlert(_ref) {
  var onConfirm = _ref.onConfirm,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  var cancelRef = React.useRef();
  var _React$useState = React.useState(false),
    isLoading = _React$useState[0],
    setIsLoading = _React$useState[1];
  var _useModals = useModals(),
    toast = _useModals.toast;
  var handleConfirm = function handleConfirm() {
    var doConfirm = function doConfirm() {
      try {
        setIsLoading(true);
        return Promise.resolve(onConfirm()).then(function (confirmed) {
          setIsLoading(false);
          if (confirmed) {
            toast({
              title: 'Success',
              description: 'Your changes have been discarded. You are now in view mode.',
              status: 'success',
              duration: 5000,
              isClosable: true
            });
            onClose();
          } else {
            toast({
              title: 'Error',
              description: 'Something went wrong.',
              status: 'error',
              duration: 5000,
              isClosable: true
            });
          }
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void doConfirm();
  };
  return jsxs(AlertDialog, {
    size: "xl",
    motionPreset: "slideInBottom",
    leastDestructiveRef: cancelRef,
    onClose: onClose,
    isOpen: isOpen,
    isCentered: true,
    children: [jsx(AlertDialogOverlay, {}), jsxs(AlertDialogContent, {
      children: [jsx(AlertDialogCloseButton, {}), jsx(AlertDialogBody, {
        px: 8,
        pt: 12,
        pb: 4,
        children: jsxs(VStack, {
          textAlign: "center",
          spacing: 4,
          children: [jsx(JaenLogo, {
            boxSize: "16",
            mb: 2
          }), jsx(Heading, {
            size: "md",
            fontWeight: "bold",
            children: "New version is now available"
          }), jsx(Text, {
            children: "There is a new version of the website available. You can either update to the latest version and discard your changes or you can continue working on your changes."
          }), jsx(Divider, {}), jsxs(Text, {
            fontSize: "sm",
            children: [jsx("strong", {
              children: "Warning:"
            }), " When not updating, publishing your changes might result in overwriting data of the latest version."]
          })]
        })
      }), jsx(AlertDialogFooter, {
        children: jsx(HStack, {
          spacing: 6,
          children: jsx(Button, {
            isLoading: isLoading,
            onClick: handleConfirm,
            size: "lg",
            mr: 4,
            mb: 4,
            children: "Update"
          })
        })
      })]
    })]
  });
};

var LoginForm = function LoginForm(props) {
  var _errors$email, _errors$password;
  var _useForm = useForm(),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    _useForm$formState = _useForm.formState,
    errors = _useForm$formState.errors,
    isSubmitting = _useForm$formState.isSubmitting,
    isSubmitSuccessful = _useForm$formState.isSubmitSuccessful;
  var _React$useState = React__default.useState(null),
    alert = _React$useState[0],
    setAlert = _React$useState[1];
  var resetAlert = function resetAlert() {
    setAlert(null);
  };
  var _onSubmit = function onSubmit(values) {
    try {
      return Promise.resolve(props.onSubmit(values)).then(function (success) {
        if (success) {
          setAlert({
            status: 'success',
            message: 'Login successful. Redirecting...'
          });
        } else {
          setAlert({
            status: 'error',
            message: 'Invalid email or password'
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onForgotPassword = function onForgotPassword() {
    props.onForgotPassword();
    setAlert({
      status: 'info',
      message: jsxs(Fragment, {
        children: ["Please ", jsx(Link$1, {
          href: "mailto:contact@snek.at",
          children: " contact us "
        }), "to reset your password"]
      })
    });
  };
  var onSignUp = function onSignUp() {
    props.onSignUp();
    setAlert({
      status: 'info',
      message: jsxs(Fragment, {
        children: ["Please ", jsx(Link$1, {
          href: "mailto:contact@snek.at",
          children: " contact us "
        }), "to create an account for you"]
      })
    });
  };
  useEffect(function () {
    var isLoggedOut = window.location.search.includes('loggedOut=true');
    if (isLoggedOut) {
      setAlert({
        status: 'success',
        message: 'You have been logged out'
      });
    }
  }, []);
  return jsx("form", {
    onSubmit: function onSubmit(e) {
      void handleSubmit(_onSubmit)(e);
    },
    children: jsxs(Stack, {
      spacing: "4",
      children: [jsxs(VStack, {
        spacing: "6",
        children: [jsx(Heading, {
          as: "h2",
          fontSize: {
            base: '2xl',
            xl: '3xl'
          },
          fontWeight: "semibold",
          lineHeight: "3",
          children: "Sign in to your account"
        }), jsxs(HStack, {
          children: [jsx(Text, {
            children: "Don't have an account?"
          }), jsx(Link$1, {
            onClick: onSignUp,
            children: "Sign up"
          })]
        }), alert && jsxs(Alert, {
          status: alert.status,
          children: [jsx(AlertIcon, {}), jsx(Box, {
            w: "full",
            children: alert.message
          }), jsx(CloseButton, {
            alignSelf: "flex-start",
            position: "relative",
            right: -1,
            top: -1,
            onClick: resetAlert
          })]
        })]
      }), jsx(Stack, {
        mt: "8",
        spacing: "6",
        children: jsxs(Stack, {
          spacing: "4",
          children: [jsxs(FormControl, {
            id: "email",
            isInvalid: !(errors.email == null),
            children: [jsx(FormLabel, {
              fontSize: "sm",
              fontWeight: "medium",
              children: "Email"
            }), jsx(Input, _extends({
              type: "email",
              placeholder: "Enter your email"
            }, register('email', {
              required: true
            }))), jsx(FormErrorMessage, {
              children: (_errors$email = errors.email) == null ? void 0 : _errors$email.message
            })]
          }), jsxs(FormControl, {
            id: "password",
            isInvalid: !(errors.password == null),
            children: [jsx(FormLabel, {
              fontSize: "sm",
              fontWeight: "medium",
              children: "Password"
            }), jsx(Input, _extends({
              type: "password",
              placeholder: "********"
            }, register('password', {
              required: true
            }))), jsx(FormErrorMessage, {
              children: (_errors$password = errors.password) == null ? void 0 : _errors$password.message
            })]
          })]
        })
      }), jsxs(HStack, {
        justifyContent: "space-between",
        children: [jsx(Controller, {
          control: control,
          name: "logMeOutAfterwards",
          render: function render(_ref) {
            var _ref$field = _ref.field,
              onChange = _ref$field.onChange,
              onBlur = _ref$field.onBlur,
              value = _ref$field.value,
              ref = _ref$field.ref;
            return jsx(Checkbox, {
              onBlur: onBlur,
              onChange: onChange,
              checked: value,
              ref: ref,
              children: "Log me out after"
            });
          }
        }), jsx(Link$1, {
          onClick: onForgotPassword,
          children: "Forgot password?"
        })]
      }), jsxs(VStack, {
        spacing: "4",
        children: [jsx(Button, {
          w: "full",
          type: "submit",
          isLoading: isSubmitting,
          disabled: isSubmitSuccessful,
          children: "Sign in"
        }), jsx(Link$1, {
          onClick: props.onSSO,
          children: "Continue using Single Sign-On (SSO)"
        })]
      }), jsxs(Flex, {
        align: "center",
        children: [jsx(Divider, {}), jsx(Text, {
          padding: "2",
          children: "OR"
        }), jsx(Divider, {})]
      }), jsx(Tooltip$1, {
        label: "This will launch a demo of the Jaen instance of " + (typeof window !== 'undefined' && window.location.host || 'none') + ". You will be able to explore the platform and see how it works, but you won't be able to publish any changes.",
        children: jsx(Button, {
          w: "full",
          colorScheme: "gray",
          leftIcon: jsx(BsLaptop, {
            fontSize: "1.5em"
          }),
          fontWeight: "normal",
          fontSize: "sm",
          onClick: props.onTryDemo,
          children: "Launch demo"
        })
      })]
    })
  });
};

var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
];

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React__default.createContext && React__default.createContext(DefaultContext);

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React__default.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon$2(data) {
  return function (props) {
    return React__default.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return React__default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? React__default.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

var esm = {
  __proto__: null,
  IconsManifest: IconsManifest,
  GenIcon: GenIcon$2,
  IconBase: IconBase,
  DefaultContext: DefaultContext,
  IconContext: IconContext
};

// THIS FILE IS AUTO GENERATED
var GenIcon$1 = esm.GenIcon;
var HiCloudUpload_1 = function HiCloudUpload (props) {
  return GenIcon$1({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M2 10a4 4 0 004 4h3v3a1 1 0 102 0v-3h3a4 4 0 000-8 4 4 0 00-8 0 4 4 0 00-4 4zm9 4H9V9.414l-1.293 1.293a1 1 0 01-1.414-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 9.414V14z","clipRule":"evenodd"}}]})(props);
};

// THIS FILE IS AUTO GENERATED
var GenIcon = esm.GenIcon;
var HiTemplate_1 = function HiTemplate (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"}}]})(props);
};

function dirtyValues(dirtyFields, allValues) {
  if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues;
  return Object.fromEntries(Object.keys(dirtyFields).map(function (key) {
    return [key, dirtyValues(dirtyFields[key], allValues[key])];
  }));
}

var PageContent = function PageContent(props) {
  var _errors$title, _errors$slug;
  var _useModals = useModals(),
    toast = _useModals.toast;
  var _React$useState = React.useState(props.values),
    defaultValues = _React$useState[0],
    setDefaultValues = _React$useState[1];
  var _useForm = useForm({
      defaultValues: defaultValues
    }),
    register = _useForm.register,
    reset = _useForm.reset,
    handleSubmit = _useForm.handleSubmit,
    setValue = _useForm.setValue,
    control = _useForm.control,
    _useForm$formState = _useForm.formState,
    errors = _useForm$formState.errors,
    isSubmitting = _useForm$formState.isSubmitting,
    isDirty = _useForm$formState.isDirty,
    dirtyFields = _useForm$formState.dirtyFields;
  var finder = useSnekFinder({
    mode: 'selector',
    onSelect: function onSelect(_ref) {
      var src = _ref.src;
      setValue('image', src, {
        shouldDirty: true
      });
    }
  });
  var _onSubmit = function onSubmit(values) {
    var vs = _extends({}, defaultValues, values);
    props.onSubmit(dirtyValues(dirtyFields, values));
    setDefaultValues(vs);
    reset(vs);
    toast({
      title: 'Saved',
      description: 'Your changes have been saved.',
      status: 'success',
      duration: 5000
    });
  };
  var onReset = function onReset() {
    reset(defaultValues);
  };
  var handleImageUpload = function handleImageUpload() {
    finder.toggleSelector();
  };
  var handleImageRemove = function handleImageRemove() {
    setValue('image', '', {
      shouldDirty: true
    });
  };
  return jsxs(Fragment, {
    children: [jsx(ThemeProvider, {
      theme: theme$1,
      children: finder.finderElement
    }), jsx("form", {
      onSubmit: function onSubmit(e) {
        void handleSubmit(_onSubmit)(e);
      },
      style: {
        width: '100%'
      },
      children: jsxs(Stack, {
        boxSize: "full",
        spacing: "8",
        children: [jsxs(Stack, {
          flexGrow: "1",
          overflowY: "auto",
          spacing: "6",
          children: [jsx(HStack, {
            children: props.template && jsxs(Tag, {
              my: 4,
              size: "lg",
              variant: "outline",
              children: [jsx(Box, {
                ml: -1,
                mr: 2,
                children: jsx(HiTemplate_1, {})
              }), jsx(TagLabel, {
                children: props.template.label
              })]
            })
          }), jsxs(FormControl, {
            isInvalid: !(errors.title == null),
            children: [jsx(FormLabel, {
              children: "Title"
            }), jsx(Input, _extends({
              placeholder: "Title"
            }, register('title', {}))), jsx(FormErrorMessage, {
              children: (_errors$title = errors.title) == null ? void 0 : _errors$title.message
            })]
          }), props.values.slug && props.template && jsxs(FormControl, {
            mt: 4,
            isInvalid: !(errors.slug == null),
            children: [jsx(FormLabel, {
              children: "Slug"
            }), jsx(Input, _extends({
              placeholder: "the-slug",
              disabled: !props.template
            }, register('slug', {
              required: 'This is required',
              pattern: {
                value: /^[a-z0-9-]+$/,
                message: 'Only lowercase letters, numbers and hyphens are allowed'
              },
              validate: function validate(value) {
                if (!dirtyFields.slug) {
                  return true;
                }
                var externalValidation = props.externalValidation;
                if (externalValidation) {
                  var validation = externalValidation('slug', value);
                  if (validation) {
                    return validation;
                  }
                }
                return true;
              }
            }))), errors.slug == null && jsx(FormHelperText, {
              children: "Make sure the slug is unique between siblings."
            }), jsx(FormErrorMessage, {
              children: (_errors$slug = errors.slug) == null ? void 0 : _errors$slug.message
            })]
          }), jsxs(FormControl, {
            mt: 4,
            children: [jsx(FormLabel, {
              children: "Description"
            }), jsx(Textarea, _extends({
              placeholder: "This is a sample description used for this page."
            }, register('description', {})))]
          }), jsxs(FormControl, {
            mt: 4,
            children: [jsx(FormLabel, {
              children: "Image"
            }), jsx(Controller, {
              control: control,
              name: "image",
              render: function render(_ref2) {
                var value = _ref2.field.value;
                return jsxs(Stack, {
                  direction: "row",
                  spacing: "6",
                  align: "center",
                  width: "full",
                  children: [jsx(Box, {
                    boxSize: 36,
                    borderRadius: "lg",
                    bg: "gray.50",
                    children: jsx(Image$1, {
                      borderRadius: "lg",
                      boxSize: "100%",
                      src: value,
                      fallback: jsx(Center, {
                        boxSize: "100%",
                        children: jsx(Text, {
                          color: "gray.600",
                          fontSize: "sm",
                          children: "No image"
                        })
                      })
                    })
                  }), jsxs(Box, {
                    children: [jsxs(HStack, {
                      spacing: "5",
                      children: [jsx(Button, {
                        leftIcon: jsx(HiCloudUpload_1, {}),
                        onClick: handleImageUpload,
                        children: "Change photo"
                      }), jsx(Button, {
                        variant: "ghost",
                        colorScheme: "red",
                        onClick: handleImageRemove,
                        children: "Delete"
                      })]
                    }), jsx(Text, {
                      fontSize: "sm",
                      mt: "3",
                      color: "gray.500",
                      children: "Upload a photo to represent this page."
                    })]
                  })]
                });
              }
            })]
          }), jsxs(FormControl, {
            mt: 4,
            children: [jsx(FormLabel, {
              children: "Settings"
            }), jsx(Checkbox, _extends({}, register('excludedFromIndex'), {
              children: "Exclude from index"
            }))]
          })]
        }), jsxs(ButtonGroup, {
          isDisabled: !isDirty,
          mt: "8",
          size: "lg",
          children: [jsx(Button, {
            isLoading: isSubmitting,
            type: "submit",
            children: "Save"
          }), jsx(Button, {
            onClick: onReset,
            variant: "ghost",
            colorScheme: "red",
            children: "Cancel"
          })]
        })]
      })
    })]
  });
};

var SectionBlockSelector = function SectionBlockSelector(_ref) {
  var sectionTitle = _ref.sectionTitle,
    sectionDescription = _ref.sectionDescription,
    blockTypes = _ref.blockTypes,
    onBlockAdd = _ref.onBlockAdd,
    onlyAdd = _ref.onlyAdd;
  var _useState = useState(blockTypes[0] || null),
    selection = _useState[0],
    setSelection = _useState[1];
  return jsxs(VStack, {
    p: "3",
    rounded: "xl",
    bg: "white",
    w: "48",
    maxW: "300px",
    shadow: "lg",
    border: "1px",
    borderColor: "gray.100",
    children: [jsxs(Box, {
      w: "100%",
      children: [jsx(Text, {
        fontSize: "md",
        fontWeight: "bold",
        textAlign: "left",
        children: sectionTitle
      }), jsx(Text, {
        fontSize: "xs",
        color: "gray.400",
        children: sectionDescription
      })]
    }), jsx(VStack, {
      w: "100%",
      align: "flex-start",
      spacing: "1",
      children: blockTypes.map(function (block) {
        return jsxs(HStack, {
          rounded: "md",
          w: "100%",
          p: "2",
          bg: (selection == null ? void 0 : selection.slug) === block.slug ? 'gray.200' : 'white',
          transition: "all 0.2s",
          cursor: "pointer",
          _hover: {
            bg: 'gray.100'
          },
          onClick: function onClick() {
            if ((selection == null ? void 0 : selection.slug) === block.slug) {
              setSelection(null);
            } else {
              setSelection(block);
            }
          },
          children: [jsx(Icon, {
            as: block.Icon
          }), jsx(Text, {
            fontSize: "sm",
            children: block.label
          })]
        }, block.slug);
      })
    }), jsx(HStack, {
      w: "100%",
      children: onlyAdd ? jsx(Button, {
        size: "sm",
        flex: "1",
        isDisabled: selection == null,
        onClick: function onClick() {
          if (selection == null) return;
          onBlockAdd(selection, 'add');
        },
        children: "Add"
      }) : jsxs(ButtonGroup, {
        size: "sm",
        children: [jsx(Button, {
          flex: "1",
          isDisabled: selection == null,
          onClick: function onClick() {
            if (selection == null) return;
            onBlockAdd(selection, 'prepend');
          },
          children: "Prepend"
        }), jsx(Button, {
          flex: "1",
          isDisabled: selection == null,
          onClick: function onClick() {
            if (selection == null) return;
            onBlockAdd(selection, 'append');
          },
          children: "Append"
        })]
      })
    })]
  });
};

var SectionBlockSelectorButton = function SectionBlockSelectorButton(props) {
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var toggleOpen = function toggleOpen() {
    setIsOpen(!isOpen);
  };
  var handleBlockAdd = function handleBlockAdd() {
    props.onBlockAdd.apply(props, [].slice.call(arguments));
    setIsOpen(false);
  };
  var canClose = useRef(false);
  var handleMouseLeave = function handleMouseLeave() {
    canClose.current = true;
    setTimeout(function () {
      if (canClose.current) {
        setIsOpen(false);
      }
    }, 1000);
  };
  var handleMouseEnter = function handleMouseEnter() {
    canClose.current = false;
  };
  return jsxs(Flex, {
    pos: "relative",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: [jsx(IconButton, {
      variant: "jaenHighlightTooltip",
      ml: 0.5,
      icon: jsx(AddIcon, {}),
      "aria-label": "Add",
      onClick: toggleOpen
    }), isOpen && jsx(Box, {
      position: "absolute",
      top: "6",
      left: "0",
      zIndex: "popover",
      p: "2",
      children: jsx(SectionBlockSelector, {
        sectionTitle: "Add block",
        sectionDescription: "Select the type of block you want to add",
        blockTypes: props.blocks,
        onBlockAdd: handleBlockAdd,
        onlyAdd: props.onlyAdd
      })
    })]
  });
};

var _excluded$c = ["icon", "children"];
var SelectorButton = function SelectorButton(_ref) {
  var icon = _ref.icon,
    childrenProp = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var toggleOpen = function toggleOpen() {
    setIsOpen(!isOpen);
  };
  var canClose = useRef(false);
  var handleMouseLeave = function handleMouseLeave() {
    canClose.current = true;
    setTimeout(function () {
      if (canClose.current) {
        setIsOpen(false);
      }
    }, 1000);
  };
  var handleMouseEnter = function handleMouseEnter() {
    canClose.current = false;
  };
  var children = typeof childrenProp === 'function' ? childrenProp({
    onClose: function onClose() {
      setIsOpen(false);
    }
  }) : childrenProp;
  return jsxs(Flex, {
    pos: "relative",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: [jsx(IconButton, _extends({
      variant: "jaenHighlightTooltip",
      size: "xs",
      icon: icon,
      "aria-label": "Add",
      onClick: toggleOpen
    }, props)), isOpen && jsx(Box, {
      position: "absolute",
      top: "6",
      left: "0",
      zIndex: "popover",
      p: "2",
      children: jsx(VStack, {
        p: "3",
        rounded: "xl",
        bg: "white",
        shadow: "lg",
        border: "1px",
        borderColor: "gray.100",
        children: children
      })
    })]
  });
};

var _excluded$b = ["tunes", "onTune", "activeTunes"];
var TuneSelectorButton = function TuneSelectorButton(_ref) {
  var tunes = _ref.tunes,
    _ref$onTune = _ref.onTune,
    onTune = _ref$onTune === void 0 ? function () {} : _ref$onTune,
    _ref$activeTunes = _ref.activeTunes,
    activeTunes = _ref$activeTunes === void 0 ? [] : _ref$activeTunes,
    iconButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var toggleOpen = function toggleOpen() {
    setIsOpen(!isOpen);
  };
  useEffect(function () {
    console.log('TuneSelectorButton');
  }, []);
  return jsxs(Flex, {
    pos: "relative",
    children: [jsx(IconButton, _extends({
      variant: "jaenHighlightTooltip",
      icon: jsx(Icon, {
        as: FaBars
      }),
      onClick: toggleOpen
    }, iconButtonProps)), isOpen && jsx(Box, {
      position: "absolute",
      top: "6",
      left: "0",
      zIndex: "popover",
      p: "2",
      children: jsx(TuneSelector, {
        tunes: tunes,
        onTune: onTune,
        activeTunes: activeTunes,
        onClose: function onClose() {
          setIsOpen(false);
        }
      })
    })]
  });
};

var _excluded$a = ["heading", "children", "fullscreen", "controls"];
var ViewLayout = function ViewLayout(_ref) {
  var heading = _ref.heading,
    children = _ref.children,
    fullscreen = _ref.fullscreen,
    controls = _ref.controls,
    boxProps = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  if (fullscreen) {
    return jsx(Box, {
      className: CLASSNAMES.JAEN_ADMIN_BODY,
      children: children
    });
  }
  return jsxs(Stack, _extends({
    boxSize: "full",
    px: {
      base: 2,
      md: 4,
      lg: 8,
      xl: 12
    },
    pt: "4",
    spacing: "4"
  }, boxProps, {
    children: [jsxs(Flex, {
      children: [heading && jsx(Heading, {
        size: "lg",
        as: "h1",
        children: heading
      }), jsx(Spacer, {}), jsx(HStack, {
        children: controls
      })]
    }), jsx(Box, {
      w: "100%",
      bg: "white",
      mx: "auto",
      rounded: "lg",
      shadow: "md",
      px: {
        base: 2,
        md: 4
      },
      py: {
        base: 4,
        md: 8
      },
      children: jsx(Stack, {
        divider: jsx(StackDivider, {}),
        spacing: "4",
        children: children
      })
    })]
  }));
};

var ImageAltSelector = function ImageAltSelector(props) {
  var _useState = useState(props.value),
    value = _useState[0],
    setValue = _useState[1];
  useEffect(function () {
    setValue(props.value);
  }, [props.value]);
  var isEmpty = value === '';
  var canSave = props.value !== value;
  var handleChange = function handleChange(e) {
    setValue(e.target.value);
  };
  var optionalProps = {};
  if (isEmpty) {
    optionalProps.variant = 'solid';
    optionalProps.backgroundColor = 'orange.100';
    optionalProps.color = 'orange.500';
    optionalProps._hover = {
      backgroundColor: 'orange.200'
    };
  }
  return jsx(SelectorButton, _extends({
    icon: jsx(BsTag, {})
  }, optionalProps, {
    children: function children(_ref) {
      var onClose = _ref.onClose;
      return jsxs(Stack, {
        w: "xs",
        children: [jsxs(Box, {
          w: "100%",
          children: [jsx(Text, {
            fontSize: "md",
            fontWeight: "bold",
            textAlign: "left",
            children: "Image description"
          }), jsx(Text, {
            fontSize: "xs",
            color: "gray.400",
            children: "Add a description to your image for better accessibility"
          })]
        }), jsx(Textarea, {
          maxLength: 125,
          value: value,
          onChange: handleChange
        }), jsxs(Text, {
          fontSize: "xx-small",
          color: "gray.400",
          textAlign: "right",
          children: [value.length, "/125"]
        }), jsx(Button, {
          disabled: !canSave,
          size: "sm",
          onClick: function onClick() {
            props.onSave(value);
            onClose();
          },
          children: "Save"
        })]
      });
    }
  }));
};

var withSnekFinder = function withSnekFinder(Component) {
  return function (props) {
    return jsx(SnekFinder, {
      children: jsx(Component, _extends({}, props))
    });
  };
};

var ImageChooseButton = withSnekFinder(function (props) {
  var finder = useSnekFinder({
    mode: 'selector',
    onSelect: function onSelect(_ref) {
      var src = _ref.src,
        description = _ref.description;
      props.onClick({
        src: src,
        alt: description
      });
    }
  });
  return jsxs(Fragment, {
    children: [jsx(ThemeProvider, {
      theme: theme$1,
      children: jsx(Box, {
        maxW: "container.xl",
        children: finder.finderElement
      })
    }), jsx(Button, {
      leftIcon: jsx(BsCloudUpload, {}),
      variant: "jaenHighlightTooltip",
      onClick: finder.toggleSelector,
      children: "Choose"
    })]
  });
});

var _excluded$9 = ["children"];
var List = function List(props) {
  var children = props.children,
    stackProps = _objectWithoutPropertiesLoose(props, _excluded$9);
  var items = React.useMemo(function () {
    return React.Children.toArray(children).filter(React.isValidElement).map(function (item, index, array) {
      return index + 1 === array.length ? React.cloneElement(item, {
        isLastItem: true
      }) : item;
    });
  }, [children]);
  return jsxs(Box, {
    bg: useColorModeValue('white', 'gray.700'),
    px: {
      base: 4,
      sm: 6
    },
    py: "5",
    shadow: "base",
    rounded: "lg",
    children: [props.label && jsx(Text, {
      fontSize: "sm",
      fontWeight: "medium",
      noOfLines: 1,
      color: useColorModeValue('gray.500', 'gray.400'),
      pb: "1",
      children: props.label
    }), jsx(Stack, _extends({
      as: "ul"
    }, stackProps, {
      children: items
    }))]
  });
};

var _excluded$8 = ["title", "subTitle", "circleColor", "icon", "isLastItem", "children"];
var ListItem = function ListItem(props) {
  var title = props.title,
    subTitle = props.subTitle,
    circleColor = props.circleColor,
    icon = props.icon,
    isLastItem = props.isLastItem,
    children = props.children,
    stackProps = _objectWithoutPropertiesLoose(props, _excluded$8);
  return jsxs(Stack, _extends({
    as: "li",
    direction: "row",
    spacing: "4"
  }, stackProps, {
    children: [jsxs(Flex, {
      direction: "column",
      alignItems: "center",
      "aria-hidden": "true",
      children: [jsx(Circle, {
        bg: circleColor,
        size: "12",
        borderWidth: "4px",
        borderColor: useColorModeValue('white', 'gray.800'),
        color: useColorModeValue('white', 'black'),
        children: icon
      }), !isLastItem && jsx(Flex, {
        flex: "1",
        borderRightWidth: "1px",
        mb: "-12"
      })]
    }), jsxs(Stack, {
      spacing: "4",
      pt: "1",
      flex: "1",
      children: [jsxs(Flex, {
        direction: "column",
        children: [jsx(Heading, {
          fontSize: "md",
          fontWeight: "semibold",
          children: title
        }), jsx(Text, {
          fontSize: "sm",
          color: useColorModeValue('gray.600', 'gray.400'),
          children: subTitle
        })]
      }), jsx(Flex, {
        children: children
      })]
    })]
  }));
};

var NavGroup = function NavGroup(props) {
  var label = props.label,
    children = props.children;
  return jsxs(Box, {
    children: [jsx(Text, {
      px: "3",
      fontSize: "xs",
      fontWeight: "semibold",
      textTransform: "uppercase",
      letterSpacing: "widest",
      color: "gray.500",
      mb: "3",
      children: label
    }), jsx(Stack, {
      spacing: "2",
      children: children
    })]
  });
};

var NavItem = function NavItem(props) {
  var active = props.active,
    subtle = props.subtle,
    IconComponent = props.Icon,
    label = props.label,
    onClick = props.onClick;
  return jsx(Button, {
    onClick: onClick,
    w: "full",
    py: "3",
    cursor: "pointer",
    userSelect: "none",
    rounded: "md",
    transition: "all 0.2s",
    fontSize: "lg",
    bg: active ? 'pink.100' : undefined,
    _hover: {
      bg: active ? undefined : 'pink.50'
    },
    _active: {
      bg: 'pink.100'
    },
    justifyContent: "flex-start",
    flex: "1",
    variant: "ghost",
    leftIcon: jsx(Icon, {
      as: IconComponent || Circle,
      color: "pink.400"
    }),
    fontWeight: "inherit",
    color: subtle ? 'gray.400' : 'black',
    children: label
  });
};

var NewsSlideContext = createContext({
  ref: null,
  isOpen: false,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onToggle: function onToggle() {},
  data: null,
  isLoading: true
});
var NewsSlideProvider = function NewsSlideProvider(_ref) {
  var children = _ref.children;
  var ref = useRef(null);
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = useState(null),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(true),
    isLoading = _useState3[0],
    setIsLoading = _useState3[1];
  useEffect(function () {
    var fetchData = function fetchData() {
      try {
        setIsLoading(true);
        return Promise.resolve(new Promise(function (resolve) {
          return setTimeout(resolve, 1000);
        })).then(function () {
          setData({
            items: [{
              id: 1,
              title: 'test',
              description: 'test',
              image: 'https://via.placeholder.com/150'
            }, {
              id: 2,
              title: 'test',
              description: 'test',
              image: 'https://via.placeholder.com/150'
            }]
          });
          setIsLoading(false);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    if (isOpen && data === null) {
      void fetchData();
    }
  }, [isOpen]);
  var onOpen = useCallback(function () {
    setIsOpen(true);
  }, []);
  var onClose = useCallback(function () {
    setIsOpen(false);
  }, []);
  var onToggle = useCallback(function () {
    setIsOpen(!isOpen);
  }, [isOpen]);
  return jsx(NewsSlideContext.Provider, {
    value: {
      ref: ref,
      isOpen: isOpen,
      onOpen: onOpen,
      onClose: onClose,
      onToggle: onToggle,
      data: data,
      isLoading: isLoading
    },
    children: children
  });
};

var TuneSelector = function TuneSelector(_ref) {
  var tunes = _ref.tunes,
    _ref$activeTunes = _ref.activeTunes,
    activeTunes = _ref$activeTunes === void 0 ? [] : _ref$activeTunes,
    onTune = _ref.onTune,
    onClose = _ref.onClose;
  var _useState = useState(''),
    searchTerm = _useState[0],
    setSearchTerm = _useState[1];
  var handleSearch = function handleSearch(event) {
    setSearchTerm(event.target.value);
  };
  var filteredTunes = tunes.filter(function (tune) {
    if ('type' in tune && tune.type === 'groupTune') {
      return tune.tunes.some(function (subTune) {
        var _subTune$label;
        return subTune.name.toLowerCase().includes(searchTerm.toLowerCase()) || ((_subTune$label = subTune.label) == null ? void 0 : _subTune$label.toLowerCase().includes(searchTerm.toLowerCase()));
      });
    } else {
      return tune.name.toLowerCase().includes(searchTerm.toLowerCase()) || tune.label.toLowerCase().includes(searchTerm.toLowerCase());
    }
  });
  var handleTune = function handleTune(info) {
    var _info$group;
    info.tune.onTune == null ? void 0 : info.tune.onTune();
    onTune({
      name: info.tune.name,
      groupName: (_info$group = info.group) == null ? void 0 : _info$group.name,
      isActive: info.isActive
    });
    onClose();
  };
  return jsxs(VStack, {
    p: "3",
    rounded: "xl",
    bg: "white",
    w: "48",
    maxW: "300px",
    shadow: "lg",
    border: "1px",
    borderColor: "gray.100",
    children: [jsxs(InputGroup, {
      size: "sm",
      variant: "filled",
      rounded: "md",
      children: [jsx(InputLeftElement, {
        pointerEvents: "none",
        children: jsx(SearchIcon, {
          color: "gray.300"
        })
      }), jsx(Input, {
        placeholder: "Search",
        value: searchTerm,
        onChange: handleSearch,
        px: "10",
        py: "1",
        bg: "gray.50",
        _hover: {
          bg: 'gray.100'
        },
        _focus: {
          bg: 'gray.100',
          boxShadow: 'outline'
        }
      })]
    }), jsx(VStack, {
      w: "100%",
      align: "flex-start",
      spacing: "1",
      maxH: "xs",
      overflowY: "auto",
      children: filteredTunes.map(function (tune, index) {
        if ('type' in tune && tune.type === 'groupTune') {
          return jsxs(VStack, {
            w: "full",
            children: [jsx(Text, {
              fontSize: "sm",
              as: "b",
              children: tune.label
            }), jsx(Wrap, {
              spacing: "1",
              children: tune.tunes.map(function (subTune, subIndex) {
                var isActive = activeTunes.some(function (activeTune) {
                  return activeTune.name === subTune.name && activeTune.groupName === tune.name;
                });
                var isDisabled = isActive && subTune.isDisableOnActive;
                var isHidden = isActive && subTune.isHiddenOnActive;
                return jsx(WrapItem, {
                  display: isHidden ? 'none' : 'flex',
                  children: jsx(IconButton, _extends({
                    size: "sm",
                    variant: "ghost",
                    "aria-label": "" + subTune.name,
                    icon: jsx(Icon, {
                      as: subTune.Icon
                    })
                  }, isActive && {
                    bg: 'gray.100',
                    cursor: 'pointer'
                  }, {
                    isDisabled: isDisabled,
                    onClick: function onClick() {
                      handleTune({
                        tune: subTune,
                        group: tune,
                        isActive: isActive
                      });
                    }
                  }))
                }, subIndex);
              })
            })]
          }, index);
        }
        if ('type' in tune && tune.type === 'tune') {
          var isActive = activeTunes.some(function (activeTune) {
            return activeTune.name === tune.name;
          });
          var isDisabled = isActive && tune.isDisableOnActive;
          var isHidden = isActive && tune.isHiddenOnActive;
          return jsxs(HStack, _extends({
            display: isHidden ? 'none' : 'flex',
            rounded: "md",
            w: "100%",
            p: "2",
            transition: "all 0.2s",
            _hover: {
              bg: 'gray.100'
            }
          }, isActive && {
            bg: 'gray.100',
            cursor: 'pointer'
          }, isDisabled && {
            opacity: 0.5,
            cursor: 'not-allowed'
          }, {
            onClick: function onClick() {
              if (!isDisabled) {
                handleTune({
                  tune: tune,
                  isActive: isActive
                });
              }
            },
            children: [tune.Icon && jsx(Icon, {
              as: tune.Icon
            }), jsx(Text, {
              fontSize: "sm",
              children: tune.name
            })]
          }), index);
        }
        return null;
      })
    })]
  });
};

var isSSR = function isSSR() {
  return typeof window === 'undefined';
};

var useScrollToElement = function useScrollToElement() {
  var targetRef = useRef(null);
  useEffect(function () {
    var url = new URL(window.location.href);
    var id = url.hash.slice(1);
    console.log('Scrolling to element', id);
    if (id) {
      var targetElement = document.getElementById(id);
      if (targetElement) {
        console.log('Scrolling to element', targetElement);
        targetElement.scrollIntoView({
          behavior: 'auto'
        });
      }
    }
  }, []);
  return {
    targetRef: targetRef
  };
};

var AdminShell = function AdminShell(props) {
  useScrollToElement();
  var marginTop = props.contentOffset ? "calc(" + props.contentOffset + ")" : 14;
  return jsx(Fragment, {
    children: jsxs(NewsSlideProvider, {
      children: [jsx(Box, {
        pos: "fixed",
        top: "0",
        left: "0",
        w: "full",
        zIndex: 9999,
        children: jsxs(ThemeProvider, {
          children: [jsx(AdminToolbar, {
            withoutShadow: props.withoutAdminToolbarShadow
          }), props.beforeAdminShell]
        })
      }), jsx(Box, {
        pt: marginTop,
        pos: "relative",
        children: jsx(Box, {
          zIndex: 0,
          position: "relative",
          children: props.children
        })
      })]
    })
  });
};

var AdminShell$1 = {
  __proto__: null,
  AdminShell: AdminShell,
  'default': AdminShell
};

var LoadingPage = function LoadingPage() {
  return jsx(Center, {
    h: "100vh",
    w: "full",
    children: jsx(JaenLogo, {
      boxSize: "12"
    })
  });
};

var withCustomViewLayout = function withCustomViewLayout(Component) {
  return function (props) {
    return jsx(ViewLayout, {
      heading: Component.options.heading,
      fullscreen: Component.options.fullscreen,
      controls: Component.options.controls,
      children: jsx(Component, _extends({}, props))
    });
  };
};
var normalizePath = function normalizePath(path) {
  return path.replace(/\/+/g, '/');
};
var useCustomViews = function useCustomViews() {
  var staticData = useAdminStaticQuery();
  var _React$useState = React.useState([]),
    customViews = _React$useState[0],
    setCustomViews = _React$useState[1];
  var _React$useState2 = React.useState(true),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  React.useEffect(function () {
    var nodes = staticData.jaenView.nodes;
    var loadViews = function loadViews() {
      try {
        setIsLoading(true);
        var alreadyTakenPaths = new Set();
        return Promise.resolve(Promise.all(nodes.map(function (_ref) {
          var relativePath = _ref.relativePath;
          try {
            return Promise.resolve(viewLoader(relativePath)).then(function (Connection) {
              var view = {
                path: normalizePath("/views/" + Connection.options.path),
                Component: withCustomViewLayout(Connection),
                label: Connection.options.label,
                group: 'Views',
                Icon: Connection.options.Icon || null,
                hasRoutes: true
              };
              if (alreadyTakenPaths.has(view.path)) {
                throw new Error("The path \"" + view.path + "\" is already taken by another view. Please change the path of the view \"" + view.label + "\".");
              }
              alreadyTakenPaths.add(view.path);
              return view;
            });
          } catch (e) {
            return Promise.reject(e);
          }
        }))).then(function (views) {
          setCustomViews(views);
          setIsLoading(false);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void loadViews();
  }, [staticData]);
  return {
    customViews: customViews,
    isLoading: isLoading
  };
};

var buildFromViews = function buildFromViews(views) {
  var items = {
    grouped: {},
    ungrouped: []
  };
  var routes = {};
  for (var _iterator = _createForOfIteratorHelperLoose(views), _step; !(_step = _iterator()).done;) {
    var _view$hasRoutes;
    var view = _step.value;
    var item = {
      path: view.path,
      Icon: view.Icon || Circle,
      label: view.label
    };
    if (view.group) {
      var _items$grouped$view$g;
      if (items.grouped[view.group] == null) {
        items.grouped[view.group] = {
          label: view.group,
          items: []
        };
      }
      (_items$grouped$view$g = items.grouped[view.group]) == null ? void 0 : _items$grouped$view$g.items.push(item);
    } else {
      items.ungrouped.push(item);
    }
    routes[view.path] = {
      Component: view.Component,
      hasRoutes: (_view$hasRoutes = view.hasRoutes) != null ? _view$hasRoutes : false
    };
  }
  return {
    items: items,
    routes: routes
  };
};

var _excluded$7 = ["views"];
function withAdminPageWrapper(WrappedComponent) {
  var ComponentWithExtraInfo = function ComponentWithExtraInfo(_ref) {
    var views = _ref.views,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
    if (typeof window === 'undefined') {
      return null;
    }
    var _useCustomViews = useCustomViews(),
      isLoading = _useCustomViews.isLoading,
      customViews = _useCustomViews.customViews;
    if (isLoading) {
      console.info("Loading custom views...");
    } else {
      console.info("Custom views loaded.");
    }
    views = views.concat(customViews);
    var builtViews = buildFromViews(views);
    return jsx(HashRouter, {
      children: jsx(WrappedComponent, _extends({}, props, {
        routes: builtViews.routes,
        items: builtViews.items
      }))
    });
  };
  return ComponentWithExtraInfo;
}

var AdminPage = withRedux(function (_ref) {
  var items = _ref.items,
    activePath = _ref.activePath,
    children = _ref.children,
    onNavigate = _ref.onNavigate;
  var leftRef = React.useRef(null);
  var navSliderDisclosure = useDisclosure();
  return jsx(AdminShell, {
    contentOffset: "3rem",
    withoutAdminToolbarShadow: true,
    beforeAdminShell: jsx(AdminSecondaryToolbar, {
      isSidebarOpen: navSliderDisclosure.isOpen,
      onToggleSidebar: navSliderDisclosure.onToggle
    }),
    children: jsx(ThemeProvider, {
      children: jsxs(Flex, {
        flex: "1",
        position: "relative",
        minH: "calc(100vh - 6.5rem)",
        bg: "gray.50",
        onClick: function onClick(e) {
          var _leftRef$current;
          if ((_leftRef$current = leftRef.current) != null && _leftRef$current.contains(e.target) && navSliderDisclosure.isOpen) {
            return;
          }
          if (navSliderDisclosure.isOpen) {
            navSliderDisclosure.onClose();
          }
        },
        children: [jsx(SlideFade, {
          "in": navSliderDisclosure.isOpen,
          offsetY: "0",
          style: {
            height: '100%',
            position: 'absolute',
            left: 0,
            top: 0,
            zIndex: 2,
            pointerEvents: navSliderDisclosure.isOpen ? 'all' : 'none'
          },
          children: jsxs(Box, {
            position: "fixed",
            h: "full",
            w: "80",
            children: [jsx(Box, {
              borderY: "1px",
              borderColor: "gray.200",
              h: "full",
              w: "64",
              p: "8",
              borderRightRadius: "md",
              shadow: "md",
              bg: "white",
              ref: leftRef,
              children: jsxs(Stack, {
                spacing: "8",
                flex: "1",
                children: [jsx(Stack, {
                  spacing: "4",
                  children: items.ungrouped.map(function (item) {
                    return jsx(NavItem, {
                      active: item.path === activePath,
                      Icon: item.Icon,
                      label: item.label,
                      onClick: function onClick() {
                        onNavigate(item.path);
                        navSliderDisclosure.onClose();
                      }
                    }, item.path);
                  })
                }), Object.entries(items.grouped).map(function (_ref2) {
                  var key = _ref2[0],
                    group = _ref2[1];
                  return jsx(NavGroup, {
                    label: group.label,
                    children: group.items.map(function (item) {
                      return jsx(NavItem, {
                        active: item.path === activePath,
                        Icon: item.Icon,
                        label: item.label,
                        onClick: function onClick() {
                          onNavigate(item.path);
                          navSliderDisclosure.onClose();
                        }
                      }, item.path);
                    })
                  }, key);
                })]
              })
            }), jsx(Box, {
              position: "absolute",
              right: "0",
              top: "2",
              children: jsx(CloseButton, {
                bg: "blackAlpha.100",
                onClick: navSliderDisclosure.onClose
              })
            })]
          })
        }), jsx(Box, {
          boxSize: "full",
          zIndex: "1",
          children: children
        })]
      })
    })
  });
});
var AdminPage$1 = withAdminPageWrapper(function (_ref3) {
  var routes = _ref3.routes,
    items = _ref3.items;
  var activePath = !isSSR() ? window.location.hash.replace('#', '') : null;
  var routerNavigate = useNavigate();
  var onNavigate = React.useCallback(function (path) {
    routerNavigate(path);
    window.scrollTo(0, 0);
  }, []);
  var _useAuthentication = useAuthentication(),
    isLoading = _useAuthentication.isLoading,
    isAuthenticated = _useAuthentication.isAuthenticated;
  var _React$useState = React.useState(false),
    isNavigating = _React$useState[0],
    setIsNavigating = _React$useState[1];
  React.useEffect(function () {
    if (!isLoading && !isAuthenticated) {
      var nav = function nav() {
        try {
          setIsNavigating(true);
          return Promise.resolve(navigate('/admin/login')).then(function () {
            setIsNavigating(false);
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };
      void nav();
    }
    window.scrollTo(0, 0);
  }, [isLoading, isAuthenticated]);
  var shouldRedirectToLogin = !isAuthenticated && !isLoading;
  return jsx(ThemeProvider, {
    children: jsx(SnekFinder, {
      children: jsx(ToolbarActionProvider, {
        children: jsx(Routes, {
          children: jsxs(Route, {
            element: isNavigating || shouldRedirectToLogin ? jsx(LoadingPage, {}) : jsx(AdminPage, {
              items: items,
              activePath: activePath,
              onNavigate: onNavigate,
              children: jsx(Outlet, {})
            }),
            children: [Object.entries(routes).map(function (_ref4) {
              var path = _ref4[0],
                _ref4$ = _ref4[1],
                Component = _ref4$.Component,
                hasRoutes = _ref4$.hasRoutes;
              if (hasRoutes) {
                path = path + "/*";
              }
              return jsx(Route, {
                path: path,
                element: jsx(Component, {})
              }, path);
            }), jsx(Route, {
              path: "*",
              element: jsx("p", {
                children: "There's nothing here: 404!"
              })
            }, "404")]
          })
        })
      })
    })
  });
});

function _catch$2(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var LoginPage = withRedux(function (props) {
  var _useAuthentication = useAuthentication(),
    login = _useAuthentication.login,
    demoLogin = _useAuthentication.demoLogin,
    redirectToSSO = _useAuthentication.redirectToSSO;
  return jsx(ThemeProvider, {
    children: jsx(Flex, {
      w: "100%",
      h: "100vh",
      bgGradient: {
        lg: 'linear(to-r, pink.500 50%, white 50%)'
      },
      children: jsxs(Flex, {
        w: "full",
        maxW: "8xl",
        mx: "auto",
        children: [jsx(Box, {
          flex: "1 1 0%",
          display: {
            base: 'none',
            lg: 'block'
          },
          children: jsxs(Flex, {
            flexDirection: "column",
            px: {
              base: 4,
              lg: 8
            },
            h: "full",
            color: "white",
            children: [jsx(Flex, {
              align: "center",
              alignItems: "center",
              h: "24",
              children: jsx(JaenFullLogoWhite, {
                h: "full",
                w: "auto"
              })
            }), jsx(Flex, {
              flex: "1 1 0%",
              align: "center",
              alignItems: "center",
              children: jsxs(Stack, {
                spacing: "8",
                children: [jsxs(Stack, {
                  spacing: "4",
                  children: [jsx(Heading, {
                    as: "h2",
                    fontSize: {
                      lg: '5xl',
                      xl: '6xl'
                    },
                    fontWeight: "semibold",
                    letterSpacing: "tight",
                    lineHeight: "4.5rem",
                    children: "Start editing to see some magic happen!"
                  }), jsx(Text, {
                    mt: "6",
                    fontSize: "lg",
                    maxW: "md",
                    fontWeight: "medium",
                    children: "Sign-in to your demo account and discover the power of Jaen."
                  })]
                }), jsxs(HStack, {
                  mt: "8",
                  children: [jsxs(AvatarGroup, {
                    children: [jsx(Avatar, {
                      bg: "red.500"
                    }), jsx(Avatar, {
                      bg: "teal.500"
                    }), jsx(Avatar, {
                      bg: "teal.500"
                    })]
                  }), jsx(Text, {
                    fontWeight: "medium",
                    children: "Join with your business"
                  })]
                })]
              })
            }), jsx(Flex, {
              align: "center",
              alignItems: "center",
              h: "24",
              children: jsxs(Text, {
                fontWeight: "medium",
                fontSize: "sm",
                children: ["Powered by", ' ', jsx(Link$1, {
                  variant: "white",
                  href: "https://snek.at",
                  children: "Snek"
                })]
              })
            })]
          })
        }), jsx(Flex, {
          flex: "1 1 0%",
          justifyContent: "center",
          alignItems: "center",
          align: "center",
          children: jsxs(Stack, {
            mx: "4",
            maxW: "md",
            w: "full",
            spacing: 8,
            children: [jsx(LoginForm, {
              onSubmit: function onSubmit(data) {
                try {
                  return Promise.resolve(_catch$2(function () {
                    return Promise.resolve(login(data.email, data.password, data.logMeOutAfterwards)).then(function () {
                      return true;
                    });
                  }, function (error) {
                    console.error(error);
                    return false;
                  }));
                } catch (e) {
                  return Promise.reject(e);
                }
              },
              onForgotPassword: function onForgotPassword() {},
              onSignUp: function onSignUp() {},
              onSSO: function onSSO() {
                void redirectToSSO();
              },
              onTryDemo: function onTryDemo() {
                void demoLogin();
              }
            }), jsxs(Link$1, {
              display: "flex",
              alignItems: "center",
              onClick: function onClick() {
                var _location$state;
                var location = props.location;
                var from = location == null ? void 0 : (_location$state = location.state) == null ? void 0 : _location$state.from;
                var to = from != null && from.startsWith('/admin') ? '/' : from || '/';
                navigate(to);
              },
              children: [jsx(ChevronLeftIcon, {}), ' ', jsx(Text, {
                as: "span",
                fontWeight: "medium",
                children: "Back to site"
              })]
            })]
          })
        })]
      })
    })
  });
});

var FilesView$1 = withSnekFinder(function () {
  var finder = useSnekFinder({
    mode: 'browser'
  });
  return jsx(ThemeProvider, {
    theme: theme$1,
    children: jsx(Box, {
      h: "60vh",
      children: finder.finderElement
    })
  });
});

var useStatistics = function useStatistics() {
  var _useAdminStaticQuery = useAdminStaticQuery(),
    migrationHistory = _useAdminStaticQuery.jaenInternal.migrationHistory,
    allJaenPage = _useAdminStaticQuery.allJaenPage,
    allJaenPopup = _useAdminStaticQuery.allJaenPopup;
  var sortedMigration = migrationHistory.sort(function (a, b) {
    return new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1;
  });
  return {
    totalPages: allJaenPage.totalCount,
    totalPopups: allJaenPopup.totalCount,
    migrations: sortedMigration
  };
};

var PagesView$1 = function PagesView() {
  var manager = usePageManager();
  var _useModals = useModals(),
    confirm = _useModals.confirm,
    toast = _useModals.toast;
  var rootElement = React.useMemo(function () {
    var rootPageId = manager.getPageIdFromPath('/');
    if (!rootPageId) return null;
    var rootPage = manager.onGet(rootPageId);
    if (rootPage == null) return null;
    return {
      path: '/',
      jaenPage: rootPage
    };
  }, [manager]);
  var _React$useState = React.useState(rootElement),
    selectedJaenPage = _React$useState[0],
    setSelectedJaenPage = _React$useState[1];
  React.useEffect(function () {
    return function () {
      if (manager.latestAddedPageId) {
        onSelect(manager.latestAddedPageId, 'pageId');
      }
    };
  }, [manager.latestAddedPageId]);
  var onSelect = React.useCallback(function (id, idType) {
    if (idType === void 0) {
      idType = 'path';
    }
    var path = idType === 'path' ? id : manager.getPathFromPageId(id);
    var pageId = idType === 'pageId' ? id : manager.getPageIdFromPath(id);
    if (path && pageId) {
      var jaenPage = manager.onGet(pageId);
      if (jaenPage) {
        setSelectedJaenPage({
          path: path,
          jaenPage: jaenPage
        });
      }
    } else {
      setSelectedJaenPage(rootElement);
    }
  }, [manager, rootElement]);
  var handleSelectedJaenPageUpdate = React.useCallback(function (values) {
    selectedJaenPage && manager.onUpdate(selectedJaenPage.jaenPage.id, values);
  }, [selectedJaenPage]);
  var handleItemAdd = React.useCallback(function (path) {
    var parentPageId = manager.getPageIdFromPath(path);
    manager.onToggleCreator(parentPageId);
    toast({
      title: "Create a new page under " + path,
      status: 'info',
      isClosable: true
    });
  }, [manager]);
  var handleItemDelete = React.useCallback(function (path) {
    try {
      return Promise.resolve(confirm("Are you sure you want to delete the page \"" + path + "\"?")).then(function (shouldDelete) {
        if (shouldDelete) {
          var _page$parent;
          var pageId = manager.getPageIdFromPath(path);
          if (!pageId) {
            return;
          }
          toast({
            title: 'Page deleted',
            status: 'success'
          });
          var page = manager.onGet(pageId);
          manager.onDelete(pageId);
          if (!(page != null && (_page$parent = page.parent) != null && _page$parent.id)) {
            return;
          }
          onSelect(page.parent.id, 'pageId');
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [manager.pageTree]);
  var handlePageMove = React.useCallback(function (info) {
    var pageId = manager.getPageIdFromPath(info.dragPath);
    if (!pageId) {
      return;
    }
    var oldParentId = manager.getPageIdFromPath(info.dragParentPath);
    var newParentId = manager.getPageIdFromPath(info.dropPath);
    manager.onMove(pageId, oldParentId, newParentId);
  }, [manager]);
  var selectedTemplate = React.useMemo(function () {
    return manager.templates.find(function (t) {
      return t.name === (selectedJaenPage == null ? void 0 : selectedJaenPage.jaenPage.template);
    }) || null;
  }, [manager.templates, selectedJaenPage == null ? void 0 : selectedJaenPage.jaenPage.template]);
  var toolbarActions = useToolbarActions();
  React.useEffect(function () {
    toolbarActions.register([jsx(Button, {
      size: "sm",
      leftIcon: jsx(FaEye, {}),
      variant: "link",
      onClick: function onClick() {
        manager.onNavigate((selectedJaenPage == null ? void 0 : selectedJaenPage.path) || '/');
      },
      children: "View"
    }, "view"), jsx(Button, {
      size: "sm",
      leftIcon: jsx(AddIcon, {}),
      variant: "link",
      onClick: function onClick() {
        handleItemAdd((selectedJaenPage == null ? void 0 : selectedJaenPage.path) || '/');
      },
      children: "Add"
    }, "add"), jsx(Button, {
      size: "sm",
      leftIcon: jsx(DeleteIcon, {}),
      variant: "link",
      disabled: !(selectedJaenPage != null && selectedJaenPage.jaenPage.template),
      onClick: function onClick() {
        void handleItemDelete((selectedJaenPage == null ? void 0 : selectedJaenPage.path) || '/');
      },
      children: "Delete"
    }, "delete")]);
    return function () {
      toolbarActions.register([]);
    };
  }, [selectedJaenPage == null ? void 0 : selectedJaenPage.path]);
  return jsxs(Stack, {
    divider: jsx(StackDivider, {}),
    spacing: "4",
    h: "full",
    direction: {
      base: 'column',
      md: 'row'
    },
    children: [jsx(PageTree, {
      px: "2",
      borderRadius: "md",
      minW: {
        base: 'full',
        md: 'xs'
      },
      h: {
        base: 48,
        md: 'full'
      },
      defaultSelectedPath: "/",
      selectedPath: selectedJaenPage == null ? void 0 : selectedJaenPage.path,
      nodes: manager.pagePaths,
      onSelectPage: onSelect,
      onAddPage: handleItemAdd,
      onDeletePage: function onDeletePage(path) {
        void handleItemDelete(path);
      },
      onMovePage: handlePageMove,
      onViewPage: manager.onNavigate
    }), selectedJaenPage && jsx(PageProvider, {
      jaenPage: selectedJaenPage.jaenPage,
      unregisterFields: false,
      children: jsx(PageContent, {
        template: selectedTemplate,
        jaenPageId: selectedJaenPage.jaenPage.id,
        publishedAt: selectedJaenPage.jaenPage.jaenPageMetadata.datePublished,
        values: {
          title: selectedJaenPage.jaenPage.jaenPageMetadata.title,
          slug: selectedJaenPage.jaenPage.slug,
          description: selectedJaenPage.jaenPage.jaenPageMetadata.description,
          image: selectedJaenPage.jaenPage.jaenPageMetadata.image,
          excludedFromIndex: selectedJaenPage.jaenPage.excludedFromIndex
        },
        onSubmit: handleSelectedJaenPageUpdate,
        externalValidation: function externalValidation(name, value) {
          var _selectedJaenPage$jae;
          return pageUpdateValidation({
            name: name,
            value: value,
            parentId: (_selectedJaenPage$jae = selectedJaenPage.jaenPage.parent) == null ? void 0 : _selectedJaenPage$jae.id,
            pageTree: manager.pageTree
          });
        }
      }, selectedJaenPage.jaenPage.id)
    })]
  });
};

var PopupCard = function PopupCard(_ref) {
  var _ref$isEnabled = _ref.isEnabled,
    isEnabled = _ref$isEnabled === void 0 ? false : _ref$isEnabled,
    title = _ref.title,
    description = _ref.description,
    imageURL = _ref.imageURL,
    onEdit = _ref.onEdit,
    onEnableToggle = _ref.onEnableToggle;
  var boxBg = 'white';
  var mainText = 'gray.800';
  var iconBox = 'gray.100';
  var iconColor = 'pink.500';
  return jsxs(Flex, {
    shadow: "base",
    rounded: "lg",
    borderRadius: "20px",
    bg: boxBg,
    p: "20px",
    w: {
      base: '315px',
      md: '345px'
    },
    alignItems: "center",
    direction: "column",
    children: [jsxs(Flex, {
      w: "100%",
      mb: "18px",
      align: "center",
      justifyContent: "space-between",
      children: [jsx(Flex, {
        w: "38px",
        h: "38px",
        align: "center",
        justify: "center",
        borderRadius: "50%",
        me: "12px",
        bg: iconBox,
        children: jsx(Icon, {
          w: "24px",
          h: "24px",
          as: isEnabled ? BiNotification : BiNotificationOff,
          color: iconColor
        })
      }), jsxs(FormControl, {
        display: "flex",
        alignItems: "center",
        w: "fit-content",
        children: [jsx(FormLabel, {
          htmlFor: "enable-popup",
          mb: "0",
          children: "Active"
        }), jsx(Switch, {
          id: "enable-popup",
          onChange: onEnableToggle,
          isChecked: isEnabled
        })]
      })]
    }), imageURL ? jsx(Image$1, {
      src: imageURL,
      maxW: "100%",
      borderRadius: "20px",
      mb: "10px"
    }) : null, jsx(Text, {
      fontWeight: "600",
      color: mainText,
      textAlign: "start",
      fontSize: "xl",
      w: "100%",
      children: title
    }), jsx(Text, {
      fontWeight: "400",
      color: mainText,
      textAlign: "start",
      fontSize: "sm",
      w: "100%",
      children: description
    }), jsx(Flex, {
      mt: "auto",
      justify: "space-between",
      w: "100%",
      align: "center",
      justifyContent: "right",
      children: jsx(Button, {
        size: "sm",
        onClick: onEdit,
        children: "Edit"
      })
    })]
  });
};
var PopupsView$1 = function PopupsView(_ref2) {
  var isLoading = _ref2.isLoading,
    popups = _ref2.popups,
    onPopupEnableToggle = _ref2.onPopupEnableToggle;
  var _useState = useState(null),
    popup = _useState[0],
    setPopup = _useState[1];
  var onPopupEdit = function onPopupEdit(popup) {
    setPopup(popup);
  };
  return jsxs(Fragment, {
    children: [isLoading ? jsx(Text, {
      children: "Loading..."
    }) : jsx(Wrap, {
      spacing: "8",
      overflow: "visible",
      children: popups.map(function (popup) {
        return jsx(WrapItem, {
          children: jsx(PopupCard, {
            title: popup.Component.options.label,
            description: popup.Component.options.description,
            imageURL: popup.Component.options.imageURL,
            onEdit: function onEdit() {
              onPopupEdit(popup);
            },
            onEnableToggle: function onEnableToggle() {
              onPopupEnableToggle(popup);
            },
            isEnabled: popup.isActive
          }, popup.id)
        }, popup.id);
      })
    }), popup && jsx(popup.Component, {
      id: popup.id,
      popup: popup.popup,
      forceOpen: true,
      onClose: function onClose() {
        setPopup(null);
      },
      edtiable: true
    })]
  });
};

var _excluded$6 = ["title", "children"];
var FieldGroup = function FieldGroup(props) {
  var title = props.title,
    children = props.children,
    flexProps = _objectWithoutPropertiesLoose(props, _excluded$6);
  return jsxs(Stack, _extends({
    direction: {
      base: 'column',
      md: 'row'
    },
    spacing: "6",
    py: "4"
  }, flexProps, {
    children: [jsx(Box, {
      minW: "3xs",
      children: title && jsx(Heading, {
        as: "h2",
        fontWeight: "semibold",
        fontSize: "lg",
        flexShrink: 0,
        children: title
      })
    }), children]
  }));
};

var SettingsView$1 = function SettingsView(_ref) {
  var _errors$siteMetadata, _errors$siteMetadata2, _errors$siteMetadata3, _errors$siteMetadata4, _errors$siteMetadata5, _errors$siteMetadata6, _errors$siteMetadata7, _errors$siteMetadata8, _errors$siteMetadata9, _errors$siteMetadata10, _errors$siteMetadata11, _errors$siteMetadata12, _errors$siteMetadata13, _errors$siteMetadata14, _errors$siteMetadata15, _errors$siteMetadata16, _errors$siteMetadata17, _errors$siteMetadata18, _errors$siteMetadata19, _errors$siteMetadata20, _errors$siteMetadata21, _errors$siteMetadata22, _errors$siteMetadata23, _errors$siteMetadata24, _errors$siteMetadata25;
  var data = _ref.data,
    onUpdate = _ref.onUpdate;
  var toast = useToast();
  var _React$useState = React__default.useState(data),
    defaultValues = _React$useState[0],
    setDefaultValues = _React$useState[1];
  var _useStatistics = useStatistics(),
    migrations = _useStatistics.migrations;
  var _useStatus = useStatus(),
    isPublishing = _useStatus.isPublishing;
  React__default.useEffect(function () {
    setDefaultValues(data);
    reset(data);
  }, [data]);
  var _useForm = useForm({
      defaultValues: defaultValues
    }),
    register = _useForm.register,
    reset = _useForm.reset,
    handleSubmit = _useForm.handleSubmit,
    setValue = _useForm.setValue,
    control = _useForm.control,
    _useForm$formState = _useForm.formState,
    errors = _useForm$formState.errors,
    isSubmitting = _useForm$formState.isSubmitting,
    isDirty = _useForm$formState.isDirty;
  var _React$useState2 = React__default.useState(null),
    finderReference = _React$useState2[0],
    setFinderReference = _React$useState2[1];
  var finder = useSnekFinder({
    mode: 'selector',
    onSelect: function onSelect(_ref2) {
      var src = _ref2.src;
      if (finderReference) {
        setValue(finderReference, src, {
          shouldDirty: true
        });
        setFinderReference(null);
      }
    }
  });
  var handleSiteImageUpload = function handleSiteImageUpload() {
    setFinderReference('siteMetadata.image');
    finder.toggleSelector();
  };
  var handleSiteImageDelete = function handleSiteImageDelete() {
    setValue('siteMetadata.image', '', {
      shouldDirty: true
    });
  };
  var handleOrganizationLogoUpload = function handleOrganizationLogoUpload() {
    setFinderReference('siteMetadata.organization.logo');
    finder.toggleSelector();
  };
  var handleOrganizationLogoDelete = function handleOrganizationLogoDelete() {
    setValue('siteMetadata.organization.logo', '', {
      shouldDirty: true
    });
  };
  var _onSubmit = function onSubmit(values) {
    onUpdate(values);
    setDefaultValues(values);
    reset(values);
    toast({
      title: 'Saved',
      description: 'Your changes have been saved.',
      status: 'success',
      duration: 5000
    });
  };
  var onReset = function onReset() {
    reset(defaultValues);
  };
  var currentWindowUrl = typeof window !== 'undefined' ? window.location.href : '';
  return jsxs(Fragment, {
    children: [jsx(ThemeProvider, {
      theme: theme$1,
      children: finder.finderElement
    }), jsxs("form", {
      onSubmit: function onSubmit(data) {
        void handleSubmit(_onSubmit)(data);
      },
      children: [jsxs(Stack, {
        spacing: "4",
        divider: jsx(StackDivider, {}),
        px: {
          base: '4',
          md: '10'
        },
        children: [jsx(FieldGroup, {
          title: "Site Info",
          children: jsxs(VStack, {
            width: "full",
            spacing: "6",
            children: [jsxs(FormControl, {
              isRequired: true,
              isInvalid: !!(errors != null && (_errors$siteMetadata = errors.siteMetadata) != null && _errors$siteMetadata.title),
              children: [jsx(FormLabel, {
                children: "Title"
              }), jsx(Input, _extends({
                placeholder: "Title"
              }, register('siteMetadata.title', {
                required: 'Title is required',
                maxLength: {
                  value: 100,
                  message: 'Title is too long'
                }
              }))), jsx(FormErrorMessage, {
                children: (_errors$siteMetadata2 = errors.siteMetadata) == null ? void 0 : (_errors$siteMetadata3 = _errors$siteMetadata2.title) == null ? void 0 : _errors$siteMetadata3.message
              })]
            }), jsxs(FormControl, {
              isRequired: true,
              isInvalid: !!(errors != null && (_errors$siteMetadata4 = errors.siteMetadata) != null && _errors$siteMetadata4.siteUrl),
              children: [jsx(FormLabel, {
                children: "Url"
              }), jsx(Input, _extends({
                placeholder: currentWindowUrl
              }, register('siteMetadata.siteUrl', {
                required: 'Url is required',
                validate: {
                  checkUrl: function checkUrl(value) {
                    return value && !/^https?:\/\//.test(value) ? 'Url must start with http:// or https://' : undefined;
                  }
                }
              }))), jsx(FormErrorMessage, {
                children: (_errors$siteMetadata5 = errors.siteMetadata) == null ? void 0 : (_errors$siteMetadata6 = _errors$siteMetadata5.siteUrl) == null ? void 0 : _errors$siteMetadata6.message
              })]
            }), jsxs(FormControl, {
              isInvalid: !!(errors != null && (_errors$siteMetadata7 = errors.siteMetadata) != null && _errors$siteMetadata7.description),
              children: [jsx(FormLabel, {
                children: "Description"
              }), jsx(Textarea, _extends({
                rows: 5,
                placeholder: "The description will be showed in SEO results on pages without their own descriptions."
              }, register('siteMetadata.description'))), !((_errors$siteMetadata8 = errors.siteMetadata) != null && _errors$siteMetadata8.description) && jsx(FormHelperText, {
                children: "Brief description for your site."
              }), jsx(FormErrorMessage, {
                children: (_errors$siteMetadata9 = errors.siteMetadata) == null ? void 0 : (_errors$siteMetadata10 = _errors$siteMetadata9.description) == null ? void 0 : _errors$siteMetadata10.message
              })]
            }), jsxs(FormControl, {
              id: "image",
              children: [jsx(FormLabel, {
                children: "Image"
              }), jsx(Controller, {
                control: control,
                name: "siteMetadata.image",
                render: function render(_ref3) {
                  var value = _ref3.field.value;
                  return jsxs(Stack, {
                    direction: "row",
                    spacing: "6",
                    align: "center",
                    width: "full",
                    children: [jsx(Box, {
                      boxSize: 36,
                      borderRadius: "lg",
                      bg: "gray.50",
                      children: jsx(Image$1, {
                        borderRadius: "lg",
                        boxSize: "100%",
                        src: value,
                        fallback: jsx(Center, {
                          boxSize: "100%",
                          children: jsx(Text, {
                            color: "gray.600",
                            fontSize: "sm",
                            children: "No image"
                          })
                        })
                      })
                    }), jsxs(Box, {
                      children: [jsxs(HStack, {
                        spacing: "5",
                        children: [jsx(Button, {
                          leftIcon: jsx(HiCloudUpload, {}),
                          onClick: handleSiteImageUpload,
                          children: "Change photo"
                        }), jsx(Button, {
                          variant: "ghost",
                          colorScheme: "red",
                          onClick: handleSiteImageDelete,
                          children: "Delete"
                        })]
                      }), jsx(Text, {
                        fontSize: "sm",
                        mt: "3",
                        color: useColorModeValue('gray.500', 'whiteAlpha.600'),
                        children: "Upload a photo to represent this site."
                      })]
                    })]
                  });
                }
              })]
            })]
          })
        }), jsx(FieldGroup, {
          title: "Version history",
          children: jsx(Flex, {
            direction: "column",
            width: "full",
            children: jsxs(List, {
              spacing: "12",
              overflowY: "auto",
              h: "xs",
              label: "Previouse releases",
              children: [isPublishing && jsx(ListItem, {
                title: "In progress",
                subTitle: "Your website will be live in a few minutes.",
                circleColor: useColorModeValue('orange.500', 'orange.300'),
                icon: jsx(Icon, {
                  as: FaRocket,
                  boxSize: "6"
                })
              }), migrations.map(function (m, i) {
                return jsx(ListItem, {
                  title: "Published site",
                  subTitle: "Published on " + new Date(m.createdAt).toLocaleString(),
                  circleColor: useColorModeValue('teal.500', 'teal.300'),
                  icon: jsx(Icon, {
                    as: FaRocket,
                    boxSize: "6"
                  }),
                  isLastItem: i === migrations.length - 1
                }, i);
              })]
            })
          })
        }), jsx(FieldGroup, {
          title: "Author",
          children: jsx(VStack, {
            width: "full",
            spacing: "6",
            children: jsxs(FormControl, {
              isInvalid: !!(errors != null && (_errors$siteMetadata11 = errors.siteMetadata) != null && (_errors$siteMetadata12 = _errors$siteMetadata11.author) != null && _errors$siteMetadata12.name),
              children: [jsx(FormLabel, {
                children: "Name"
              }), jsx(Input, _extends({
                placeholder: "Emma Doe"
              }, register('siteMetadata.author.name', {
                maxLength: {
                  value: 100,
                  message: 'Name is too long'
                }
              }))), jsx(FormErrorMessage, {
                children: (_errors$siteMetadata13 = errors.siteMetadata) == null ? void 0 : (_errors$siteMetadata14 = _errors$siteMetadata13.author) == null ? void 0 : (_errors$siteMetadata15 = _errors$siteMetadata14.name) == null ? void 0 : _errors$siteMetadata15.message
              })]
            })
          })
        }), jsx(FieldGroup, {
          title: "Organisation",
          children: jsxs(VStack, {
            width: "full",
            spacing: "6",
            children: [jsxs(FormControl, {
              isInvalid: !!(errors != null && (_errors$siteMetadata16 = errors.siteMetadata) != null && (_errors$siteMetadata17 = _errors$siteMetadata16.organization) != null && _errors$siteMetadata17.name),
              children: [jsx(FormLabel, {
                children: "Name"
              }), jsx(Input, _extends({
                placeholder: "Snek"
              }, register('siteMetadata.organization.name', {
                maxLength: {
                  value: 100,
                  message: 'Name is too long'
                }
              }))), jsx(FormErrorMessage, {
                children: (_errors$siteMetadata18 = errors.siteMetadata) == null ? void 0 : (_errors$siteMetadata19 = _errors$siteMetadata18.organization) == null ? void 0 : (_errors$siteMetadata20 = _errors$siteMetadata19.name) == null ? void 0 : _errors$siteMetadata20.message
              })]
            }), jsxs(FormControl, {
              isInvalid: !!(errors != null && (_errors$siteMetadata21 = errors.siteMetadata) != null && (_errors$siteMetadata22 = _errors$siteMetadata21.organization) != null && _errors$siteMetadata22.url),
              children: [jsx(FormLabel, {
                children: "Url"
              }), jsx(Input, _extends({
                placeholder: "https://snek.at"
              }, register('siteMetadata.organization.url', {
                validate: {
                  checkUrl: function checkUrl(value) {
                    return value && !/^https?:\/\//.test(value) ? 'Url must start with http:// or https://' : undefined;
                  }
                }
              }))), jsx(FormErrorMessage, {
                children: (_errors$siteMetadata23 = errors.siteMetadata) == null ? void 0 : (_errors$siteMetadata24 = _errors$siteMetadata23.organization) == null ? void 0 : (_errors$siteMetadata25 = _errors$siteMetadata24.url) == null ? void 0 : _errors$siteMetadata25.message
              })]
            }), jsxs(FormControl, {
              id: "image",
              children: [jsx(FormLabel, {
                children: "Image"
              }), jsx(Controller, {
                control: control,
                name: "siteMetadata.organization.logo",
                render: function render(_ref4) {
                  var value = _ref4.field.value;
                  return jsxs(Stack, {
                    direction: "row",
                    spacing: "6",
                    align: "center",
                    width: "full",
                    children: [jsx(Box, {
                      boxSize: 36,
                      borderRadius: "lg",
                      bg: "gray.50",
                      children: jsx(Image$1, {
                        borderRadius: "lg",
                        boxSize: "100%",
                        src: value,
                        fallback: jsx(Center, {
                          boxSize: "100%",
                          children: jsx(Text, {
                            color: "gray.600",
                            fontSize: "sm",
                            children: "No image"
                          })
                        })
                      })
                    }), jsxs(Box, {
                      children: [jsxs(HStack, {
                        spacing: "5",
                        children: [jsx(Button, {
                          leftIcon: jsx(HiCloudUpload, {}),
                          onClick: handleOrganizationLogoUpload,
                          children: "Change photo"
                        }), jsx(Button, {
                          variant: "ghost",
                          colorScheme: "red",
                          onClick: handleOrganizationLogoDelete,
                          children: "Delete"
                        })]
                      }), jsx(Text, {
                        fontSize: "sm",
                        mt: "3",
                        color: useColorModeValue('gray.500', 'whiteAlpha.600'),
                        children: "Upload a photo of your organisation."
                      })]
                    })]
                  });
                }
              })]
            })]
          })
        })]
      }), jsx(FieldGroup, {
        mt: "8",
        children: jsx(HStack, {
          width: "full",
          children: jsxs(ButtonGroup, {
            isDisabled: !isDirty,
            size: "lg",
            children: [jsx(Button, {
              type: "submit",
              mr: "4",
              isLoading: isSubmitting,
              children: "Save Changes"
            }), jsx(Button, {
              variant: "outline",
              onClick: onReset,
              children: "Cancel"
            })]
          })
        })
      })]
    })]
  });
};

var ChoiceField = connectField(function (_ref) {
  var jaenField = _ref.jaenField,
    defaultValue = _ref.defaultValue,
    options = _ref.options,
    render = _ref.render,
    renderPopover = _ref.renderPopover;
  var selection = jaenField.value || jaenField.staticValue || defaultValue;
  var actions = [jsx(Button, {
    variant: "jaenHighlightTooltipText",
    children: jsx(Tooltip$1, {
      label: "ID: " + jaenField.id,
      placement: "top-start",
      children: jsx(Text, {
        children: "Choice"
      })
    })
  }, "jaen-highlight-tooltip-text-" + jaenField.name)];
  var _useModals = useModals(),
    toast = _useModals.toast;
  var selectAndClose = function selectAndClose(onClose) {
    return function (value) {
      jaenField.onUpdateValue(value);
      onClose();
      toast({
        title: 'Choice saved',
        description: 'The choice has been saved',
        status: 'info'
      });
    };
  };
  if (renderPopover) {
    actions.push(jsx(SelectorButton, {
      icon: jsx(Icon, {
        as: IoOptions
      }),
      children: function children(_ref2) {
        var onClose = _ref2.onClose;
        return renderPopover(selection, options, selectAndClose(onClose), jaenField.isEditing);
      }
    }, "jaen-highlight-tooltip-button-" + jaenField.name));
  }
  return jsx(HighlightTooltip, {
    id: jaenField.id,
    actions: actions,
    children: render(selection, options, jaenField.onUpdateValue, jaenField.isEditing)
  });
}, {
  fieldType: 'IMA:ChoiceField'
});

var ImageEditButton = withSnekFinder(function (props) {
  var finder = useSnekFinder({
    mode: 'editor',
    onSnekStudioUpdate: function onSnekStudioUpdate(_, src) {
      props.onUpdate({
        src: src
      });
    }
  });
  var isDisabled = !props.src;
  var toggleSnekStudio = function toggleSnekStudio() {
    if (isDisabled) return;
    finder.toggleSnekStudio(props.src, props.name);
  };
  return jsxs(Fragment, {
    children: [jsx(ThemeProvider, {
      theme: theme$1,
      children: finder.finderElement
    }), jsx(Button, {
      "aria-label": "Edit Image",
      isDisabled: isDisabled,
      leftIcon: jsx(EditIcon, {}),
      variant: "jaenHighlightTooltip",
      onClick: toggleSnekStudio,
      children: "Edit"
    })]
  });
});

var DataImage = function DataImage(_ref) {
  var imageFieldProps = _ref.imageFieldProps,
    imageData = _ref.imageData,
    internalImageUrl = _ref.internalImageUrl,
    _ref$renderAsDynamic = _ref.renderAsDynamic,
    renderAsDynamic = _ref$renderAsDynamic === void 0 ? false : _ref$renderAsDynamic,
    _ref$onLoadingComplet = _ref.onLoadingComplete,
    onLoadingComplete = _ref$onLoadingComplet === void 0 ? function () {} : _ref$onLoadingComplet;
  var imageElement;
  var gatsbyImageDynamic = {
    placeholder: undefined,
    layout: 'constained',
    images: {
      fallback: {
        src: internalImageUrl
      }
    }
  };
  var completeLoader = function completeLoader() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        onLoadingComplete();
      });
    });
  };
  var oldLoad = imageFieldProps.onLoad;
  imageFieldProps.onLoad = function () {
    completeLoader();
    oldLoad == null ? void 0 : oldLoad.apply(void 0, [].slice.call(arguments));
  };
  if (internalImageUrl && renderAsDynamic) {
    imageElement = jsx(GatsbyImage, _extends({}, imageFieldProps, {
      image: gatsbyImageDynamic,
      imgStyle: _extends({}, imageFieldProps.imgStyle, {
        position: 'static'
      })
    }));
  } else if (imageData) {
    imageElement = jsx(GatsbyImage, _extends({}, imageFieldProps, {
      image: imageData
    }));
  } else {
    imageElement = jsx(Center, {
      style: imageFieldProps.style,
      children: jsx(Text, {
        color: "gray.600",
        fontSize: "sm",
        children: "No image"
      })
    });
  }
  return imageElement;
};

function usePageImage(options) {
  var id = options.id,
    byFieldName = options.byFieldName;
  var _usePageContext = usePageContext(),
    jaenPage = _usePageContext.jaenPage;
  var sectionContext = useSectionBlockContext();
  var file;
  if (sectionContext) {
    var section = findSection(jaenPage.sections || [], sectionContext.path);
    var item = section == null ? void 0 : section.items.find(function (_ref) {
      var id = _ref.id;
      return id === sectionContext.id;
    });
    if (item) {
      if (byFieldName) {
        file = item[byFieldName];
      }
      if (!file) {
        file = item.jaenFiles.find(function (file) {
          return file.id === id;
        });
      }
    }
  } else {
    if (byFieldName) {
      file = jaenPage[byFieldName];
    }
    if (!file) {
      var _jaenPage$jaenFiles;
      file = jaenPage == null ? void 0 : (_jaenPage$jaenFiles = jaenPage.jaenFiles) == null ? void 0 : _jaenPage$jaenFiles.find(function (file) {
        return file.id === id;
      });
    }
  }
  if (file) {
    return getImage(file.childImageSharp.gatsbyImageData);
  }
  return undefined;
}

var _excluded$5 = ["jaenField", "defaultValue", "lightbox", "lightboxGroup", "overload"];
var ImageField = connectField(function (_ref) {
  var _jaenField$staticValu;
  var jaenField = _ref.jaenField,
    defaultValue = _ref.defaultValue,
    lightbox = _ref.lightbox,
    lightboxGroup = _ref.lightboxGroup,
    overload = _ref.overload,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var _useModals = useModals(),
    toast = _useModals.toast,
    confirm = _useModals.confirm;
  var handleImageChooseClick = function handleImageChooseClick(info) {
    jaenField.onUpdateValue(_extends({}, jaenField.value, {
      internalImageUrl: info.src,
      alt: info.alt
    }));
    toast({
      title: 'Image updated',
      description: 'The image has been updated',
      status: 'info'
    });
  };
  var handleImageClearClick = function handleImageClearClick() {
    var updateWhenConfirmed = function updateWhenConfirmed() {
      try {
        return Promise.resolve(confirm('Are you sure you want to clear the image?')).then(function (confirmed) {
          if (confirmed) {
            jaenField.onUpdateValue({
              internalImageUrl: null
            });
            toast({
              title: 'Image cleared',
              description: 'The image has been cleared',
              status: 'info'
            });
          }
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void updateWhenConfirmed();
  };
  var handleImageAltSaveClick = function handleImageAltSaveClick(value) {
    toast({
      title: 'Image description saved',
      description: 'The image description has been saved',
      status: 'info'
    });
    jaenField.onUpdateValue(_extends({}, jaenField.value, {
      alt: value
    }));
  };
  var value = _extends({}, jaenField.staticValue, jaenField.value);
  var _useState = useState(false),
    shouldOverload = _useState[0],
    setShouldOverload = _useState[1];
  useEffect(function () {
    if (!value.internalImageUrl && defaultValue) {
      jaenField.onUpdateValue(_extends({}, jaenField.value, {
        internalImageUrl: defaultValue
      }));
    }
  }, [value]);
  var gatsbyImage = usePageImage({
    id: jaenField == null ? void 0 : (_jaenField$staticValu = jaenField.staticValue) == null ? void 0 : _jaenField$staticValu.imageId,
    byFieldName: jaenField.name
  });
  var imageFieldProps = _extends({
    style: _extends({}, jaenField.style, {
      width: '100%',
      height: '100%'
    })
  }, props, {
    alt: value.alt || props.alt || jaenField.name + "-image",
    title: value.title
  });
  var imageElement = useMemo(function () {
    var _jaenField$value;
    var isLightbox = lightbox && !jaenField.isEditing;
    var renderAsDynamic = ((_jaenField$value = jaenField.value) == null ? void 0 : _jaenField$value.internalImageUrl) !== undefined || shouldOverload;
    var dataImage = jsx(Box, {
      boxSize: "full",
      className: "jaen-image-wrapper",
      cursor: isLightbox ? 'zoom-in' : 'default',
      children: jsx(DataImage, {
        imageFieldProps: imageFieldProps,
        internalImageUrl: value.internalImageUrl,
        imageData: gatsbyImage,
        alt: value.alt,
        renderAsDynamic: renderAsDynamic,
        onLoadingComplete: function onLoadingComplete() {
          if (overload) {
            setShouldOverload(true);
          }
        }
      })
    });
    if (isLightbox) {
      var _jaenField$value2, _jaenField$staticValu2;
      var staticImageUrl = gatsbyImage ? getSrc(gatsbyImage) : undefined;
      var photo = jsx(PhotoView, {
        src: ((_jaenField$value2 = jaenField.value) == null ? void 0 : _jaenField$value2.internalImageUrl) || staticImageUrl || ((_jaenField$staticValu2 = jaenField.staticValue) == null ? void 0 : _jaenField$staticValu2.internalImageUrl) || undefined,
        children: dataImage
      });
      if (lightboxGroup) {
        return photo;
      }
      return jsx(PhotoProvider, {
        maskOpacity: 0.8,
        children: photo
      });
    }
    return dataImage;
  }, [jaenField, lightbox, lightboxGroup, imageFieldProps, value, gatsbyImage, shouldOverload]);
  console.log('value 2', jaenField.name, value.internalImageUrl);
  return jsx(HighlightTooltip, {
    id: jaenField.id,
    actions: [jsx(Button, {
      variant: "jaenHighlightTooltipText",
      children: jsx(Tooltip$1, {
        label: "ID: " + jaenField.id,
        placement: "top-start",
        children: jsx(Text, {
          children: "Image"
        })
      })
    }, "jaen-highlight-tooltip-text-" + jaenField.name), jsxs(ButtonGroup, {
      size: "xs",
      spacing: "0.5",
      children: [jsx(ImageChooseButton, {
        onClick: handleImageChooseClick
      }), jsx(ImageEditButton, {
        src: value.internalImageUrl,
        name: jaenField.name,
        onUpdate: function onUpdate(_ref2) {
          var src = _ref2.src;
          jaenField.onUpdateValue(_extends({}, jaenField.value, {
            internalImageUrl: src
          }));
        }
      }), jsx(IconButton, {
        variant: "jaenHighlightTooltip",
        icon: jsx(BsEraser, {}),
        "aria-label": "Clear content",
        onClick: handleImageClearClick
      }), jsx(ImageAltSelector, {
        value: (value == null ? void 0 : value.alt) || '',
        onSave: handleImageAltSaveClick
      })]
    }, "jaen-highlight-tooltip-buttons-" + jaenField.name)],
    isEditing: jaenField.isEditing,
    boxSize: "full",
    children: imageElement
  });
}, {
  fieldType: 'IMA:ImageField'
});

var _excluded$4 = ["name", "renderPage"];
var IndexField = withRedux(function (_ref) {
  var name = _ref.name,
    renderPage = _ref.renderPage,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var _useJaenPageIndex = useJaenPageIndex(rest),
    children = _useJaenPageIndex.children,
    withJaenPage = _useJaenPageIndex.withJaenPage;
  return jsx(HighlightTooltip, {
    id: name,
    actions: [jsx(Button, {
      variant: "jaenHighlightTooltipText",
      children: jsx(Text, {
        as: "span",
        noOfLines: 1,
        children: "Index"
      })
    }, "jaen-highlight-tooltip-text-index")],
    children: children.map(function (page) {
      return withJaenPage(page.id, renderPage(page));
    })
  });
});

/**
 * @typedef {import('estree-jsx').Program} Program
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 *
 * @typedef {import('../index.js').MdxFlowExpression} MdxFlowExpression
 * @typedef {import('../index.js').MdxTextExpression} MdxTextExpression
 */

/**
 * Extension for `mdast-util-to-markdown` to enable MDX ESM.
 *
 * @type {ToMarkdownExtension}
 */
const mdxExpressionToMarkdown = {
  handlers: {
    mdxFlowExpression: handleMdxExpression,
    mdxTextExpression: handleMdxExpression
  },
  unsafe: [
    {character: '{', inConstruct: ['phrasing']},
    {atBreak: true, character: '{'}
  ]
};

/**
 * @type {ToMarkdownHandle}
 * @param {MdxFlowExpression | MdxTextExpression} node
 */
function handleMdxExpression(node) {
  const value = node.value || '';
  return '{' + value + '}'
}

/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
function ccount(value, character) {
  const source = String(value);

  if (typeof character !== 'string') {
    throw new TypeError('Expected character')
  }

  let count = 0;
  let index = source.indexOf(character);

  while (index !== -1) {
    count++;
    index = source.indexOf(character, index + character.length);
  }

  return count
}

/**
 * @typedef CoreOptions
 * @property {Array<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */

/**
 * Encode certain characters in `value`.
 *
 * @param {string} value
 * @param {CoreWithFormatOptions} options
 * @returns {string}
 */
function core(value, options) {
  value = value.replace(
    options.subset ? charactersToExpression(options.subset) : /["&'<>`]/g,
    basic
  );

  if (options.subset || options.escapeOnly) {
    return value
  }

  return (
    value
      // Surrogate pairs.
      .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, surrogate)
      // BMP control characters (C0 except for LF, CR, SP; DEL; and some more
      // non-ASCII ones).
      .replace(
        // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
        /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g,
        basic
      )
  )

  /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */
  function surrogate(pair, index, all) {
    return options.format(
      (pair.charCodeAt(0) - 0xd800) * 0x400 +
        pair.charCodeAt(1) -
        0xdc00 +
        0x10000,
      all.charCodeAt(index + 2),
      options
    )
  }

  /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */
  function basic(character, index, all) {
    return options.format(
      character.charCodeAt(0),
      all.charCodeAt(index + 1),
      options
    )
  }
}

/**
 * @param {Array<string>} subset
 * @returns {RegExp}
 */
function charactersToExpression(subset) {
  /** @type {Array<string>} */
  const groups = [];
  let index = -1;

  while (++index < subset.length) {
    groups.push(subset[index].replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'));
  }

  return new RegExp('(?:' + groups.join('|') + ')', 'g')
}

/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */
function formatBasic(code) {
  return '&#x' + code.toString(16).toUpperCase() + ';'
}

/**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */

/**
 * Encode special characters in `value` as hexadecimals.
 *
 * @param {string} value
 *   Value to encode.
 * @param {LightOptions} [options]
 *   Configuration.
 * @returns {string}
 *   Encoded value.
 */
function stringifyEntitiesLight(value, options) {
  return core(value, Object.assign({format: formatBasic}, options))
}

/**
 * @typedef {import('estree-jsx').Program} Program
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Token} Token
 * @typedef {import('mdast-util-from-markdown').OnEnterError} OnEnterError
 * @typedef {import('mdast-util-from-markdown').OnExitError} OnExitError
 *
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Tracker} Tracker
 *
 * @typedef {import('../index.js').MdxJsxAttributeValueExpression} MdxJsxAttributeValueExpression
 * @typedef {import('../index.js').MdxJsxAttribute} MdxJsxAttribute
 * @typedef {import('../index.js').MdxJsxExpressionAttribute} MdxJsxExpressionAttribute
 * @typedef {import('../index.js').MdxJsxFlowElement} MdxJsxFlowElement
 * @typedef {import('../index.js').MdxJsxTextElement} MdxJsxTextElement
 */

// To do: next major: use `state`, use utilities from state, rename `safeOptions` to `info`.

const indent = '  ';

/**
 * Create an extension for `mdast-util-to-markdown` to enable MDX JSX.
 *
 * This extension configures `mdast-util-to-markdown` with
 * `options.fences: true` and `options.resourceLink: true` too, do not
 * overwrite them!
 *
 * @param {ToMarkdownOptions | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable MDX JSX.
 */
function mdxJsxToMarkdown(options) {
  const options_ = options || {};
  const quote = options_.quote || '"';
  const quoteSmart = options_.quoteSmart || false;
  const tightSelfClosing = options_.tightSelfClosing || false;
  const printWidth = options_.printWidth || Number.POSITIVE_INFINITY;
  const alternative = quote === '"' ? "'" : '"';

  if (quote !== '"' && quote !== "'") {
    throw new Error(
      'Cannot serialize attribute values with `' +
        quote +
        '` for `options.quote`, expected `"`, or `\'`'
    )
  }

  mdxElement.peek = peekElement;

  return {
    handlers: {
      mdxJsxFlowElement: mdxElement,
      mdxJsxTextElement: mdxElement
    },
    unsafe: [
      {character: '<', inConstruct: ['phrasing']},
      {atBreak: true, character: '<'}
    ],
    // Always generate fenced code (never indented code).
    fences: true,
    // Always generate links with resources (never autolinks).
    resourceLink: true
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {MdxJsxFlowElement | MdxJsxTextElement} node
   */
  // eslint-disable-next-line complexity
  function mdxElement(node, _, context, safeOptions) {
    const flow = node.type === 'mdxJsxFlowElement';
    const selfClosing = node.name
      ? !node.children || node.children.length === 0
      : false;
    const depth = inferDepth(context);
    const currentIndent = createIndent(depth);
    const trackerOneLine = track(safeOptions);
    const trackerMultiLine = track(safeOptions);
    /** @type {Array<string>} */
    const serializedAttributes = [];
    const prefix = (flow ? currentIndent : '') + '<' + (node.name || '');
    const exit = context.enter(node.type);

    trackerOneLine.move(prefix);
    trackerMultiLine.move(prefix);

    // None.
    if (node.attributes && node.attributes.length > 0) {
      if (!node.name) {
        throw new Error('Cannot serialize fragment w/ attributes')
      }

      let index = -1;
      while (++index < node.attributes.length) {
        const attribute = node.attributes[index];
        /** @type {string} */
        let result;

        if (attribute.type === 'mdxJsxExpressionAttribute') {
          result = '{' + (attribute.value || '') + '}';
        } else {
          if (!attribute.name) {
            throw new Error('Cannot serialize attribute w/o name')
          }

          const value = attribute.value;
          const left = attribute.name;
          /** @type {string} */
          let right = '';

          if (value === undefined || value === null) ; else if (typeof value === 'object') {
            right = '{' + (value.value || '') + '}';
          } else {
            // If the alternative is less common than `quote`, switch.
            const appliedQuote =
              quoteSmart && ccount(value, quote) > ccount(value, alternative)
                ? alternative
                : quote;
            right =
              appliedQuote +
              stringifyEntitiesLight(value, {subset: [appliedQuote]}) +
              appliedQuote;
          }

          result = left + (right ? '=' : '') + right;
        }

        serializedAttributes.push(result);
      }
    }

    let attributesOnTheirOwnLine = false;
    const attributesOnOneLine = serializedAttributes.join(' ');

    if (
      // Block:
      flow &&
      // Including a line ending (expressions).
      (/\r?\n|\r/.test(attributesOnOneLine) ||
        // Current position (including `<tag`).
        trackerOneLine.current().now.column +
          // -1 because columns, +1 for ` ` before attributes.
          // Attributes joined by spaces.
          attributesOnOneLine.length +
          // ` />`.
          (selfClosing ? (tightSelfClosing ? 2 : 3) : 1) >
          printWidth)
    ) {
      attributesOnTheirOwnLine = true;
    }

    let tracker = trackerOneLine;
    let value = prefix;

    if (attributesOnTheirOwnLine) {
      tracker = trackerMultiLine;

      let index = -1;

      while (++index < serializedAttributes.length) {
        // Only indent first line of of attributes, we can’t indent attribute
        // values.
        serializedAttributes[index] =
          currentIndent + indent + serializedAttributes[index];
      }

      value += tracker.move(
        '\n' + serializedAttributes.join('\n') + '\n' + currentIndent
      );
    } else if (attributesOnOneLine) {
      value += tracker.move(' ' + attributesOnOneLine);
    }

    if (selfClosing) {
      value += tracker.move(
        (tightSelfClosing || attributesOnTheirOwnLine ? '' : ' ') + '/'
      );
    }

    value += tracker.move('>');

    if (node.children && node.children.length > 0) {
      if (node.type === 'mdxJsxTextElement') {
        value += tracker.move(
          containerPhrasing(node, context, {
            ...tracker.current(),
            before: '>',
            after: '<'
          })
        );
      } else {
        tracker.shift(2);
        value += tracker.move('\n');
        value += tracker.move(containerFlow(node, context, tracker.current()));
        value += tracker.move('\n');
      }
    }

    if (!selfClosing) {
      value += tracker.move(
        (flow ? currentIndent : '') + '</' + (node.name || '') + '>'
      );
    }

    exit();
    return value
  }
}

// Modified copy of:
// <https://github.com/syntax-tree/mdast-util-to-markdown/blob/a381cbc/lib/util/container-flow.js>.
//
// To do: add `indent` support to `mdast-util-to-markdown`.
// As indents are only used for JSX, it’s fine for now, but perhaps better
// there.
/**
 * @param {MdxJsxFlowElement} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {ReturnType<Tracker['current']>} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */
function containerFlow(parent, state, info) {
  const indexStack = state.indexStack;
  const children = parent.children;
  const tracker = state.createTracker(info);
  const currentIndent = createIndent(inferDepth(state));
  /** @type {Array<string>} */
  const results = [];
  let index = -1;

  indexStack.push(-1);

  while (++index < children.length) {
    const child = children[index];

    indexStack[indexStack.length - 1] = index;

    const childInfo = {before: '\n', after: '\n', ...tracker.current()};

    const result = state.handle(child, parent, state, childInfo);

    const serializedChild =
      child.type === 'mdxJsxFlowElement'
        ? result
        : indentLines(result, function (line, _, blank) {
            return (blank ? '' : currentIndent) + line
          });

    results.push(tracker.move(serializedChild));

    if (child.type !== 'list') {
      state.bulletLastUsed = undefined;
    }

    if (index < children.length - 1) {
      results.push(tracker.move('\n\n'));
    }
  }

  indexStack.pop();

  return results.join('')
}

/**
 *
 * @param {State} context
 * @returns {number}
 */
function inferDepth(context) {
  let depth = 0;

  for (const x of context.stack) {
    if (x === 'mdxJsxFlowElement') {
      depth++;
    }
  }

  return depth
}

/**
 * @param {number} depth
 * @returns {string}
 */
function createIndent(depth) {
  return indent.repeat(depth)
}

/**
 * @type {ToMarkdownHandle}
 */
function peekElement() {
  return '<'
}

/**
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('estree-jsx').Program} Program
 *
 * @typedef {import('../index.js').MdxjsEsm} MdxjsEsm
 */

/**
 * Extension for `mdast-util-to-markdown` to enable MDX ESM.
 *
 * @type {ToMarkdownExtension}
 */
const mdxjsEsmToMarkdown = {handlers: {mdxjsEsm: handleMdxjsEsm}};

/**
 * @type {ToMarkdownHandle}
 * @param {MdxjsEsm} node
 */
function handleMdxjsEsm(node) {
  return node.value || ''
}

/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-mdx-expression').MdxFlowExpression} MdxFlowExpression
 * @typedef {import('mdast-util-mdx-expression').MdxTextExpression} MdxTextExpression
 * @typedef {import('mdast-util-mdxjs-esm').MdxjsEsm} MdxjsEsm
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxAttributeValueExpression} MdxJsxAttributeValueExpression
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxAttribute} MdxJsxAttribute
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxExpressionAttribute} MdxJsxExpressionAttribute
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxFlowElement} MdxJsxFlowElement
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxTextElement} MdxJsxTextElement
 * @typedef {import('mdast-util-mdx-jsx').ToMarkdownOptions} ToMarkdownOptions
 */

/**
 * Create an extension for `mdast-util-to-markdown` to enable MDX (ESM, JSX,
 * expressions).
 *
 * @param {ToMarkdownOptions | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable MDX (ESM, JSX,
 *   expressions).
 */
function mdxToMarkdown(options) {
  return {
    extensions: [
      mdxExpressionToMarkdown,
      mdxJsxToMarkdown(options),
      mdxjsEsmToMarkdown
    ]
  }
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */

/**
 * Generate an assertion from a test.
 *
 * Useful if you’re going to test many nodes, for example when creating a
 * utility where something else passes a compatible test.
 *
 * The created function is a bit faster because it expects valid input only:
 * a `node`, `index`, and `parent`.
 *
 * @param test
 *   *   when nullish, checks if `node` is a `Node`.
 *   *   when `string`, works like passing `(node) => node.type === test`.
 *   *   when `function` checks if function passed the node is true.
 *   *   when `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
 *   *   when `array`, checks if any one of the subtests pass.
 * @returns
 *   An assertion.
 */
const convert =
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  );

/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array<AssertAnything>} */
  const checks = [];
  let index = -1;

  while (++index < tests.length) {
    checks[index] = convert(tests[index]);
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    let index = -1;

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }

    return false
  }
}

/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    let key;

    for (key in check) {
      // @ts-expect-error: hush, it sure works as an index.
      if (node[key] !== check[key]) return false
    }

    return true
  }
}

/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(node, ...parameters) {
    return Boolean(
      node &&
        typeof node === 'object' &&
        'type' in node &&
        // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters))
    )
  }
}

function ok() {
  return true
}

/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */

/**
 * Continue traversing as normal.
 */
const CONTINUE = true;

/**
 * Stop traversing immediately.
 */
const EXIT = false;

/**
 * Do not traverse this node’s children.
 */
const SKIP = 'skip';

/**
 * Visit nodes, with ancestral information.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @param tree
 *   Tree to traverse.
 * @param test
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Handle each node.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns
 *   Nothing.
 */
const visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
      }

      const is = convert(test);
      const step = reverse ? -1 : 1;

      factory(tree, undefined, [])();

      /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = node && typeof node === 'object' ? node : {};

        if (typeof value.type === 'string') {
          const name =
            // `hast`
            typeof value.tagName === 'string'
              ? value.tagName
              : // `xast`
              typeof value.name === 'string'
              ? value.name
              : undefined;

          Object.defineProperty(visit, 'name', {
            value:
              'node (' + color(node.type + (name ? '<' + name + '>' : '')) + ')'
          });
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = [];
          /** @type {ActionTuple} */
          let subresult;
          /** @type {number} */
          let offset;
          /** @type {Array<Parent>} */
          let grandparents;

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents));

            if (result[0] === EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step;
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node);

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)();

              if (subresult[0] === EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step;
            }
          }

          return result
        }
      }
    }
  );

/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @param tree
 *   Tree to traverse.
 * @param test
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Handle each node.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns
 *   Nothing.
 */
const visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
      }

      visitParents(tree, test, overload, reverse);

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  );

var rehypeUnwrapImages = function rehypeUnwrapImages() {
  return function (tree) {
    visit(tree, 'element', visitor);
  };
  function visitor(node, index, parent) {
    console.log('visitor', node.tagName, parent == null ? void 0 : parent.tagName, index);
    if (node.tagName === 'img' && parent && parent.tagName === 'p') {
      parent.tagName = 'div';
    }
  }
};

var parseMdast = function parseMdast(tree) {
  var out = toMarkdown(tree, {
    extensions: [mdxToMarkdown(), gfmToMarkdown(), directiveToMarkdown, frontmatterToMarkdown()]
  });
  return out;
};
function createFile(value) {
  return new VFile({
    basename: 'example.mdx',
    value: value
  });
}
function evaluateFile(file) {
  var capture = function capture(name) {
    return function () {
      return function (tree) {
        file.data[name] = tree;
      };
    };
  };
  try {
    file.result = evaluateSync(file, _extends({}, runtime, {
      development: false,
      useDynamicImport: true,
      remarkPlugins: [remarkGfm, remarkFrontmatter, remarkMath, remarkDirective, capture('mdast')],
      rehypePlugins: [rehypeSlug, rehypeUnwrapImages, [rehypeMdxCodeProps, {
        tagName: 'code'
      }]],
      recmaPlugins: []
    }))["default"];
  } catch (error) {
    var message = error instanceof VFileMessage ? error : new VFileMessage(error);
    if (!file.messages.includes(message)) {
      file.messages.push(message);
    }
    message.fatal = true;
  }
}
var initializeState = function initializeState(defaults) {
  var markdown = defaults.mdast ? parseMdast(defaults.mdast) : '';
  var file = createFile(markdown);
  evaluateFile(file);
  return _extends({}, defaults, {
    value: markdown,
    file: file
  });
};
function useMdx(defaults, live) {
  if (live === void 0) {
    live = false;
  }
  var _useState = useState(function () {
      return initializeState(defaults);
    }),
    state = _useState[0],
    setState = _useState[1];
  useEffect(function () {
    if (live) {
      setState(initializeState(defaults));
    }
  }, [defaults, live]);
  var _useDebounceFn = useDebounceFn(function (config) {
      try {
        var file = createFile(config.value);
        evaluateFile(file);
        setState(_extends({}, config, {
          file: file
        }));
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    }, {
      leading: true,
      trailing: true,
      wait: 200
    }),
    setConfig = _useDebounceFn.run;
  return [state, setConfig];
}

var ErrorFallback = function ErrorFallback(_ref) {
  var error = _ref.error,
    resetErrorBoundary = _ref.resetErrorBoundary;
  return jsxs(Alert, {
    status: "error",
    children: [jsx(AlertIcon, {}), jsx(AlertTitle, {
      children: "Something went wrong"
    }), jsxs(AlertDescription, {
      children: [jsx("pre", {
        children: error.message
      }), jsx(Button, {
        onClick: resetErrorBoundary,
        children: "Try again"
      })]
    })]
  });
};

var StatsErrorReporter = function StatsErrorReporter(_ref) {
  var stats = _ref.stats,
    state = _ref.state;
  var vfileReporter = function vfileReporter(file) {
    return JSON.stringify(file.messages, null, 2);
  };
  return jsx(Fragment, {
    children: stats.fatal || stats.warn ? jsx("pre", {
      children: jsx("code", {
        children: vfileReporter(state.file)
      })
    }) : null
  });
};

var _excluded$3 = ["className"];
function _catch$1(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var FallbackComponent = function FallbackComponent(_ref) {
  var error = _ref.error;
  var message = new VFileMessage(error);
  message.fatal = true;
  return jsx("pre", {
    children: jsx("code", {
      children: String(message)
    })
  });
};
var processContent = function processContent(_ref2) {
  var state = _ref2.state,
    components = _ref2.components;
  try {
    if (typeof state.file.result !== 'function') {
      throw new Error("Preview could not be generated.");
    }
    return state.file.result({
      components: _extends({
        code: function code(_ref3) {
          var className = _ref3.className,
            props = _objectWithoutPropertiesLoose(_ref3, _excluded$3);
          var match = /language-(\w+)/.exec(className || '');
          return match ? jsx(SyntaxHighlighter, _extends({
            language: match[1],
            PreTag: "div"
          }, props)) : jsx("code", _extends({
            className: className
          }, props));
        }
      }, components)
    });
  } catch (error) {
    throw error;
  }
};
var PreviewComponent = function PreviewComponent(_ref4) {
  var _state$file;
  var state = _ref4.state,
    stats = _ref4.stats,
    components = _ref4.components;
  var _useState = useState(function () {
      return processContent({
        state: state,
        components: components
      });
    }),
    content = _useState[0],
    setContent = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  useEffect(function () {
    var processState = function processState() {
      try {
        var _temp = _catch$1(function () {
          return Promise.resolve(processContent({
            state: state,
            components: components
          })).then(function (result) {
            setContent(result);
            setError(null);
          });
        }, function (error) {
          setError(error);
        });
        return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    processState();
  }, [state.file, components]);
  return jsxs(ErrorBoundary, {
    FallbackComponent: ErrorFallback,
    children: [jsx("noscript", {
      children: "Enable JavaScript for the rendered result."
    }), ((_state$file = state.file) == null ? void 0 : _state$file.result) && jsx(Fragment, {
      children: content
    }), error && jsx(FallbackComponent, {
      error: error
    }), jsx(StatsErrorReporter, {
      state: state,
      stats: stats
    })]
  });
};

var Preview = React__default.memo(function (_ref) {
  var components = _ref.components,
    mdast = _ref.mdast;
  var defaults = useMemo(function () {
    return {
      gfm: true,
      frontmatter: true,
      math: true,
      directive: true,
      mdast: mdast
    };
  }, [mdast]);
  var _useMdx = useMdx(defaults, true),
    state = _useMdx[0];
  var stats = state.file ? statistics(state.file) : {};
  return jsx(PreviewComponent, {
    state: state,
    stats: stats,
    components: components
  });
});

var _excluded$2 = ["name", "defaultValue", "alt"];
var Image = function Image(_ref) {
  var name = _ref.name,
    defaultValue = _ref.defaultValue,
    alt = _ref.alt,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return jsx(Box, _extends({}, rest, {
    children: jsx(Field.Image, {
      name: name,
      defaultValue: defaultValue,
      alt: alt
    })
  }));
};
Image.defaultProps = {
  name: function name() {
    return "image-" + (Math.random() + 1).toString(36).substring(7);
  },
  defaultValue: 'https://via.placeholder.com/150'
};
var Link = function Link(_ref2) {
  var to = _ref2.to,
    children = _ref2.children;
  if (to.startsWith('/')) {
    return jsx(Link$1, {
      as: Link$2,
      to: to,
      children: children
    });
  }
  return jsx(Link$1, {
    href: to,
    isExternal: true,
    children: children
  });
};
Link.defaultProps = {
  to: '/',
  children: 'My Link'
};

var defaultData = {
  type: 'root',
  children: [{
    type: 'heading',
    depth: 1,
    children: [{
      type: 'text',
      value: 'Hello, world!',
      position: {
        start: {
          line: 1,
          column: 3,
          offset: 2
        },
        end: {
          line: 1,
          column: 16,
          offset: 15
        }
      }
    }],
    position: {
      start: {
        line: 1,
        column: 1,
        offset: 0
      },
      end: {
        line: 1,
        column: 16,
        offset: 15
      }
    }
  }, {
    type: 'paragraph',
    children: [{
      type: 'text',
      value: '// This is a ',
      position: {
        start: {
          line: 3,
          column: 1,
          offset: 17
        },
        end: {
          line: 3,
          column: 14,
          offset: 30
        }
      }
    }, {
      type: 'strong',
      children: [{
        type: 'text',
        value: 'jaen',
        position: {
          start: {
            line: 3,
            column: 16,
            offset: 32
          },
          end: {
            line: 3,
            column: 20,
            offset: 36
          }
        }
      }],
      position: {
        start: {
          line: 3,
          column: 14,
          offset: 30
        },
        end: {
          line: 3,
          column: 22,
          offset: 38
        }
      }
    }, {
      type: 'text',
      value: ' MDX field.',
      position: {
        start: {
          line: 3,
          column: 22,
          offset: 38
        },
        end: {
          line: 3,
          column: 33,
          offset: 49
        }
      }
    }],
    position: {
      start: {
        line: 3,
        column: 1,
        offset: 17
      },
      end: {
        line: 3,
        column: 33,
        offset: 49
      }
    }
  }, {
    type: 'paragraph',
    children: [{
      type: 'text',
      value: '// ## Usage',
      position: {
        start: {
          line: 5,
          column: 1,
          offset: 51
        },
        end: {
          line: 5,
          column: 12,
          offset: 62
        }
      }
    }],
    position: {
      start: {
        line: 5,
        column: 1,
        offset: 51
      },
      end: {
        line: 5,
        column: 12,
        offset: 62
      }
    }
  }, {
    type: 'paragraph',
    children: [{
      type: 'text',
      value: '// You can use this field to write markdown content.\n//',
      position: {
        start: {
          line: 7,
          column: 1,
          offset: 64
        },
        end: {
          line: 8,
          column: 3,
          offset: 119
        }
      }
    }],
    position: {
      start: {
        line: 7,
        column: 1,
        offset: 64
      },
      end: {
        line: 8,
        column: 4,
        offset: 120
      }
    }
  }],
  position: {
    start: {
      line: 1,
      column: 1,
      offset: 0
    },
    end: {
      line: 15,
      column: 8,
      offset: 228
    }
  }
};

var MdxField = connectField(function (_ref) {
  var jaenField = _ref.jaenField,
    components = _ref.components;
  var _React$useState = React__default.useState(jaenField.staticValue || defaultData),
    rawValue = _React$useState[0],
    setRawValue = _React$useState[1];
  useEffect(function () {
    setRawValue(jaenField.value || jaenField.staticValue || defaultData);
  }, [jaenField.value]);
  components = _extends({}, components, {
    img: function img(props) {
      var src = props.src;
      var alt = props.alt;
      var name = src + "-" + alt;
      return jsx(Image, {
        name: name,
        defaultValue: src,
        alt: alt
      });
    },
    Image: Image,
    a: function a(props) {
      return jsx(Link, {
        to: props.href,
        children: props.children
      });
    },
    Link: Link
  });
  if (jaenField.isEditing) {
    return jsx(LayzEditor, {
      components: components,
      onUpdateValue: jaenField.onUpdateValue,
      rawValue: rawValue
    });
  } else {
    return jsx(Preview, {
      components: components,
      mdast: rawValue
    });
  }
}, {
  fieldType: 'IMA:MdxField'
});
var LayzEditor = function LayzEditor(_ref2) {
  var components = _ref2.components,
    onUpdateValue = _ref2.onUpdateValue,
    rawValue = _ref2.rawValue;
  var Editor = React__default.lazy(function () {
    try {
      return Promise.resolve(import('./Editor-a3b47668.js'));
    } catch (e) {
      return Promise.reject(e);
    }
  });
  var MemoedEditor = React__default.useMemo(function () {
    return Editor;
  }, []);
  return jsx(React__default.Suspense, {
    fallback: jsx("div", {
      children: "Loading..."
    }),
    children: jsx(MemoedEditor, {
      components: components,
      onUpdateValue: onUpdateValue,
      mode: "editAndPreview",
      mdast: rawValue
    })
  });
};

function useSectionData(sectionName, options) {
  var _ref = options || {},
    _ref$forceUpdate = _ref.forceUpdate,
    forceUpdate = _ref$forceUpdate === void 0 ? false : _ref$forceUpdate;
  var jaenSection = useSectionBlockContext();
  var sectionPath = React.useMemo(function () {
    return ((jaenSection == null ? void 0 : jaenSection.path) || []).concat({
      fieldName: sectionName,
      sectionId: jaenSection == null ? void 0 : jaenSection.id
    });
  }, []);
  var _usePageContext = usePageContext(),
    jaenPage = _usePageContext.jaenPage;
  if (!jaenPage.id) {
    throw new Error('JaenPage id is undefined! connectField must be used within a JaenPage');
  }
  var staticSection = React.useMemo(function () {
    return findSection(jaenPage.sections || [], sectionPath);
  }, [jaenPage.sections, sectionPath]);
  var dynamicSection = useAppSelector(function (state) {
    var _state$page$pages$nod;
    return findSection(((_state$page$pages$nod = state.page.pages.nodes[jaenPage.id]) == null ? void 0 : _state$page$pages$nod.sections) || [], sectionPath);
  }, function (l, r) {
    if (forceUpdate) {
      return false;
    }
    var stringifyWithExclusion = function stringifyWithExclusion(obj, excludedKey) {
      return JSON.stringify(obj, function (key, value) {
        if (key === excludedKey) {
          return undefined;
        }
        return value;
      });
    };
    return stringifyWithExclusion(l, 'jaenFields') === stringifyWithExclusion(r, 'jaenFields');
  });
  var _React$useState = React.useState(staticSection || {
      fieldName: sectionName,
      ptrHead: null,
      items: [],
      ptrTail: null
    }),
    section = _React$useState[0],
    setSection = _React$useState[1];
  React.useEffect(function () {
    var _mergedSection$items;
    var mergedSection = deepmerge(staticSection || {}, dynamicSection || {}, {
      arrayMerge: deepmergeArrayIdMerge
    });
    var sectionItemsDict = {};
    mergedSection == null ? void 0 : (_mergedSection$items = mergedSection.items) == null ? void 0 : _mergedSection$items.forEach(function (item) {
      sectionItemsDict[item.id] = item;
    });
    var orderedSectionItems = [];
    var ptrHead = mergedSection == null ? void 0 : mergedSection.ptrHead;
    var i = 0;
    while (ptrHead && i < 50) {
      var item = sectionItemsDict[ptrHead];
      if (item == null) {
        throw new Error("ptrHead " + ptrHead + " is not found in section items!");
      }
      i++;
      ptrHead = item.ptrNext;
      if (item.deleted) {
        continue;
      }
      orderedSectionItems.push(item);
    }
    mergedSection.items = orderedSectionItems;
    setSection(mergedSection);
  }, [dynamicSection]);
  return {
    data: section,
    sectionPath: sectionPath
  };
}

var useSectionField = function useSectionField(sectionName, blocks) {
  var _usePageContext = usePageContext(),
    jaenPage = _usePageContext.jaenPage;
  var _useSectionData = useSectionData(sectionName),
    section = _useSectionData.data,
    sectionPath = _useSectionData.sectionPath;
  var sectionsDict = useMemo(function () {
    var t = blocks.reduce(function (acc, Section) {
      var _extends2;
      return _extends({}, acc, (_extends2 = {}, _extends2[Section.options.name] = {
        Component: Section,
        options: Section.options
      }, _extends2));
    }, {});
    return t;
  }, [blocks]);
  var onSectionAdd = useCallback(function (sectionItemType, between) {
    store.dispatch(actions.section_add({
      pageId: jaenPage.id,
      sectionItemType: sectionItemType,
      path: sectionPath,
      between: between
    }));
  }, []);
  var onSectionDelete = useCallback(function (id, ptrPrev, ptrNext) {
    store.dispatch(actions.section_remove({
      pageId: jaenPage.id,
      sectionId: id,
      path: sectionPath,
      between: [ptrPrev, ptrNext]
    }));
  }, []);
  var onSectionMove = useCallback(function (id, ptrPrev, ptrNext, ptrNew, direction) {
    store.dispatch(actions.section_move({
      pageId: jaenPage.id,
      sectionId: id,
      path: sectionPath,
      between: [ptrPrev, ptrNext],
      move: {
        direction: direction,
        ptrNew: ptrNew
      }
    }));
  }, []);
  var onSectionAppend = useCallback(function (sectionName, id, ptrNext) {
    onSectionAdd(sectionName, [id, ptrNext || null]);
  }, []);
  var onSectionPrepend = useCallback(function (sectionName, id, ptrPrev) {
    onSectionAdd(sectionName, [ptrPrev || null, id]);
  }, []);
  return {
    onSectionAdd: onSectionAdd,
    onSectionDelete: onSectionDelete,
    onSectionMove: onSectionMove,
    onSectionAppend: onSectionAppend,
    onSectionPrepend: onSectionPrepend,
    section: section,
    sectionsDict: sectionsDict,
    sectionPath: sectionPath
  };
};

var useIncomingBuild = function useIncomingBuild() {
  var key = 'ljch';
  var latestWebpackCompilationHash = typeof window !== 'undefined' ? window.___webpackCompilationHash : undefined;
  var isDisabled = latestWebpackCompilationHash === undefined;
  var isIncomingBuild = function isIncomingBuild() {
    if (typeof window === 'undefined') {
      return false;
    }
    var latestJaenCompilationHash = localStorage.getItem(key);
    if (latestWebpackCompilationHash && latestJaenCompilationHash !== null && latestWebpackCompilationHash !== latestJaenCompilationHash) {
      return true;
    }
    if (latestWebpackCompilationHash) {
      var isJaenStateKeySet = localStorage.getItem(persistKey) !== null;
      if (isJaenStateKeySet) {
        localStorage.setItem(key, latestWebpackCompilationHash);
      }
    }
    return false;
  };
  var updateToLatest = function updateToLatest() {
    resetState();
    localStorage.removeItem(key);
  };
  return {
    isIncomingBuild: isIncomingBuild(),
    isDisabled: isDisabled,
    updateToLatest: updateToLatest
  };
};

var IncomingBuildChecker = withRedux(function () {
  var _useDisclosure = useDisclosure(),
    isOpen = _useDisclosure.isOpen,
    onOpen = _useDisclosure.onOpen,
    onClose = _useDisclosure.onClose;
  var _useIncomingBuild = useIncomingBuild(),
    isIncomingBuild = _useIncomingBuild.isIncomingBuild,
    updateToLatest = _useIncomingBuild.updateToLatest;
  useEffect(function () {
    if (isIncomingBuild) {
      onOpen();
    }
  }, [isIncomingBuild]);
  var handleUpdateConfirm = function handleUpdateConfirm() {
    try {
      updateToLatest();
      return Promise.resolve(true);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useChanges = useChanges(),
    totalChanges = _useChanges.totalChanges;
  return jsx(IncomingBuildAlert, {
    isOpen: isOpen,
    onClose: onClose,
    onConfirm: handleUpdateConfirm,
    totalChanges: totalChanges
  });
});
function useChanges() {
  return {
    totalChanges: 0
  };
}

var IncomingBuildCheckerContext = createContext(undefined);
var useIncomingBuildChecker = function useIncomingBuildChecker() {
  var context = useContext(IncomingBuildCheckerContext);
  if (context === undefined) {
    throw new Error('useIncomingBuildChecker must be within IncomingBuildCheckerProvider');
  }
  return context;
};

const _iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }
        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }
    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }
    pact.s = state;
    pact.v = value;
    var observer = pact.o;
    if (observer) {
      observer(pact);
    }
  }
}
var _Pact = /*#__PURE__*/function () {
  function _Pact() {}
  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;
    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;
      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }
        return result;
      } else {
        return this;
      }
    }
    this.o = function (_this) {
      try {
        var value = _this.v;
        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };
    return result;
  };
  return _Pact;
}();
function _isSettledPact(thenable) {
  return thenable instanceof _Pact && thenable.s & 1;
}
function _forTo(array, body, check) {
  var i = -1,
    pact,
    reject;
  function _cycle(result) {
    try {
      while (++i < array.length && (!check || !check())) {
        result = body(i);
        if (result && result.then) {
          if (_isSettledPact(result)) {
            result = result.v;
          } else {
            result.then(_cycle, reject || (reject = _settle.bind(null, pact = new _Pact(), 2)));
            return;
          }
        }
      }
      if (pact) {
        _settle(pact, 1, result);
      } else {
        pact = result;
      }
    } catch (e) {
      _settle(pact || (pact = new _Pact()), 2, e);
    }
  }
  _cycle();
  return pact;
}
function _forOf(target, body, check) {
  if (typeof target[_iteratorSymbol] === "function") {
    var _cycle = function _cycle(result) {
      try {
        while (!(step = iterator.next()).done && (!check || !check())) {
          result = body(step.value);
          if (result && result.then) {
            if (_isSettledPact(result)) {
              result = result.v;
            } else {
              result.then(_cycle, reject || (reject = _settle.bind(null, pact = new _Pact(), 2)));
              return;
            }
          }
        }
        if (pact) {
          _settle(pact, 1, result);
        } else {
          pact = result;
        }
      } catch (e) {
        _settle(pact || (pact = new _Pact()), 2, e);
      }
    };
    var iterator = target[_iteratorSymbol](),
      step,
      pact,
      reject;
    _cycle();
    if (iterator["return"]) {
      var _fixup = function _fixup(value) {
        try {
          if (!step.done) {
            iterator["return"]();
          }
        } catch (e) {}
        return value;
      };
      if (pact && pact.then) {
        return pact.then(_fixup, function (e) {
          throw _fixup(e);
        });
      }
      _fixup();
    }
    return pact;
  }
  // No support for Symbol.iterator
  if (!("length" in target)) {
    throw new TypeError("Object is not iterable");
  }
  // Handle live collections properly
  var values = [];
  for (var i = 0; i < target.length; i++) {
    values.push(target[i]);
  }
  return _forTo(values, function (i) {
    return body(values[i]);
  }, check);
}
var loadPopupComponents = function loadPopupComponents(jaenPopup, allJaenPopup) {
  try {
    var popups = [];
    var _temp = _forOf(jaenPopup.nodes, function (_ref) {
      var relativePath = _ref.relativePath;
      return Promise.resolve(popupLoader(relativePath)).then(function (Popup) {
        if (Popup) {
          var popup = allJaenPopup.nodes.find(function (node) {
            return node.id === relativePath;
          });
          popups.push({
            id: relativePath,
            isActive: !!(popup != null && popup.active),
            popup: popup,
            Component: Popup
          });
        }
      });
    });
    return Promise.resolve(_temp && _temp.then ? _temp.then(function () {
      return popups;
    }) : popups);
  } catch (e) {
    return Promise.reject(e);
  }
};

var loadNotificationsForPage = function loadNotificationsForPage(jaenPopup, allJaenPopup, dynamicNotifications, pageProps, stateAdvanced) {
  try {
    var blacklist = ['/admin'];
    if (blacklist.some(function (item) {
      return pageProps.path.startsWith(item);
    })) {
      return Promise.resolve([]);
    }
    return Promise.resolve(loadPopupComponents(jaenPopup, allJaenPopup)).then(function (popups) {
      var allNotificationElement = [];
      var _loop = function _loop() {
        var _dynamicNotifications;
        var _step$value = _step.value,
          Component = _step$value.Component,
          id = _step$value.id,
          isActive = _step$value.isActive,
          popup = _step$value.popup;
        var isDynamicActive = dynamicNotifications == null ? void 0 : (_dynamicNotifications = dynamicNotifications[id]) == null ? void 0 : _dynamicNotifications.active;
        if (isDynamicActive === false) {
          return "continue";
        }
        if (isDynamicActive === undefined) {
          if (!isActive) {
            return "continue";
          }
        }
        var pushNotification = function pushNotification() {
          allNotificationElement.push(jsx(Component, {
            id: id,
            popup: popup
          }));
        };
        var _Component$options = Component.options,
          advanced = _Component$options.advanced,
          conditions = _Component$options.conditions,
          customCondition = _Component$options.customCondition;
        var notificationAdvanced = stateAdvanced[id];
        if (advanced && notificationAdvanced) {
          if (advanced.showAfterXPageViews) {
            if (notificationAdvanced.pageViews >= advanced.showAfterXPageViews) {
              pushNotification();
            }
            return "continue";
          }
          if (advanced.showUntilXPageViews) {
            if (notificationAdvanced.pageViews <= advanced.showUntilXPageViews) {
              pushNotification();
            }
            return "continue";
          }
        }
        if (customCondition) {
          var condition = customCondition(pageProps);
          if (condition) {
            pushNotification();
          }
          return "continue";
        }
        if (conditions) {
          var entireSite = conditions.entireSite,
            templates = conditions.templates,
            urlPatterns = conditions.urlPatterns;
          if (entireSite) {
            pushNotification();
            return "continue";
          }
          if (templates) {
            var _pageProps$data, _pageProps$data$jaenP;
            var staticTemplate = (_pageProps$data = pageProps.data) == null ? void 0 : (_pageProps$data$jaenP = _pageProps$data.jaenPage) == null ? void 0 : _pageProps$data$jaenP.template;
            if (staticTemplate && templates.includes(staticTemplate)) {
              pushNotification();
              return "continue";
            }
          }
          if (urlPatterns) {
            var staticUrl = pageProps.location.pathname;
            for (var _iterator2 = _createForOfIteratorHelperLoose(urlPatterns), _step2; !(_step2 = _iterator2()).done;) {
              var urlPattern = _step2.value;
              if (staticUrl.match(urlPattern)) {
                pushNotification();
                continue;
              }
            }
          }
        }
      };
      for (var _iterator = _createForOfIteratorHelperLoose(popups), _step; !(_step = _iterator()).done;) {
        var _ret = _loop();
        if (_ret === "continue") continue;
      }
      return allNotificationElement;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var usePopupsInject = function usePopupsInject(_ref) {
  var pageProps = _ref.pageProps;
  var _usePopupStaticQuery = usePopupStaticQuery(),
    jaenPopup = _usePopupStaticQuery.jaenPopup,
    allJaenPopup = _usePopupStaticQuery.allJaenPopup;
  var advanced = useAppSelector(function (state) {
    return state.popup.advanced;
  });
  var dynamicPopupNodes = useAppSelector(function (state) {
    return state.popup.nodes;
  });
  var _useState = useState([]),
    elements = _useState[0],
    setElements = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  useEffect(function () {
    var loadPopups = function loadPopups() {
      try {
        setIsLoading(true);
        return Promise.resolve(loadNotificationsForPage(jaenPopup, allJaenPopup, dynamicPopupNodes, pageProps, advanced)).then(function (elements) {
          setElements(elements);
          setIsLoading(false);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void loadPopups();
  }, []);
  return {
    elements: elements,
    isLoading: isLoading
  };
};

var InjectPopups = function InjectPopups(_ref) {
  var pageProps = _ref.pageProps;
  var _usePopupsInject = usePopupsInject({
      pageProps: pageProps
    }),
    elements = _usePopupsInject.elements;
  return jsx(Fragment, {
    children: elements
  });
};

function usePromiseEffect(effect, deps) {
  var _React$useState = React.useState({
      status: 'idle',
      value: null,
      error: null
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  React.useEffect(function () {
    effect().then(function (value) {
      setState({
        status: 'fulfilled',
        value: value,
        error: null
      });
    })["catch"](function (error) {
      setState({
        status: 'rejected',
        value: null,
        error: error
      });
    });
  }, deps);
  return state;
}

var useDynamicPaths = function useDynamicPaths() {
  var _useState = useState(getDynamicPaths()),
    dynamicPaths = _useState[0],
    setDynamicPaths = _useState[1];
  useEffect(function () {
    var unsubscribe = store.subscribe(function () {
      var newDynamicPaths = getDynamicPaths();
      if (JSON.stringify(newDynamicPaths) !== JSON.stringify(dynamicPaths)) {
        setDynamicPaths(newDynamicPaths);
      }
    });
    return unsubscribe;
  }, []);
  return dynamicPaths;
};
function getDynamicPaths() {
  var state = store.getState();
  var dynamicPaths = state.page.routing.dynamicPaths;
  return dynamicPaths;
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var DynamicRoute = function DynamicRoute(props) {
  var jaenPagePaths = useJaenPagePaths();
  var dynamicPaths = useDynamicPaths();
  var path = props.path.endsWith('/') ? props.path : props.path + "/";
  var loadingComponent = jsx(Center, {
    my: "24",
    children: jsx(CircularProgress, {
      isIndeterminate: true
    })
  });
  var TemplateLoader = function TemplateLoader(_ref) {
    var _pageData$result;
    var path = _ref.path;
    var dynamicPath = dynamicPaths[path];
    if (dynamicPath == null) {
      return null;
    }
    var pageId = dynamicPath.pageId,
      templateName = dynamicPath.templateName;
    var _useSiteContext = useSiteContext(),
      templateLoader = _useSiteContext.templateLoader;
    useEffect(function () {
      if (!(path in dynamicPaths)) {
        var newPath = Object.keys(dynamicPaths).find(function (path) {
          var _dynamicPaths$path;
          return ((_dynamicPaths$path = dynamicPaths[path]) == null ? void 0 : _dynamicPaths$path.pageId) === pageId;
        });
        if (newPath) {
          void navigate(newPath);
        } else {
          void navigate('/');
        }
      }
    }, [dynamicPaths]);
    var _useJaenTemplates = useJaenTemplates(),
      templates = _useJaenTemplates.templates;
    var template = templates ? templates.find(function (t) {
      return t.name === templateName;
    }) : null;
    var _usePromiseEffect = usePromiseEffect(function () {
        try {
          var _exit;
          var _temp4 = function () {
            if (template) {
              var _temp3 = function _temp3() {
                return Promise.resolve(templateLoader(templateName)).then(function (_templateLoader) {
                  var _Component$pageData = {
                    Component: _templateLoader,
                    pageData: _pageData
                  };
                  _exit = 1;
                  return _Component$pageData;
                });
              };
              var buildJaenPage = jaenPagePaths.find(function (path) {
                return path.id === pageId;
              });
              var _pageData = null;
              var _temp2 = function () {
                if (buildJaenPage) {
                  var _temp = _catch(function () {
                    return Promise.resolve(fetch(buildJaenPage.buildPath)).then(function (repsonse) {
                      return Promise.resolve(repsonse.json()).then(function (_repsonse$json) {
                        _pageData = _repsonse$json;
                      });
                    });
                  }, function (e) {
                    console.error(e);
                  });
                  if (_temp && _temp.then) return _temp.then(function () {});
                }
              }();
              return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
            }
          }();
          return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function (_result) {
            return _exit ? _result : null;
          }) : _exit ? _temp4 : null);
        } catch (e) {
          return Promise.reject(e);
        }
      }, [template]),
      value = _usePromiseEffect.value;
    var _ref2 = value != null ? value : {},
      Component = _ref2.Component,
      pageData = _ref2.pageData;
    if (Component == null) {
      return loadingComponent;
    }
    return jsx(Component, _extends({}, props, {
      pageContext: _extends({
        jaenPageId: pageId
      }, pageData == null ? void 0 : pageData.pageContext),
      data: _extends({
        jaenPage: null
      }, pageData == null ? void 0 : (_pageData$result = pageData.result) == null ? void 0 : _pageData$result.data)
    }));
  };
  if (!path || dynamicPaths[path] == null) {
    return loadingComponent;
  }
  return jsx(TemplateLoader, {
    path: path
  });
};
var useDynamicRoute = function useDynamicRoute(_ref3) {
  var pageProps = _ref3.pageProps;
  var _useState = useState(),
    node = _useState[0],
    setNode = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var dynamicRoutes = useDynamicPaths();
  var isDynamic = useMemo(function () {
    var path = pageProps.path.endsWith('/') ? pageProps.path : pageProps.path + "/";
    var isDynamic = Object.keys(dynamicRoutes).includes(path);
    return isDynamic;
  }, [pageProps.path, dynamicRoutes]);
  useEffect(function () {
    if (isDynamic) {
      setIsLoading(true);
      console.log("Setting dynamic route for " + window.location.pathname, pageProps);
      setNode(jsx(DynamicRoute, _extends({}, pageProps)));
      setIsLoading(false);
    } else {
      setNode(undefined);
    }
  }, [pageProps.path, dynamicRoutes, isDynamic]);
  var value = useMemo(function () {
    return {
      node: node,
      isLoading: isLoading
    };
  }, [node, isLoading]);
  return value;
};

var ActivationButton = React__default.lazy(function () {
  try {
    return Promise.resolve(import('./ActivationButton-b8e98e41.js'));
  } catch (e) {
    return Promise.reject(e);
  }
});
var LazyHighlightProvider = function LazyHighlightProvider(_ref) {
  var children = _ref.children;
  var Provider = React__default.lazy(function () {
    try {
      return Promise.resolve(Promise.resolve().then(function () { return HighlightContext; }));
    } catch (e) {
      return Promise.reject(e);
    }
  });
  return jsx(React__default.Suspense, {
    fallback: jsx(LoadingPage, {}),
    children: jsx(Provider, {
      children: children
    })
  });
};
var GatsbyRootWrapper = function GatsbyRootWrapper(_ref2) {
  var children = _ref2.children;
  var MayeLazy = function MayeLazy(_ref3) {
    var children = _ref3.children;
    var _useAuthentication = useAuthentication(),
      isAuthenticated = _useAuthentication.isAuthenticated,
      isLoading = _useAuthentication.isLoading;
    if (!isAuthenticated || isLoading) {
      return jsx(Fragment, {
        children: children
      });
    }
    return jsx(React__default.Suspense, {
      fallback: jsx(LoadingPage, {}),
      children: jsx(LazyHighlightProvider, {
        children: children
      })
    });
  };
  return jsx(ChakraProvider, {
    cssVarsRoot: "#coco",
    resetCSS: true,
    theme: theme,
    children: jsx(SiteProvider, {
      children: jsx(ModalProvider, {
        children: jsx(AuthenticationProvider, {
          children: jsx(MayeLazy, {
            children: children
          })
        })
      })
    })
  });
};
var GatsbyPageWrapper = function GatsbyPageWrapper(props) {
  var dynamicRoute = useDynamicRoute({
    pageProps: props.pageProps
  });
  var handleActivationButtonClick = useCallback(function () {
    void navigate('/admin');
  }, []);
  var auth = useAuthentication();
  if (dynamicRoute.isLoading) {
    return jsx(LoadingPage, {});
  }
  return jsxs(Fragment, {
    children: [jsx(InjectPopups, {
      pageProps: props.pageProps
    }), jsx(WrapperPage, {
      dynamicRoute: dynamicRoute,
      path: props.pageProps.path,
      isAuthenticated: auth.isAuthenticated,
      handleActivationButtonClick: handleActivationButtonClick,
      children: props.children
    })]
  });
};
var DynamicAdminShell = function DynamicAdminShell(_ref4) {
  var children = _ref4.children;
  var AdminShell = React__default.lazy(function () {
    try {
      return Promise.resolve(Promise.resolve().then(function () { return AdminShell$1; }));
    } catch (e) {
      return Promise.reject(e);
    }
  });
  var MemoedAdminShell = useMemo(function () {
    return AdminShell;
  }, []);
  return jsx(React__default.Suspense, {
    fallback: jsx(LoadingPage, {}),
    children: jsx(MemoedAdminShell, {
      children: children
    })
  });
};
var WrapperPage = function WrapperPage(_ref5) {
  var dynamicRoute = _ref5.dynamicRoute,
    propsChildren = _ref5.children,
    path = _ref5.path,
    isAuthenticated = _ref5.isAuthenticated,
    handleActivationButtonClick = _ref5.handleActivationButtonClick;
  var isOnAdmin = path.includes('/admin');
  var children = jsxs(Fragment, {
    children: [jsx(IncomingBuildChecker, {}), dynamicRoute.node || propsChildren]
  });
  if (isAuthenticated) {
    return jsx(DynamicAdminShell, {
      children: children
    });
  } else {
    if (isOnAdmin) {
      return jsx(Fragment, {
        children: children
      });
    }
    return jsxs(Fragment, {
      children: [jsx(React__default.Suspense, {
        fallback: jsx(Fragment, {}),
        children: jsx(ThemeProvider, {
          children: jsx(ActivationButton, {
            onClick: handleActivationButtonClick
          })
        })
      }), children]
    });
  }
};

var FilesView = function FilesView() {
  return jsx(FilesView$1, {});
};

var PagesView = function PagesView() {
  return jsx(PageManagerProvider, {
    children: jsx(PagesView$1, {})
  });
};

var usePopupComponents = function usePopupComponents() {
  var dispatch = useAppDispatch();
  var _usePopupStaticQuery = usePopupStaticQuery(),
    jaenPopup = _usePopupStaticQuery.jaenPopup,
    allJaenPopup = _usePopupStaticQuery.allJaenPopup;
  var dynamicPopupNodes = useAppSelector(function (state) {
    return state.popup.nodes;
  });
  var _useState = useState(false),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var _useState2 = useState([]),
    popups = _useState2[0],
    setPopups = _useState2[1];
  var togglePopup = useCallback(function (popup) {
    if (popup.isActive) {
      dispatch(setInactive(popup.id));
    } else {
      dispatch(setActive(popup.id));
    }
  }, []);
  useEffect(function () {
    var loadPopups = function loadPopups() {
      try {
        setIsLoading(true);
        Object.entries(dynamicPopupNodes).forEach(function (_ref) {
          var id = _ref[0],
            node = _ref[1];
          var index = allJaenPopup.nodes.findIndex(function (n) {
            return n.id === id;
          });
          var nodeWithId = _extends({}, node, {
            id: id
          });
          if (index > -1) {
            allJaenPopup.nodes[index] = deepmerge(allJaenPopup.nodes[index], nodeWithId);
          } else {
            allJaenPopup.nodes.push(nodeWithId);
          }
        });
        return Promise.resolve(loadPopupComponents(jaenPopup, allJaenPopup)).then(function (elements) {
          setPopups(elements);
          setIsLoading(false);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void loadPopups();
  }, [dynamicPopupNodes]);
  return {
    isLoading: isLoading,
    popups: popups,
    togglePopup: togglePopup
  };
};

var PopupsView = withRedux(function () {
  var _usePopupComponents = usePopupComponents(),
    isLoading = _usePopupComponents.isLoading,
    popups = _usePopupComponents.popups,
    togglePopup = _usePopupComponents.togglePopup;
  return jsx(PopupsView$1, {
    isLoading: isLoading,
    popups: popups,
    onPopupEnableToggle: togglePopup
  });
});

var useSite = function useSite() {
  var staticData = useAdminStaticQuery();
  var site = useAppSelector(function (state) {
    return state.site;
  });
  var mergedSite = deepmerge({
    siteMetadata: staticData.jaenInternal.siteMetadata
  }, site || {}, {
    arrayMerge: deepmergeArrayIdMerge
  });
  return mergedSite;
};

var SettingsView = function SettingsView() {
  var dispatch = useAppDispatch();
  var site = useSite();
  var handleUpdate = function handleUpdate(data) {
    if (data.siteMetadata) {
      dispatch(updateSiteMetadata(data.siteMetadata));
    }
  };
  return jsx(SettingsView$1, {
    data: site,
    onUpdate: handleUpdate
  });
};

var CMSComponent = function CMSComponent(props) {
  var location = useLocation();
  var isActive = function isActive(path) {
    return location.pathname.endsWith(path);
  };
  return jsxs(Flex, {
    children: [jsx(Box, {
      zIndex: 1,
      w: "48",
      top: "0",
      left: "0",
      bg: "gray.50",
      pos: "fixed",
      h: "calc(100vh - 6.5rem)",
      mt: "6.5rem",
      p: "4",
      boxShadow: "inner",
      children: jsxs(Stack, {
        spacing: "8",
        children: [jsxs(HStack, {
          children: [jsx(Circle, {
            size: "10",
            bg: "white",
            boxShadow: "md",
            children: jsx(Icon, {
              as: GiRuleBook
            })
          }), jsxs(Text, {
            fontSize: "sm",
            fontWeight: "bold",
            children: ["Site ", jsx("br", {}), " Management"]
          })]
        }), jsx(Stack, {
          p: "2",
          children: props.routes.map(function (route) {
            return jsx(Link$1, {
              as: Link$3,
              to: route.path,
              variant: isActive(route.path) ? '' : 'black',
              fontSize: "sm",
              children: route.name
            }, route.path);
          })
        })]
      })
    }), jsx(Box, {
      flex: "1",
      ml: "48",
      children: props.children
    })]
  });
};
var CMS = function CMS() {
  var _routes$;
  var routes = [{
    name: 'Pages',
    path: 'pages',
    render: function render() {
      return jsx(PagesView, {});
    }
  }, {
    name: 'Files',
    path: 'files',
    render: function render() {
      return jsx(FilesView, {});
    }
  }, {
    name: 'Popups',
    path: 'popups',
    render: function render() {
      return jsx(PopupsView, {});
    }
  }, {
    name: 'Settings',
    path: 'settings',
    render: function render() {
      return jsx(SettingsView, {});
    }
  }];
  return jsx(Routes, {
    children: jsxs(Route, {
      element: jsx(CMSComponent, {
        routes: routes,
        children: jsx(Outlet, {})
      }),
      children: [jsx(Route, {
        path: "/",
        element: ((_routes$ = routes[0]) == null ? void 0 : _routes$.path) && jsx(Navigate, {
          to: routes[0].path,
          replace: true
        })
      }), routes.map(function (route) {
        return jsx(Route, {
          path: route.path,
          element: jsx(ViewLayout, {
            heading: route.name,
            children: route.render()
          })
        }, route.path);
      }), jsx(Route, {
        path: "*",
        element: jsx("p", {
          children: "There's nothing here: 404!"
        })
      }, "404")]
    })
  });
};

var index$1 = {
  __proto__: null,
  CMS: CMS
};

var index = {
  __proto__: null,
  views: index$1,
  AdminPage: AdminPage$1,
  CookieConsent: CookieConsent,
  LoginPage: LoginPage,
  useIncomingBuildChecker: useIncomingBuildChecker,
  GatsbyPageWrapper: GatsbyPageWrapper,
  GatsbyRootWrapper: GatsbyRootWrapper,
  useStatus: useStatus
};

var _excluded$1 = ["name", "label", "blocks"];
var SectionField = withRedux(function (_ref) {
  var name = _ref.name,
    label = _ref.label,
    unfilteredBlocks = _ref.blocks,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var _useModals = useModals(),
    confirm = _useModals.confirm,
    toast = _useModals.toast;
  var blocks = unfilteredBlocks.reduce(function (acc, block) {
    var index = acc.findIndex(function (el) {
      return el.options.name === block.options.name;
    });
    if (index === -1) {
      return [].concat(acc, [block]);
    }
    return [].concat(acc.slice(0, index), [block], acc.slice(index + 1));
  }, []);
  var _useSectionField = useSectionField(name, blocks),
    onSectionAdd = _useSectionField.onSectionAdd,
    onSectionDelete = _useSectionField.onSectionDelete,
    onSectionMove = _useSectionField.onSectionMove,
    onSectionAppend = _useSectionField.onSectionAppend,
    onSectionPrepend = _useSectionField.onSectionPrepend,
    section = _useSectionField.section,
    sectionsDict = _useSectionField.sectionsDict,
    sectionPath = _useSectionField.sectionPath;
  var _useStatus = useStatus(),
    isEditing = _useStatus.isEditing;
  var Wrapper = rest.as || Stack;
  var tooltipButtons = [jsx(Button, {
    variant: "jaenHighlightTooltipText",
    size: "xs",
    children: jsx(Text, {
      as: "span",
      noOfLines: 1,
      children: label
    })
  }, "section-field-tooltip-button-add")];
  var blocksForSelector = blocks.map(function (_ref2) {
    var options = _ref2.options;
    return {
      slug: options.name,
      label: options.label,
      Icon: options.Icon || FiBox
    };
  });
  var handleSectionAdd = function handleSectionAdd(block, type, item) {
    if (item) {
      if (type === 'prepend') {
        onSectionPrepend(block.slug, item.id, item.ptrPrev);
      } else if (type === 'append') {
        onSectionAppend(block.slug, item.id, item.ptrNext);
      } else {
        onSectionAdd(block.slug, [item.id, item.ptrNext]);
      }
    } else {
      if (type === 'prepend' && section.ptrHead) {
        onSectionPrepend(block.slug, section.ptrHead, null);
      } else if (type === 'append' && section.ptrTail) {
        onSectionAppend(block.slug, section.ptrTail, null);
      } else {
        onSectionAdd(block.slug, [null, null]);
      }
    }
    toast({
      title: 'Block added',
      description: "Block has been added to the " + label + " section",
      status: 'info'
    });
  };
  var handleSectionDelete = function handleSectionDelete(id, ptrPrev, ptrNext) {
    try {
      return Promise.resolve(confirm("Are you sure you want to remove this block from the " + label + " section?")).then(function (shouldDelete) {
        if (shouldDelete) {
          onSectionDelete(id, ptrPrev, ptrNext);
          toast({
            title: 'Block deleted',
            description: "Block has been removed from the " + label + " section",
            status: 'info',
            variant: 'subtle'
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  if (blocks.length > 0) {
    tooltipButtons = tooltipButtons.concat([jsx(HStack, {
      spacing: "0.5",
      children: jsx(SectionBlockSelectorButton, {
        onBlockAdd: handleSectionAdd,
        blocks: blocksForSelector,
        onlyAdd: section.items.length === 0
      })
    }, "section-field-tooltip-buttons")]);
  }
  console.log('section', section);
  return jsx(HighlightTooltip, _extends({
    id: name,
    isEditing: isEditing,
    actions: tooltipButtons,
    as: Wrapper,
    minH: "64",
    p: "4",
    className: rest.className,
    style: rest.style
  }, rest.props, {
    children: section.items.map(function (item, index) {
      var s = sectionsDict[item.type];
      if (s == null) {
        console.error("Section type " + item.type + " is not found in sections dictionary!");
        return null;
      }
      var SectionWrapper = rest.sectionAs || Box;
      var sectionProps = typeof rest.sectionProps === 'function' ? rest.sectionProps({
        count: index + 1,
        totalSections: section.items.length,
        section: item
      }) : rest.sectionProps;
      return jsx(HighlightTooltip, _extends({
        id: name + "-" + index,
        as: SectionWrapper,
        isEditing: isEditing,
        actions: [jsx(Button, {
          variant: "jaenHighlightTooltipText",
          children: jsx(Text, {
            as: "span",
            noOfLines: 1,
            children: s.Component.options.label
          })
        }, "section-field-tooltip-button-" + item.id), jsx(SectionBlockSelectorButton, {
          onBlockAdd: function onBlockAdd(block, type) {
            handleSectionAdd(block, type, item);
          },
          blocks: blocksForSelector,
          onlyAdd: false
        }, "section-field-tooltip-block-selector-" + item.id), jsx(TuneSelectorButton, {
          "aria-label": "Section tune selector",
          activeTunes: item.id === section.ptrHead ? [{
            name: 'move-up'
          }] : item.id === section.ptrTail ? [{
            name: 'move-down'
          }] : [],
          tunes: [{
            type: 'tune',
            name: 'move-up',
            label: 'Move up',
            Icon: FaArrowUp,
            onTune: function onTune() {
              var _section$items$find;
              var prevItem = ((_section$items$find = section.items.find(function (el) {
                return el.id === item.ptrPrev;
              })) == null ? void 0 : _section$items$find.ptrPrev) || null;
              onSectionMove(item.id, item.ptrPrev, item.ptrNext, prevItem, 'up');
            },
            isHiddenOnActive: true
          }, {
            type: 'tune',
            name: 'move-down',
            label: 'Move down',
            Icon: FaArrowDown,
            onTune: function onTune() {
              var _section$items$find2;
              var nextItem = ((_section$items$find2 = section.items.find(function (el) {
                return el.id === item.ptrNext;
              })) == null ? void 0 : _section$items$find2.ptrNext) || null;
              onSectionMove(item.id, item.ptrPrev, item.ptrNext, nextItem, 'down');
            },
            isHiddenOnActive: true
          }, {
            type: 'tune',
            name: 'delete',
            label: 'Delete',
            Icon: FaTrash,
            onTune: function onTune() {
              void handleSectionDelete(item.id, item.ptrPrev, item.ptrNext);
            }
          }]
        }, "section-field-tooltip-tune-selector-" + item.id)],
        p: "2"
      }, sectionProps, {
        children: jsx(JaenSectionBlockProvider, {
          path: sectionPath,
          id: item.id,
          position: index,
          Component: s.Component
        })
      }), item.id);
    })
  }));
});

var getActiveProps = function getActiveProps(activeTunes, tunes) {
  if (tunes === void 0) {
    tunes = [];
  }
  var activeProps = {};
  tunes.forEach(function (tune) {
    if ('type' in tune && tune.type === 'groupTune') {
      tune.tunes.forEach(function (subTune) {
        if (subTune.props) {
          var isActive = activeTunes == null ? void 0 : activeTunes.some(function (activeTune) {
            return activeTune.name === subTune.name && activeTune.groupName === tune.name;
          });
          if (isActive) {
            activeProps = _extends({}, activeProps, subTune.props);
          }
        }
      });
    } else {
      if (tune.props) {
        var isActive = activeTunes == null ? void 0 : activeTunes.some(function (activeTune) {
          return activeTune.name === tune.name;
        });
        if (isActive) {
          activeProps = _extends({}, activeProps, tune.props);
        }
      }
    }
  });
  return activeProps;
};
var getActiveTunesFromProps = function getActiveTunesFromProps(props, tunes) {
  if (tunes === void 0) {
    tunes = [];
  }
  var activeTunes = [];
  tunes.forEach(function (tune) {
    if ('type' in tune && tune.type === 'groupTune') {
      tune.tunes.forEach(function (subTune) {
        if (subTune.props) {
          var requiredProps = subTune.requiredProps || Object.keys(subTune.props);
          var isActive = requiredProps.every(function (prop) {
            var _subTune$props;
            return props[prop] === ((_subTune$props = subTune.props) == null ? void 0 : _subTune$props[prop]);
          });
          if (isActive) {
            activeTunes.push({
              name: subTune.name,
              groupName: tune.name
            });
          }
        }
      });
    } else {
      if (tune.props) {
        var requiredProps = tune.requiredProps || Object.keys(tune.props);
        var isActive = requiredProps.every(function (prop) {
          var _tune$props;
          return props[prop] === ((_tune$props = tune.props) == null ? void 0 : _tune$props[prop]);
        });
        if (isActive) {
          activeTunes.push({
            name: tune.name
          });
        }
      }
    }
  });
  return activeTunes;
};
var useTunes = function useTunes(_ref) {
  var props = _ref.props,
    activeTunes = _ref.activeTunes,
    tunes = _ref.tunes;
  var defaultActiveTunes = useMemo(function () {
    return getActiveTunesFromProps(props, tunes);
  }, [props, tunes]);
  var activeOrDefaultTunes = useMemo(function () {
    var tuneMap = new Map();
    for (var _iterator = _createForOfIteratorHelperLoose(defaultActiveTunes), _step; !(_step = _iterator()).done;) {
      var activeOrDefaultTune = _step.value;
      var key = activeOrDefaultTune.groupName;
      if (!tuneMap.has(key)) {
        tuneMap.set(key, activeOrDefaultTune);
      }
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(activeTunes || []), _step2; !(_step2 = _iterator2()).done;) {
      var activeTune = _step2.value;
      var _key = activeTune.groupName;
      tuneMap.set(_key, activeTune);
    }
    return Array.from(tuneMap.values());
  }, [defaultActiveTunes, activeTunes]);
  var activeProps = useMemo(function () {
    return getActiveProps(activeOrDefaultTunes, tunes);
  }, [activeOrDefaultTunes, tunes]);
  return {
    activeTunes: activeOrDefaultTunes,
    activeProps: activeProps,
    tunes: tunes
  };
};

var _excluded = ["jaenField", "defaultValue", "as", "asAs", "styleTunes", "isRTF"];
var cleanRichText = function cleanRichText(text, options) {
  var isRTF = options.isRTF;
  if (isRTF) {
    return DOMPurify.sanitize(text, {
      FORBID_TAGS: ['p']
    });
  }
  return DOMPurify.sanitize(text, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  });
};
var TextField = connectField(function (_ref) {
  var jaenField = _ref.jaenField,
    defaultValue = _ref.defaultValue,
    _ref$as = _ref.as,
    Wrapper = _ref$as === void 0 ? Text : _ref$as,
    asAs = _ref.asAs,
    _ref$styleTunes = _ref.styleTunes,
    fieldStyleTunes = _ref$styleTunes === void 0 ? [] : _ref$styleTunes,
    _ref$isRTF = _ref.isRTF,
    isRTF = _ref$isRTF === void 0 ? true : _ref$isRTF,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(function () {
      return cleanRichText(jaenField.staticValue || defaultValue || '', {
        isRTF: isRTF
      });
    }),
    value = _useState[0],
    setValue = _useState[1];
  useEffect(function () {
    var newValue = cleanRichText(jaenField.value || jaenField.staticValue || defaultValue || '', {
      isRTF: isRTF
    });
    setValue(newValue);
  }, [jaenField.value, isRTF]);
  var _useModals = useModals(),
    toast = _useModals.toast;
  var isWrapperHeading = Wrapper.displayName === 'Heading';
  if (isWrapperHeading && !asAs) {
    asAs = 'h2';
  }
  var handleTextSave = useDebouncedCallback(useCallback(function (data) {
    if (data === value) {
      return;
    }
    jaenField.onUpdateValue(data || undefined);
    toast({
      title: 'Text saved',
      description: 'The text has been saved',
      status: 'info'
    });
  }, [value]), 500);
  useEffect(function () {
    if (jaenField.isEditing) {
      var as = typeof Wrapper === 'string' ? Wrapper : typeof asAs === 'string' ? asAs : undefined;
      jaenField.register({
        as: as
      });
    }
  }, [jaenField.isEditing]);
  var handleContentBlur = useCallback(function (evt) {
    handleTextSave(evt.currentTarget.innerHTML);
  }, []);
  var alignmentTune = {
    type: 'groupTune',
    name: 'alignment',
    label: 'Alignment',
    tunes: [{
      name: 'left',
      Icon: FaAlignLeft,
      props: {
        textAlign: 'left'
      }
    }, {
      name: 'center',
      Icon: FaAlignCenter,
      props: {
        textAlign: 'center'
      }
    }, {
      name: 'right',
      Icon: FaAlignRight,
      props: {
        textAlign: 'right'
      }
    }, {
      name: 'justify',
      Icon: FaAlignJustify,
      props: {
        textAlign: 'justify'
      }
    }]
  };
  var styleTune = {
    type: 'groupTune',
    name: 'style',
    label: 'Style',
    tunes: [{
      name: 'bold',
      Icon: FaBold,
      onTune: function onTune() {
        document.execCommand('bold');
      }
    }, {
      name: 'italic',
      Icon: FaItalic,
      onTune: function onTune() {
        document.execCommand('italic');
      }
    }, {
      name: 'underline',
      Icon: FaUnderline,
      onTune: function onTune() {
        document.execCommand('underline');
      }
    }]
  };
  var tunes = useTunes({
    props: _extends({}, rest, {
      asAs: asAs
    }),
    activeTunes: jaenField.activeTunes,
    tunes: [alignmentTune].concat(isRTF ? [styleTune].concat(fieldStyleTunes) : [], jaenField.tunes)
  });
  return jsx(HighlightTooltip, _extends({
    id: jaenField.id,
    actions: [jsx(Button, {
      variant: "jaenHighlightTooltipText",
      children: jsx(Tooltip$1, {
        label: "ID: " + jaenField.id,
        placement: "top-start",
        children: jsx(Text, {
          children: "Text"
        })
      })
    }, "jaen-highlight-tooltip-text-" + jaenField.name)].concat(isRTF ? [jsx(TuneSelectorButton, {
      "aria-label": "Customize",
      tunes: [styleTune].concat(fieldStyleTunes),
      icon: jsx(Text, {
        as: "span",
        fontSize: "sm",
        fontFamily: "serif",
        children: "T"
      }),
      activeTunes: tunes.activeTunes,
      onTune: jaenField.tune
    }, "jaen-highlight-tooltip-tune-" + jaenField.name)] : [], [jsx(TuneSelectorButton, {
      "aria-label": "Customize",
      tunes: [alignmentTune].concat(jaenField.tunes),
      activeTunes: tunes.activeTunes,
      onTune: jaenField.tune
    }, "jaen-highlight-tooltip-tune-" + jaenField.name)]),
    isEditing: jaenField.isEditing,
    as: Wrapper,
    asAs: asAs,
    minW: "1rem",
    className: jaenField.className,
    style: _extends({}, jaenField.style, rest.style)
  }, rest, tunes.activeProps, {
    children: function children(props) {
      return jsx(Box, {
        ref: props.ref,
        tabIndex: props.tabIndex,
        as: "span",
        display: "block",
        outline: "none",
        dangerouslySetInnerHTML: {
          __html: value
        },
        contentEditable: jaenField.isEditing,
        onBlur: handleContentBlur,
        onPaste: function onPaste(evt) {
          evt.preventDefault();
          if (isRTF) {
            var text = evt.clipboardData.getData('text/html') || evt.clipboardData.getData('text');
            text = DOMPurify.sanitize(text, {
              ALLOWED_TAGS: ['br', 'span'],
              ALLOWED_ATTR: []
            });
            document.execCommand('insertHTML', false, text);
          } else {
            var _text = evt.clipboardData.getData('text');
            document.execCommand('insertText', false, _text);
          }
        }
      });
    }
  }));
}, {
  fieldType: 'IMA:TextField'
});

var Field = {
  Text: TextField,
  Section: SectionField,
  Index: IndexField,
  Choice: ChoiceField,
  Image: ImageField,
  Mdx: MdxField
};

var Editor = function Editor(_ref) {
  var _ref$blocks = _ref.blocks,
    blocks = _ref$blocks === void 0 ? [] : _ref$blocks;
  return jsx(Field.Section, {
    name: "editor",
    label: "Editor",
    blocks: [HeadingBlock, TextBlock, ImageBlock].concat(blocks)
  });
};
var TextBlock = connectBlock(function () {
  return jsx(Field.Text, {
    name: "text",
    defaultValue: "Example Text"
  });
}, {
  label: 'TextBlock',
  name: 'TextBlock'
});
var HeadingBlock = connectBlock(function () {
  return jsx(Field.Text, {
    as: Heading,
    name: "heading",
    defaultValue: "Example Heading",
    textAlign: "center",
    tunes: [{
      type: 'groupTune',
      name: 'heading',
      label: 'Heading',
      tunes: new Array(6).fill(0).map(function (_, i) {
        var n = i + 1;
        var tag = "h" + n;
        var responsiveFontSize = {
          h1: {
            base: '4xl',
            sm: '5xl',
            md: '6xl',
            lg: '6xl',
            '2xl': '6xl'
          },
          h2: {
            base: '3xl',
            sm: '4xl',
            md: '5xl',
            lg: '6xl',
            '2xl': '6xl'
          },
          h3: {
            base: '2xl',
            sm: '3xl',
            md: '4xl',
            lg: '5xl',
            '2xl': '6xl'
          },
          h4: {
            base: 'xl',
            sm: '2xl',
            md: '3xl',
            lg: '4xl',
            '2xl': '5xl'
          },
          h5: {
            base: 'lg',
            sm: 'xl',
            md: '2xl',
            lg: '3xl',
            '2xl': '4xl'
          },
          h6: {
            base: 'md',
            sm: 'lg',
            md: 'xl',
            lg: '2xl',
            '2xl': '3xl'
          }
        };
        var responsiveFontSizeValue = responsiveFontSize[tag];
        var marginTop = 2 + (7 - i) * 0.5 + "rem";
        var marginBottom = (6 - i) * 0.5 + "rem";
        return {
          type: 'tune',
          name: tag,
          label: "Heading " + i,
          Icon: function Icon() {
            return jsx(Box, {
              children: tag.toUpperCase()
            });
          },
          isDisableOnActive: tag === 'h2',
          requiredProps: ['asAs'],
          props: {
            asAs: tag,
            fontSize: responsiveFontSizeValue,
            marginTop: marginTop,
            marginBottom: marginBottom
          }
        };
      })
    }]
  });
}, {
  label: 'HeadingBlock',
  name: 'HeadingBlock'
});
var ImageBlock = connectBlock(function () {
  return jsxs(Box, {
    children: [jsx(Box, {
      h: "md",
      m: "4",
      objectFit: "contain",
      children: jsx(Field.Image, {
        name: "image",
        objectFit: "contain"
      })
    }), jsx(Field.Text, {
      name: "caption",
      textAlign: "center",
      variant: "cursive",
      fontSize: "xs"
    })]
  });
}, {
  label: 'ImageBlock',
  name: 'ImageBlock'
});

var getWidgetData = function getWidgetData(widgetName) {
  var _state$widget$nodes$f;
  var state = store.getState();
  return (_state$widget$nodes$f = state.widget.nodes.find(function (widget) {
    return widget.name === widgetName;
  })) == null ? void 0 : _state$widget$nodes$f.data;
};
var useWidgetStateFromStore = function useWidgetStateFromStore(widgetName) {
  var _React$useState = React__default.useState(getWidgetData(widgetName)),
    state = _React$useState[0],
    setState = _React$useState[1];
  React__default.useEffect(function () {
    var unsubscribe = store.subscribe(function () {
      setState(getWidgetData(widgetName));
    });
    return function () {
      unsubscribe();
    };
  }, []);
  return state;
};
function useWidget(widgetName) {
  var dynamicData = useWidgetStateFromStore(widgetName);
  var _useWidgetStaticQuery = useWidgetStaticQuery(),
    jaenInternal = _useWidgetStaticQuery.jaenInternal;
  var staticData = React__default.useMemo(function () {
    var _jaenInternal$widgets;
    var widget = jaenInternal == null ? void 0 : (_jaenInternal$widgets = jaenInternal.widgets) == null ? void 0 : _jaenInternal$widgets.find(function (node) {
      return node.name === widgetName;
    });
    if (widget) {
      return widget.data;
    }
    return undefined;
  }, [jaenInternal.widgets, widgetName]);
  var _React$useState2 = React__default.useState(staticData),
    data = _React$useState2[0],
    setData = _React$useState2[1];
  React__default.useEffect(function () {
    if (dynamicData) {
      setData(dynamicData);
    }
  }, [dynamicData]);
  var writeData$1 = function writeData$1(data) {
    return store.dispatch(writeData({
      widgetName: widgetName,
      data: data
    }));
  };
  return {
    data: data,
    writeData: writeData$1
  };
}

var withJaenMock = function withJaenMock(Component, mockProps) {
  var WithJaenMock = function WithJaenMock(props) {
    return jsxs(GatsbyRootWrapper, _extends({}, mockProps, {
      children: [jsx(AdminToolbar, {}), jsx(PageProvider, _extends({}, mockProps, {
        children: jsx(Component, _extends({}, props))
      }))]
    }));
  };
  return withSnekFinder(WithJaenMock);
};

var SearchProvider = withRedux(function (props) {
  return jsx(Fragment, {
    children: props.children
  });
});

var useSearch = function useSearch() {
  var _useState = useState(true),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var _useState2 = useState({}),
    searchIndex = _useState2[0],
    setSearchIndex = _useState2[1];
  var builtSearchIndexRef = useRef(null);
  var pages = useAppSelector(function (state) {
    return state.page.pages.nodes;
  });
  var dynamicPaths = useDynamicPaths();
  useEffect(function () {
    var loadSearchIndex = function loadSearchIndex() {
      try {
        var _temp2 = function _temp2() {
          var pageValuesWithId = Object.entries(pages).map(function (_ref) {
            var _Object$entries$find, _Object$entries$find2, _value$jaenPageMetada, _builtSearchIndexRef$, _builtSearchIndexRef$2;
            var pageId = _ref[0],
              value = _ref[1];
            var dynamicPagePath = (_Object$entries$find = Object.entries(dynamicPaths).find(function (_ref2) {
              var _ = _ref2[0],
                node = _ref2[1];
              return node.pageId === pageId;
            })) == null ? void 0 : _Object$entries$find[0];
            var builtPagePath = (_Object$entries$find2 = Object.entries(builtSearchIndexRef.current || {}).find(function (_ref3) {
              var _ = _ref3[0],
                node = _ref3[1];
              return node.id === pageId;
            })) == null ? void 0 : _Object$entries$find2[0];
            var title = (value == null ? void 0 : (_value$jaenPageMetada = value.jaenPageMetadata) == null ? void 0 : _value$jaenPageMetada.title) || (builtPagePath ? (_builtSearchIndexRef$ = builtSearchIndexRef.current) == null ? void 0 : (_builtSearchIndexRef$2 = _builtSearchIndexRef$[builtPagePath]) == null ? void 0 : _builtSearchIndexRef$2.title : undefined);
            return _extends({}, value, {
              jaenPageMetadata: _extends({}, value.jaenPageMetadata, {
                title: title
              }),
              id: pageId,
              path: dynamicPagePath || builtPagePath,
              type: value == null ? void 0 : value.template
            });
          });
          return Promise.resolve(buildSearchIndex(pageValuesWithId)).then(function (pageSearchIndex) {
            var merged = mergeSearchIndex(builtSearchIndexRef.current || {}, pageSearchIndex);
            setSearchIndex(merged);
            setIsLoading(false);
          });
        };
        var _temp = function () {
          if (builtSearchIndexRef.current) {
            setSearchIndex(builtSearchIndexRef.current);
          } else {
            return Promise.resolve(getBuiltSearchIndex()).then(function (builtSearchIndex) {
              if (builtSearchIndex) {
                builtSearchIndexRef.current = builtSearchIndex;
              }
            });
          }
        }();
        return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
      } catch (e) {
        return Promise.reject(e);
      }
    };
    void loadSearchIndex();
  }, [pages, dynamicPaths]);
  return {
    searchIndex: searchIndex,
    isLoading: isLoading
  };
};

var getCookieConsentApi = function getCookieConsentApi() {
  return window.CookieConsentApi;
};

export { ErrorFallback as E, Field as F, JaenLogo as J, PreviewComponent as P, SearchProvider as S, ThemeProvider as T, _extends as _, connectField as a, connectPage as b, connectBlock as c, connectPopup as d, connectTemplate as e, connectView as f, getCookieConsentApi as g, Editor as h, index as i, usePageManager as j, useAuthentication as k, usePageContext as l, PageManagerProvider as m, useSectionBlockContext as n, generatePageOriginPath as o, useJaenPageTree as p, useStatus as q, useWidget as r, snekResourceId as s, useJaenPageIndex as t, useMdx as u, useField as v, withJaenMock as w, useSectionField as x, useSearch as y };
//# sourceMappingURL=index-bcfff0f0.js.map
